/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type ModelProgramMembershipConnection = {
  __typename: "ModelProgramMembershipConnection",
  items:  Array<ProgramMembership | null >,
  nextToken?: string | null,
};

export type ProgramMembership = {
  __typename: "ProgramMembership",
  id: string,
  programRole: ProgramRole,
  traineeType?: TraineeType | null,
  programMemberId: string,
  programId: string,
  programMember?: User | null,
  program?: Program | null,
  startDate?: string | null,
  endDate?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum ProgramRole {
  Trainee = "Trainee",
  Attending = "Attending",
  ProgramAdmin = "ProgramAdmin",
  Admin = "Admin",
  // SE-1765: two new invitation-time program roles that represent
  // ELIGIBILITY to hold a scoped grant (Coach → person mentees;
  // RotationDirector → person_group rotations). They confer no access
  // until the scoped grant is written on the Coaching / Rotations
  // admin page. Available only in networks whose `features` JSON
  // includes the corresponding flag — see `network-features` +
  // `networkFeaturesSlice`.
  Coach = "Coach",
  RotationDirector = "RotationDirector",
}


export enum TraineeType {
  Categorical = "Categorical",
  DesignatedPreliminary = "DesignatedPreliminary",
  NonDesignatedPreliminary = "NonDesignatedPreliminary",
  Fellow = "Fellow",
  MedicalStudent = "MedicalStudent",
}


export type User = {
  __typename: "User",
  id: string,
  email: string,
  emailLower?: string | null,
  institutionId?: string | null,
  institution?: Institution | null,
  cognitoUsername?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  suffix?: string | null,
  npi?: number | null,
  simplLearnId?: string | null,
  pgy?: number | null,
  settings?: UserSettings | null,
  lastLogin?: string | null,
  eulaAcceptedDate?: string | null,
  programMemberships?: ModelProgramMembershipConnection | null,
  simpl1Id?: number | null,
  deviceToken?: string | null,
  devicePlatform?: DevicePlatform | null,
  inviteId?: string | null,
  invite?: UserInvitation | null,
  jobTitle?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
  invitationStatus?: string | null,
  fullName?: string | null,
  initials?: string | null,
};

export type Institution = {
  __typename: "Institution",
  id: string,
  name?: string | null,
  description?: string | null,
  programs?: ModelProgramConnection | null,
  users?: ModelUserConnection | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelProgramConnection = {
  __typename: "ModelProgramConnection",
  items:  Array<Program | null >,
  nextToken?: string | null,
};

export type Program = {
  __typename: "Program",
  id: string,
  name: string,
  description?: string | null,
  institutionId: string,
  institution?: Institution | null,
  programMemberships?: ModelProgramMembershipConnection | null,
  assessmentEvents?: ModelAssessmentEventConnection | null,
  sponsors?: ModelProgramSponsorsConnection | null,
  networks?: ModelNetworkProgramConnection | null,
  simpl1Id?: number | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelAssessmentEventConnection = {
  __typename: "ModelAssessmentEventConnection",
  items:  Array<AssessmentEvent | null >,
  nextToken?: string | null,
};

export type AssessmentEvent = {
  __typename: "AssessmentEvent",
  id: string,
  subjectId?: string | null,
  subject?: ActivityParticipant | null,
  subjectUserId?: string | null,
  raterId?: string | null,
  rater?: ActivityParticipant | null,
  raterUserId?: string | null,
  activityId?: string | null,
  activity?: Activity | null,
  activityEventId?: string | null,
  activityEvent?: ActivityEvent | null,
  programId?: string | null,
  program?: Program | null,
  assessmentId?: string | null,
  assessment?: Assessment | null,
  answers?: ModelAnswerEventConnection | null,
  expirationDate?: string | null,
  completionDate?: string | null,
  declined?: ReasonForDecline | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ActivityParticipant = {
  __typename: "ActivityParticipant",
  id: string,
  userId?: string | null,
  user?: User | null,
  activityEventId: string,
  activityEvent?: ActivityEvent | null,
  programId?: string | null,
  currentPGY?: number | null,
  currentRole?: ProgramRole | null,
  currentTraineeType?: TraineeType | null,
  currentJobTitle?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ActivityEvent = {
  __typename: "ActivityEvent",
  id: string,
  creatorId?: string | null,
  creator?: User | null,
  participants?: ModelActivityParticipantConnection | null,
  activities?: ModelActivityEventActivitiesConnection | null,
  assessmentEvents?: ModelAssessmentEventConnection | null,
  programId?: string | null,
  program?: Program | null,
  activityEventDate?: string | null,
  notes?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelActivityParticipantConnection = {
  __typename: "ModelActivityParticipantConnection",
  items:  Array<ActivityParticipant | null >,
  nextToken?: string | null,
};

export type ModelActivityEventActivitiesConnection = {
  __typename: "ModelActivityEventActivitiesConnection",
  items:  Array<ActivityEventActivities | null >,
  nextToken?: string | null,
};

export type ActivityEventActivities = {
  __typename: "ActivityEventActivities",
  id: string,
  activityID: string,
  activityEventID: string,
  activity: Activity,
  activityEvent: ActivityEvent,
  createdAt: string,
  updatedAt: string,
};

export type Activity = {
  __typename: "Activity",
  id: string,
  title?: string | null,
  description?: string | null,
  subActivities?: ModelActivityConnection | null,
  assessmentId?: string | null,
  assessment?: Assessment | null,
  assessments?: ModelAssessmentActivityConnection | null,
  activityEvents?: ModelActivityEventActivitiesConnection | null,
  assessmentEvents?: ModelAssessmentEventConnection | null,
  sponsorId?: string | null,
  sponsor?: Sponsor | null,
  authorId?: string | null,
  author?: User | null,
  version?: string | null,
  networks?: ModelNetworkActivityConnection | null,
  acgmeProcedures?: ModelAcgmeProcedureActivityConnection | null,
  simpl1Id?: number | null,
  categories?: Array< string > | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
  activitySubActivitiesId?: string | null,
};

export type ModelActivityConnection = {
  __typename: "ModelActivityConnection",
  items:  Array<Activity | null >,
  nextToken?: string | null,
};

export type Assessment = {
  __typename: "Assessment",
  id: string,
  title?: string | null,
  description?: string | null,
  instrumentId?: string | null,
  instrument?: Instrument | null,
  activities?: ModelActivityConnection | null,
  multiActivities?: ModelAssessmentActivityConnection | null,
  expirationDurationHours?: number | null,
  sponsorId?: string | null,
  sponsor?: Sponsor | null,
  requireTraineeSelfAssessment?: boolean | null,
  authorId?: string | null,
  author?: User | null,
  published?: boolean | null,
  archived?: boolean | null,
  version?: string | null,
  creationDurationHours?: number | null,
  showFeedbackQuestionsToTrainees?: boolean | null,
  sendEmailForSelfAssessment?: boolean | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type Instrument = {
  __typename: "Instrument",
  id: string,
  title?: string | null,
  description?: string | null,
  questions?: ModelQuestionConnection | null,
  authorId?: string | null,
  author?: User | null,
  version?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelQuestionConnection = {
  __typename: "ModelQuestionConnection",
  items:  Array<Question | null >,
  nextToken?: string | null,
};

export type Question = {
  __typename: "Question",
  id: string,
  defaultPrompt?: string | null,
  required?: boolean | null,
  selfAssessmentPrompt?: string | null,
  sortingIndex?: number | null,
  title?: string | null,
  helpText?: string | null,
  inputType?: InputType | null,
  instrumentId: string,
  answerOptions?: ModelAnswerOptionConnection | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum InputType {
  Radio = "Radio",
  Feedback = "Feedback",
  Checkbox = "Checkbox",
  Paragraph = "Paragraph",
  ShortAnswer = "ShortAnswer",
  Dropdown = "Dropdown",
  LinearScale = "LinearScale",
  DateTime = "DateTime",
  Attachment = "Attachment",
  NoInput = "NoInput",
}


export type ModelAnswerOptionConnection = {
  __typename: "ModelAnswerOptionConnection",
  items:  Array<AnswerOption | null >,
  nextToken?: string | null,
};

export type AnswerOption = {
  __typename: "AnswerOption",
  id: string,
  anchor?: string | null,
  sortingIndex?: number | null,
  helpText?: string | null,
  value?: string | null,
  questionId: string,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelAssessmentActivityConnection = {
  __typename: "ModelAssessmentActivityConnection",
  items:  Array<AssessmentActivity | null >,
  nextToken?: string | null,
};

export type AssessmentActivity = {
  __typename: "AssessmentActivity",
  id: string,
  assessmentID: string,
  activityID: string,
  assessment: Assessment,
  activity: Activity,
  createdAt: string,
  updatedAt: string,
};

export type Sponsor = {
  __typename: "Sponsor",
  id: string,
  name?: string | null,
  description?: string | null,
  programs?: ModelProgramSponsorsConnection | null,
  networks?: ModelNetworkConnection | null,
  branding?: SponsorBranding | null,
  activityLabel?: string | null,
  autoAssignActivities?: Array< string > | null,
  dashboardURL?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelProgramSponsorsConnection = {
  __typename: "ModelProgramSponsorsConnection",
  items:  Array<ProgramSponsors | null >,
  nextToken?: string | null,
};

export type ProgramSponsors = {
  __typename: "ProgramSponsors",
  id: string,
  programID: string,
  sponsorID: string,
  program: Program,
  sponsor: Sponsor,
  createdAt: string,
  updatedAt: string,
};

export type ModelNetworkConnection = {
  __typename: "ModelNetworkConnection",
  items:  Array<Network | null >,
  nextToken?: string | null,
};

export type Network = {
  __typename: "Network",
  id: string,
  name: string,
  sponsorId: string,
  sponsor?: Sponsor | null,
  programs?: ModelNetworkProgramConnection | null,
  activities?: ModelNetworkActivityConnection | null,
  acgmeEnabled?: boolean | null,
  allAttendingHistoryDisabled?: boolean | null,
  simpl1Id?: number | null,
  categoriesExcludedFromRequestFlow?: Array< string | null > | null,
  dashboardURL?: string | null,
  showDashboardLink?: boolean | null,
  disableClassicReports?: boolean | null,
  traineeCanRateTrainee?: boolean | null,
  feedbackMinWords?: number | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelNetworkProgramConnection = {
  __typename: "ModelNetworkProgramConnection",
  items:  Array<NetworkProgram | null >,
  nextToken?: string | null,
};

export type NetworkProgram = {
  __typename: "NetworkProgram",
  id: string,
  programID: string,
  networkID: string,
  program: Program,
  network: Network,
  createdAt: string,
  updatedAt: string,
};

export type ModelNetworkActivityConnection = {
  __typename: "ModelNetworkActivityConnection",
  items:  Array<NetworkActivity | null >,
  nextToken?: string | null,
};

export type NetworkActivity = {
  __typename: "NetworkActivity",
  id: string,
  networkID: string,
  activityID: string,
  network: Network,
  activity: Activity,
  createdAt: string,
  updatedAt: string,
};

export type SponsorBranding = {
  __typename: "SponsorBranding",
  colors?: SponsorColors | null,
  logos?: SponsorLogos | null,
};

export type SponsorColors = {
  __typename: "SponsorColors",
  primary?: string | null,
  secondary?: string | null,
  light?: string | null,
};

export type SponsorLogos = {
  __typename: "SponsorLogos",
  fullMono?: string | null,
  fullColor?: string | null,
  squareMono?: string | null,
  squareColor?: string | null,
  email?: string | null,
};

export type ModelAcgmeProcedureActivityConnection = {
  __typename: "ModelAcgmeProcedureActivityConnection",
  items:  Array<AcgmeProcedureActivity | null >,
  nextToken?: string | null,
};

export type AcgmeProcedureActivity = {
  __typename: "AcgmeProcedureActivity",
  id: string,
  activityID: string,
  acgmeProcedureID: string,
  activity: Activity,
  acgmeProcedure: AcgmeProcedure,
  createdAt: string,
  updatedAt: string,
};

export type AcgmeProcedure = {
  __typename: "AcgmeProcedure",
  id: string,
  name: string,
  acgmeCode: string,
  activities?: ModelAcgmeProcedureActivityConnection | null,
  simpl1Id: number,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelAnswerEventConnection = {
  __typename: "ModelAnswerEventConnection",
  items:  Array<AnswerEvent | null >,
  nextToken?: string | null,
};

export type AnswerEvent = {
  __typename: "AnswerEvent",
  id: string,
  questionId?: string | null,
  question?: Question | null,
  valueType?: ValueType | null,
  value?: string | null,
  assessmentEventId?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum ValueType {
  String = "String",
  Int = "Int",
  Float = "Float",
  DateTime = "DateTime",
  ResourceURL = "ResourceURL",
}


export enum ReasonForDecline {
  IncorrectDetails = "IncorrectDetails",
  InsufficientInteraction = "InsufficientInteraction",
  Other = "Other",
}


export type ModelUserConnection = {
  __typename: "ModelUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
};

export type UserSettings = {
  __typename: "UserSettings",
  sendEmail?: boolean | null,
  sendPushNotifications?: boolean | null,
};

export enum DevicePlatform {
  iOS = "iOS",
  Android = "Android",
}


export type UserInvitation = {
  __typename: "UserInvitation",
  id: string,
  inviteeId?: string | null,
  invitee: User,
  institutionId: string,
  invitationStatus: InvitationStatus,
  email?: string | null,
  emailLower?: string | null,
  adminId?: string | null,
  programId?: string | null,
  program?: Program | null,
  role?: ProgramRole | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum InvitationStatus {
  Started = "Started",
  Notified = "Notified",
  Resolved = "Resolved",
  SendError = "SendError",
}


export type ModelUserInvitationConnection = {
  __typename: "ModelUserInvitationConnection",
  items:  Array<UserInvitation | null >,
  nextToken?: string | null,
};

export type PaginatableAssessmentHistoryArgs = {
  programMemberships?: Array< string | null > | null,
  includeIncomplete?: boolean | null,
  membersAssessmentsOnly?: boolean | null,
  filterByUserId?: string | null,
  filterByActivityId?: string | null,
  includeSelfAssessments?: boolean | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaginatableAssessmentHistoryResult = {
  __typename: "PaginatableAssessmentHistoryResult",
  nextToken?: string | null,
  total?: number | null,
  items?:  Array<AssessmentEvent | null > | null,
};

export type PaginatableActivitiesByUsersArgs = {
  userIds: Array< string >,
  limit?: number | null,
  page?: number | null,
  roleToUserMap?: RoleToUserMapInput | null,
};

export type RoleToUserMapInput = {
  subject?: string | null,
};

export type PaginatableActivitiesByUsersResult = {
  __typename: "PaginatableActivitiesByUsersResult",
  activities?:  Array<ActivitiesByUsersActivity | null > | null,
  total?: number | null,
  nextPage?: number | null,
  error?: string | null,
};

export type ActivitiesByUsersActivity = {
  __typename: "ActivitiesByUsersActivity",
  id: string,
  title?: string | null,
  description?: string | null,
  assessmentId?: string | null,
  sponsor?: SponsorMinimal | null,
  categories?: Array< string > | null,
  programIds?: Array< string | null > | null,
};

export type SponsorMinimal = {
  __typename: "SponsorMinimal",
  id: string,
  name?: string | null,
  description?: string | null,
  activityLabel?: string | null,
  branding?: SponsorBranding | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  deletedAt?: string | null,
};

export type PaginatableSiblingUsersArgs = {
  userId?: string | null,
  assessmentRole?: AssessmentRole | null,
  limit?: number | null,
  nextToken?: string | null,
};

export enum AssessmentRole {
  subject = "subject",
  rater = "rater",
}


export type PaginatableSiblingUsersResult = {
  __typename: "PaginatableSiblingUsersResult",
  nextToken?: string | null,
  total?: number | null,
  items?:  Array<User | null > | null,
};

export type CreateActivityEventInput = {
  id?: string | null,
  creatorId?: string | null,
  programId?: string | null,
  activityEventDate?: string | null,
  notes?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type UpdateProgramMembershipsInput = {
  userId: string,
  programMemberships: Array< ProgramMembershipInput >,
};

export type ProgramMembershipInput = {
  id?: string | null,
  programRole: ProgramRole,
  traineeType?: TraineeType | null,
  programId: string,
  startDate?: string | null,
  endDate?: string | null,
};

export type GenericMutationResult = {
  __typename: "GenericMutationResult",
  success: boolean,
  message?: string | null,
  error?: string | null,
};

export type SubmitAssessmentRequestInput = {
  currentUserId: string,
  selectedParticipantIds: Array< string | null >,
  selectedProgramId: string,
  selectedActivityEventDate: string,
  selectedActivityIds: Array< string | null >,
  notes?: string | null,
  subjectUserId?: string | null,
  raterUserId?: string | null,
};

export type UpdatePgyInput = {
  id: string,
  pgy?: number | null,
};

export type CompleteAssesessmentRequestInput = {
  assessmentEventId: string,
  answers: Array< SubmittedAnswer >,
  completionDate?: string | null,
};

export type SubmittedAnswer = {
  questionId: string,
  value: string,
  customInput?: string | null,
};

export type CompletedAssessmentEvent = {
  __typename: "CompletedAssessmentEvent",
  assessmentEvent?: AssessmentEvent | null,
  acgmeEnabled?: boolean | null,
};

export type DeclineAssessmentRequestInput = {
  assessmentEventId: string,
  reason: ReasonForDecline,
};

export type CreateInstitutionInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelInstitutionConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelInstitutionConditionInput | null > | null,
  or?: Array< ModelInstitutionConditionInput | null > | null,
  not?: ModelInstitutionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type UpdateInstitutionInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteInstitutionInput = {
  id: string,
};

export type CreateProgramInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  institutionId: string,
  simpl1Id?: number | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelProgramConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  institutionId?: ModelIDInput | null,
  simpl1Id?: ModelIntInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelProgramConditionInput | null > | null,
  or?: Array< ModelProgramConditionInput | null > | null,
  not?: ModelProgramConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UpdateProgramInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  institutionId?: string | null,
  simpl1Id?: number | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteProgramInput = {
  id: string,
};

export type CreateNetworkInput = {
  id?: string | null,
  name: string,
  sponsorId: string,
  acgmeEnabled?: boolean | null,
  allAttendingHistoryDisabled?: boolean | null,
  simpl1Id?: number | null,
  categoriesExcludedFromRequestFlow?: Array< string | null > | null,
  dashboardURL?: string | null,
  showDashboardLink?: boolean | null,
  disableClassicReports?: boolean | null,
  traineeCanRateTrainee?: boolean | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelNetworkConditionInput = {
  name?: ModelStringInput | null,
  sponsorId?: ModelIDInput | null,
  acgmeEnabled?: ModelBooleanInput | null,
  allAttendingHistoryDisabled?: ModelBooleanInput | null,
  simpl1Id?: ModelIntInput | null,
  categoriesExcludedFromRequestFlow?: ModelStringInput | null,
  dashboardURL?: ModelStringInput | null,
  showDashboardLink?: ModelBooleanInput | null,
  disableClassicReports?: ModelBooleanInput | null,
  traineeCanRateTrainee?: ModelBooleanInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelNetworkConditionInput | null > | null,
  or?: Array< ModelNetworkConditionInput | null > | null,
  not?: ModelNetworkConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type UpdateNetworkInput = {
  id: string,
  name?: string | null,
  sponsorId?: string | null,
  acgmeEnabled?: boolean | null,
  allAttendingHistoryDisabled?: boolean | null,
  simpl1Id?: number | null,
  categoriesExcludedFromRequestFlow?: Array< string | null > | null,
  dashboardURL?: string | null,
  showDashboardLink?: boolean | null,
  disableClassicReports?: boolean | null,
  traineeCanRateTrainee?: boolean | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteNetworkInput = {
  id: string,
};

export type CreateUserInput = {
  id?: string | null,
  email: string,
  emailLower?: string | null,
  institutionId?: string | null,
  cognitoUsername?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  suffix?: string | null,
  npi?: number | null,
  simplLearnId?: string | null,
  pgy?: number | null,
  settings?: UserSettingsInput | null,
  lastLogin?: string | null,
  eulaAcceptedDate?: string | null,
  simpl1Id?: number | null,
  deviceToken?: string | null,
  devicePlatform?: DevicePlatform | null,
  inviteId?: string | null,
  jobTitle?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type UserSettingsInput = {
  sendEmail?: boolean | null,
  sendPushNotifications?: boolean | null,
};

export type ModelUserConditionInput = {
  email?: ModelStringInput | null,
  emailLower?: ModelStringInput | null,
  institutionId?: ModelIDInput | null,
  cognitoUsername?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  suffix?: ModelStringInput | null,
  npi?: ModelIntInput | null,
  simplLearnId?: ModelStringInput | null,
  pgy?: ModelIntInput | null,
  lastLogin?: ModelStringInput | null,
  eulaAcceptedDate?: ModelStringInput | null,
  simpl1Id?: ModelIntInput | null,
  deviceToken?: ModelStringInput | null,
  devicePlatform?: ModelDevicePlatformInput | null,
  inviteId?: ModelIDInput | null,
  jobTitle?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelUserConditionInput | null > | null,
  or?: Array< ModelUserConditionInput | null > | null,
  not?: ModelUserConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelDevicePlatformInput = {
  eq?: DevicePlatform | null,
  ne?: DevicePlatform | null,
};

export type UpdateUserInput = {
  id: string,
  email?: string | null,
  emailLower?: string | null,
  institutionId?: string | null,
  cognitoUsername?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  suffix?: string | null,
  npi?: number | null,
  simplLearnId?: string | null,
  pgy?: number | null,
  settings?: UserSettingsInput | null,
  lastLogin?: string | null,
  eulaAcceptedDate?: string | null,
  simpl1Id?: number | null,
  deviceToken?: string | null,
  devicePlatform?: DevicePlatform | null,
  inviteId?: string | null,
  jobTitle?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteUserInput = {
  id: string,
};

export type CreateUserInvitationInput = {
  id?: string | null,
  inviteeId?: string | null,
  institutionId: string,
  invitationStatus: InvitationStatus,
  email?: string | null,
  emailLower?: string | null,
  adminId?: string | null,
  programId?: string | null,
  role?: ProgramRole | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelUserInvitationConditionInput = {
  inviteeId?: ModelIDInput | null,
  institutionId?: ModelIDInput | null,
  invitationStatus?: ModelInvitationStatusInput | null,
  email?: ModelStringInput | null,
  emailLower?: ModelStringInput | null,
  adminId?: ModelIDInput | null,
  programId?: ModelIDInput | null,
  role?: ModelProgramRoleInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelUserInvitationConditionInput | null > | null,
  or?: Array< ModelUserInvitationConditionInput | null > | null,
  not?: ModelUserInvitationConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelInvitationStatusInput = {
  eq?: InvitationStatus | null,
  ne?: InvitationStatus | null,
};

export type ModelProgramRoleInput = {
  eq?: ProgramRole | null,
  ne?: ProgramRole | null,
};

export type UpdateUserInvitationInput = {
  id: string,
  inviteeId?: string | null,
  institutionId?: string | null,
  invitationStatus?: InvitationStatus | null,
  email?: string | null,
  emailLower?: string | null,
  adminId?: string | null,
  programId?: string | null,
  role?: ProgramRole | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteUserInvitationInput = {
  id: string,
};

export type CreateProgramMembershipInput = {
  id?: string | null,
  programRole: ProgramRole,
  traineeType?: TraineeType | null,
  programMemberId: string,
  programId: string,
  startDate?: string | null,
  endDate?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelProgramMembershipConditionInput = {
  programRole?: ModelProgramRoleInput | null,
  traineeType?: ModelTraineeTypeInput | null,
  programMemberId?: ModelIDInput | null,
  programId?: ModelIDInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelProgramMembershipConditionInput | null > | null,
  or?: Array< ModelProgramMembershipConditionInput | null > | null,
  not?: ModelProgramMembershipConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelTraineeTypeInput = {
  eq?: TraineeType | null,
  ne?: TraineeType | null,
};

export type UpdateProgramMembershipInput = {
  id: string,
  programRole?: ProgramRole | null,
  traineeType?: TraineeType | null,
  programMemberId?: string | null,
  programId?: string | null,
  startDate?: string | null,
  endDate?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteProgramMembershipInput = {
  id: string,
};

export type CreateEULATextInput = {
  id?: string | null,
  formattedText: string,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelEULATextConditionInput = {
  formattedText?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelEULATextConditionInput | null > | null,
  or?: Array< ModelEULATextConditionInput | null > | null,
  not?: ModelEULATextConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type EULAText = {
  __typename: "EULAText",
  id: string,
  formattedText: string,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateEULATextInput = {
  id: string,
  formattedText?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteEULATextInput = {
  id: string,
};

export type CreateMilestoneInput = {
  id?: string | null,
  shortName: string,
  name: string,
  description?: string | null,
  scale: number,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelMilestoneConditionInput = {
  shortName?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  scale?: ModelIntInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelMilestoneConditionInput | null > | null,
  or?: Array< ModelMilestoneConditionInput | null > | null,
  not?: ModelMilestoneConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Milestone = {
  __typename: "Milestone",
  id: string,
  shortName: string,
  name: string,
  description?: string | null,
  scale: number,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMilestoneInput = {
  id: string,
  shortName?: string | null,
  name?: string | null,
  description?: string | null,
  scale?: number | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteMilestoneInput = {
  id: string,
};

export type CreateMilestoneNetworkRatingInput = {
  id?: string | null,
  activityId: string,
  networkId: string,
  milestoneId: string,
  answerOptionId: string,
  milestoneRating: number,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelMilestoneNetworkRatingConditionInput = {
  activityId?: ModelIDInput | null,
  networkId?: ModelIDInput | null,
  milestoneId?: ModelIDInput | null,
  answerOptionId?: ModelIDInput | null,
  milestoneRating?: ModelFloatInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelMilestoneNetworkRatingConditionInput | null > | null,
  or?: Array< ModelMilestoneNetworkRatingConditionInput | null > | null,
  not?: ModelMilestoneNetworkRatingConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type MilestoneNetworkRating = {
  __typename: "MilestoneNetworkRating",
  id: string,
  activityId: string,
  activity?: Activity | null,
  networkId: string,
  network?: Network | null,
  milestoneId: string,
  milestone?: Milestone | null,
  answerOptionId: string,
  answerOption?: AnswerOption | null,
  milestoneRating: number,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateMilestoneNetworkRatingInput = {
  id: string,
  activityId?: string | null,
  networkId?: string | null,
  milestoneId?: string | null,
  answerOptionId?: string | null,
  milestoneRating?: number | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteMilestoneNetworkRatingInput = {
  id: string,
};

export type CreateSponsorInput = {
  id?: string | null,
  name?: string | null,
  description?: string | null,
  branding?: SponsorBrandingInput | null,
  activityLabel?: string | null,
  autoAssignActivities?: Array< string > | null,
  dashboardURL?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type SponsorBrandingInput = {
  colors?: SponsorColorsInput | null,
  logos?: SponsorLogosInput | null,
};

export type SponsorColorsInput = {
  primary?: string | null,
  secondary?: string | null,
  light?: string | null,
};

export type SponsorLogosInput = {
  fullMono?: string | null,
  fullColor?: string | null,
  squareMono?: string | null,
  squareColor?: string | null,
  email?: string | null,
};

export type ModelSponsorConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  activityLabel?: ModelStringInput | null,
  autoAssignActivities?: ModelIDInput | null,
  dashboardURL?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelSponsorConditionInput | null > | null,
  or?: Array< ModelSponsorConditionInput | null > | null,
  not?: ModelSponsorConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateSponsorInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  branding?: SponsorBrandingInput | null,
  activityLabel?: string | null,
  autoAssignActivities?: Array< string > | null,
  dashboardURL?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteSponsorInput = {
  id: string,
};

export type CreateAssessmentInput = {
  id?: string | null,
  title?: string | null,
  description?: string | null,
  instrumentId?: string | null,
  expirationDurationHours?: number | null,
  sponsorId?: string | null,
  requireTraineeSelfAssessment?: boolean | null,
  authorId?: string | null,
  published?: boolean | null,
  archived?: boolean | null,
  version?: string | null,
  creationDurationHours?: number | null,
  showFeedbackQuestionsToTrainees?: boolean | null,
  sendEmailForSelfAssessment?: boolean | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelAssessmentConditionInput = {
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  instrumentId?: ModelIDInput | null,
  expirationDurationHours?: ModelIntInput | null,
  sponsorId?: ModelIDInput | null,
  requireTraineeSelfAssessment?: ModelBooleanInput | null,
  authorId?: ModelIDInput | null,
  published?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  version?: ModelStringInput | null,
  creationDurationHours?: ModelIntInput | null,
  showFeedbackQuestionsToTrainees?: ModelBooleanInput | null,
  sendEmailForSelfAssessment?: ModelBooleanInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelAssessmentConditionInput | null > | null,
  or?: Array< ModelAssessmentConditionInput | null > | null,
  not?: ModelAssessmentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateAssessmentInput = {
  id: string,
  title?: string | null,
  description?: string | null,
  instrumentId?: string | null,
  expirationDurationHours?: number | null,
  sponsorId?: string | null,
  requireTraineeSelfAssessment?: boolean | null,
  authorId?: string | null,
  published?: boolean | null,
  archived?: boolean | null,
  version?: string | null,
  creationDurationHours?: number | null,
  showFeedbackQuestionsToTrainees?: boolean | null,
  sendEmailForSelfAssessment?: boolean | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteAssessmentInput = {
  id: string,
};

export type CreateInstrumentInput = {
  id?: string | null,
  title?: string | null,
  description?: string | null,
  authorId?: string | null,
  version?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelInstrumentConditionInput = {
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  authorId?: ModelIDInput | null,
  version?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelInstrumentConditionInput | null > | null,
  or?: Array< ModelInstrumentConditionInput | null > | null,
  not?: ModelInstrumentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateInstrumentInput = {
  id: string,
  title?: string | null,
  description?: string | null,
  authorId?: string | null,
  version?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteInstrumentInput = {
  id: string,
};

export type CreateActivityInput = {
  id?: string | null,
  title?: string | null,
  description?: string | null,
  assessmentId?: string | null,
  sponsorId?: string | null,
  authorId?: string | null,
  version?: string | null,
  simpl1Id?: number | null,
  categories?: Array< string > | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  activitySubActivitiesId?: string | null,
};

export type ModelActivityConditionInput = {
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  assessmentId?: ModelIDInput | null,
  sponsorId?: ModelIDInput | null,
  authorId?: ModelIDInput | null,
  version?: ModelStringInput | null,
  simpl1Id?: ModelIntInput | null,
  categories?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelActivityConditionInput | null > | null,
  or?: Array< ModelActivityConditionInput | null > | null,
  not?: ModelActivityConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  activitySubActivitiesId?: ModelIDInput | null,
};

export type UpdateActivityInput = {
  id: string,
  title?: string | null,
  description?: string | null,
  assessmentId?: string | null,
  sponsorId?: string | null,
  authorId?: string | null,
  version?: string | null,
  simpl1Id?: number | null,
  categories?: Array< string > | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
  activitySubActivitiesId?: string | null,
};

export type DeleteActivityInput = {
  id: string,
};

export type CreateQuestionInput = {
  id?: string | null,
  defaultPrompt?: string | null,
  required?: boolean | null,
  selfAssessmentPrompt?: string | null,
  sortingIndex?: number | null,
  title?: string | null,
  helpText?: string | null,
  inputType?: InputType | null,
  instrumentId: string,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelQuestionConditionInput = {
  defaultPrompt?: ModelStringInput | null,
  required?: ModelBooleanInput | null,
  selfAssessmentPrompt?: ModelStringInput | null,
  sortingIndex?: ModelIntInput | null,
  title?: ModelStringInput | null,
  helpText?: ModelStringInput | null,
  inputType?: ModelInputTypeInput | null,
  instrumentId?: ModelIDInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelQuestionConditionInput | null > | null,
  or?: Array< ModelQuestionConditionInput | null > | null,
  not?: ModelQuestionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelInputTypeInput = {
  eq?: InputType | null,
  ne?: InputType | null,
};

export type UpdateQuestionInput = {
  id: string,
  defaultPrompt?: string | null,
  required?: boolean | null,
  selfAssessmentPrompt?: string | null,
  sortingIndex?: number | null,
  title?: string | null,
  helpText?: string | null,
  inputType?: InputType | null,
  instrumentId?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteQuestionInput = {
  id: string,
};

export type CreateAnswerOptionInput = {
  id?: string | null,
  anchor?: string | null,
  sortingIndex?: number | null,
  helpText?: string | null,
  value?: string | null,
  questionId: string,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelAnswerOptionConditionInput = {
  anchor?: ModelStringInput | null,
  sortingIndex?: ModelIntInput | null,
  helpText?: ModelStringInput | null,
  value?: ModelStringInput | null,
  questionId?: ModelIDInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelAnswerOptionConditionInput | null > | null,
  or?: Array< ModelAnswerOptionConditionInput | null > | null,
  not?: ModelAnswerOptionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateAnswerOptionInput = {
  id: string,
  anchor?: string | null,
  sortingIndex?: number | null,
  helpText?: string | null,
  value?: string | null,
  questionId?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteAnswerOptionInput = {
  id: string,
};

export type ModelActivityEventConditionInput = {
  creatorId?: ModelIDInput | null,
  programId?: ModelIDInput | null,
  activityEventDate?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelActivityEventConditionInput | null > | null,
  or?: Array< ModelActivityEventConditionInput | null > | null,
  not?: ModelActivityEventConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateActivityEventInput = {
  id: string,
  creatorId?: string | null,
  programId?: string | null,
  activityEventDate?: string | null,
  notes?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteActivityEventInput = {
  id: string,
};

export type CreateActivityParticipantInput = {
  id?: string | null,
  userId?: string | null,
  activityEventId: string,
  programId?: string | null,
  currentPGY?: number | null,
  currentRole?: ProgramRole | null,
  currentTraineeType?: TraineeType | null,
  currentJobTitle?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelActivityParticipantConditionInput = {
  userId?: ModelIDInput | null,
  activityEventId?: ModelIDInput | null,
  programId?: ModelIDInput | null,
  currentPGY?: ModelIntInput | null,
  currentRole?: ModelProgramRoleInput | null,
  currentTraineeType?: ModelTraineeTypeInput | null,
  currentJobTitle?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelActivityParticipantConditionInput | null > | null,
  or?: Array< ModelActivityParticipantConditionInput | null > | null,
  not?: ModelActivityParticipantConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateActivityParticipantInput = {
  id: string,
  userId?: string | null,
  activityEventId?: string | null,
  programId?: string | null,
  currentPGY?: number | null,
  currentRole?: ProgramRole | null,
  currentTraineeType?: TraineeType | null,
  currentJobTitle?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteActivityParticipantInput = {
  id: string,
};

export type CreateAssessmentEventInput = {
  id?: string | null,
  subjectId?: string | null,
  subjectUserId?: string | null,
  raterId?: string | null,
  raterUserId?: string | null,
  activityId?: string | null,
  activityEventId?: string | null,
  programId?: string | null,
  assessmentId?: string | null,
  expirationDate?: string | null,
  completionDate?: string | null,
  declined?: ReasonForDecline | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelAssessmentEventConditionInput = {
  subjectId?: ModelIDInput | null,
  subjectUserId?: ModelIDInput | null,
  raterId?: ModelIDInput | null,
  raterUserId?: ModelIDInput | null,
  activityId?: ModelIDInput | null,
  activityEventId?: ModelIDInput | null,
  programId?: ModelIDInput | null,
  assessmentId?: ModelIDInput | null,
  expirationDate?: ModelStringInput | null,
  completionDate?: ModelStringInput | null,
  declined?: ModelReasonForDeclineInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelAssessmentEventConditionInput | null > | null,
  or?: Array< ModelAssessmentEventConditionInput | null > | null,
  not?: ModelAssessmentEventConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelReasonForDeclineInput = {
  eq?: ReasonForDecline | null,
  ne?: ReasonForDecline | null,
};

export type UpdateAssessmentEventInput = {
  id: string,
  subjectId?: string | null,
  subjectUserId?: string | null,
  raterId?: string | null,
  raterUserId?: string | null,
  activityId?: string | null,
  activityEventId?: string | null,
  programId?: string | null,
  assessmentId?: string | null,
  expirationDate?: string | null,
  completionDate?: string | null,
  declined?: ReasonForDecline | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteAssessmentEventInput = {
  id: string,
};

export type CreateAnswerEventInput = {
  id?: string | null,
  questionId?: string | null,
  valueType?: ValueType | null,
  value?: string | null,
  assessmentEventId?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelAnswerEventConditionInput = {
  questionId?: ModelIDInput | null,
  valueType?: ModelValueTypeInput | null,
  value?: ModelStringInput | null,
  assessmentEventId?: ModelIDInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelAnswerEventConditionInput | null > | null,
  or?: Array< ModelAnswerEventConditionInput | null > | null,
  not?: ModelAnswerEventConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelValueTypeInput = {
  eq?: ValueType | null,
  ne?: ValueType | null,
};

export type UpdateAnswerEventInput = {
  id: string,
  questionId?: string | null,
  valueType?: ValueType | null,
  value?: string | null,
  assessmentEventId?: string | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteAnswerEventInput = {
  id: string,
};

export type CreateAcgmeProcedureInput = {
  id?: string | null,
  name: string,
  acgmeCode: string,
  simpl1Id: number,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type ModelAcgmeProcedureConditionInput = {
  name?: ModelStringInput | null,
  acgmeCode?: ModelStringInput | null,
  simpl1Id?: ModelIntInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  and?: Array< ModelAcgmeProcedureConditionInput | null > | null,
  or?: Array< ModelAcgmeProcedureConditionInput | null > | null,
  not?: ModelAcgmeProcedureConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateAcgmeProcedureInput = {
  id: string,
  name?: string | null,
  acgmeCode?: string | null,
  simpl1Id?: number | null,
  deletedAt?: string | null,
  deletedBy?: string | null,
  deletedReason?: string | null,
};

export type DeleteAcgmeProcedureInput = {
  id: string,
};

export type CreateProgramSponsorsInput = {
  id?: string | null,
  programID: string,
  sponsorID: string,
};

export type ModelProgramSponsorsConditionInput = {
  programID?: ModelIDInput | null,
  sponsorID?: ModelIDInput | null,
  and?: Array< ModelProgramSponsorsConditionInput | null > | null,
  or?: Array< ModelProgramSponsorsConditionInput | null > | null,
  not?: ModelProgramSponsorsConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateProgramSponsorsInput = {
  id: string,
  programID?: string | null,
  sponsorID?: string | null,
};

export type DeleteProgramSponsorsInput = {
  id: string,
};

export type CreateNetworkProgramInput = {
  id?: string | null,
  programID: string,
  networkID: string,
};

export type ModelNetworkProgramConditionInput = {
  programID?: ModelIDInput | null,
  networkID?: ModelIDInput | null,
  and?: Array< ModelNetworkProgramConditionInput | null > | null,
  or?: Array< ModelNetworkProgramConditionInput | null > | null,
  not?: ModelNetworkProgramConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateNetworkProgramInput = {
  id: string,
  programID?: string | null,
  networkID?: string | null,
};

export type DeleteNetworkProgramInput = {
  id: string,
};

export type CreateNetworkActivityInput = {
  id?: string | null,
  networkID: string,
  activityID: string,
};

export type ModelNetworkActivityConditionInput = {
  networkID?: ModelIDInput | null,
  activityID?: ModelIDInput | null,
  and?: Array< ModelNetworkActivityConditionInput | null > | null,
  or?: Array< ModelNetworkActivityConditionInput | null > | null,
  not?: ModelNetworkActivityConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateNetworkActivityInput = {
  id: string,
  networkID?: string | null,
  activityID?: string | null,
};

export type DeleteNetworkActivityInput = {
  id: string,
};

export type CreateAssessmentActivityInput = {
  id?: string | null,
  assessmentID: string,
  activityID: string,
};

export type ModelAssessmentActivityConditionInput = {
  assessmentID?: ModelIDInput | null,
  activityID?: ModelIDInput | null,
  and?: Array< ModelAssessmentActivityConditionInput | null > | null,
  or?: Array< ModelAssessmentActivityConditionInput | null > | null,
  not?: ModelAssessmentActivityConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateAssessmentActivityInput = {
  id: string,
  assessmentID?: string | null,
  activityID?: string | null,
};

export type DeleteAssessmentActivityInput = {
  id: string,
};

export type CreateActivityEventActivitiesInput = {
  id?: string | null,
  activityID: string,
  activityEventID: string,
};

export type ModelActivityEventActivitiesConditionInput = {
  activityID?: ModelIDInput | null,
  activityEventID?: ModelIDInput | null,
  and?: Array< ModelActivityEventActivitiesConditionInput | null > | null,
  or?: Array< ModelActivityEventActivitiesConditionInput | null > | null,
  not?: ModelActivityEventActivitiesConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateActivityEventActivitiesInput = {
  id: string,
  activityID?: string | null,
  activityEventID?: string | null,
};

export type DeleteActivityEventActivitiesInput = {
  id: string,
};

export type CreateAcgmeProcedureActivityInput = {
  id?: string | null,
  activityID: string,
  acgmeProcedureID: string,
};

export type ModelAcgmeProcedureActivityConditionInput = {
  activityID?: ModelIDInput | null,
  acgmeProcedureID?: ModelIDInput | null,
  and?: Array< ModelAcgmeProcedureActivityConditionInput | null > | null,
  or?: Array< ModelAcgmeProcedureActivityConditionInput | null > | null,
  not?: ModelAcgmeProcedureActivityConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateAcgmeProcedureActivityInput = {
  id: string,
  activityID?: string | null,
  acgmeProcedureID?: string | null,
};

export type DeleteAcgmeProcedureActivityInput = {
  id: string,
};

export type UserStats = {
  __typename: "UserStats",
  percentCompleted?: number | null,
  averageResponseTime?: number | null,
  assessmentsCreated?: number | null,
  assessmentsCompleted?: number | null,
  assessmentsExpired?: number | null,
};

export type AssessmentHistoryArgs = {
  programMemberships?: Array< string | null > | null,
  includeIncomplete?: boolean | null,
  membersAssessmentsOnly?: boolean | null,
  filterByUserId?: string | null,
  filterByActivityId?: string | null,
  includeSelfAssessments?: boolean | null,
};

export type UpdateUserEmailArgs = {
  userId?: string | null,
  newEmail?: string | null,
};

export type EngagementReportArgs = {
  reportType?: EngagementReportType | null,
  institutionId?: string | null,
  programId?: string | null,
  role?: ProgramRole | null,
  startDate?: string | null,
  endDate?: string | null,
};

export enum EngagementReportType {
  User = "User",
  Program = "Program",
}


export type EngagementReportResult = {
  __typename: "EngagementReportResult",
  success: boolean,
  error?: string | null,
  programReportRows?:  Array<ProgramReportRow > | null,
  userReportRows?:  Array<UserReportRow > | null,
};

export type ProgramReportRow = {
  __typename: "ProgramReportRow",
  institutionId?: string | null,
  institutionName?: string | null,
  programId?: string | null,
  program?: string | null,
  createdAssessmentEvents?: number | null,
  assignedAssessmentEvents?: number | null,
  completedAssessmentEvents?: number | null,
  percentCompleted?: number | null,
  attendingsInProgram?: number | null,
  traineesInProgram?: number | null,
  averageCompletedPerTrainee?: number | null,
};

export type UserReportRow = {
  __typename: "UserReportRow",
  userId?: string | null,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  programRole?: string | null,
  programId?: string | null,
  program?: string | null,
  createdAssessmentEvents?: number | null,
  assignedAssessmentEvents?: number | null,
  completedAssessmentEvents?: number | null,
  percentCompleted?: number | null,
  expiredAssessmentEvents?: number | null,
  percentExpired?: number | null,
};

export type ValidateBulkUploadArgs = {
  invitations?: Array< ValidateBulkUploadInvitation > | null,
};

export type ValidateBulkUploadInvitation = {
  requestId?: string | null,
  firstName: string,
  lastName: string,
  email: string,
  role: ProgramRole,
  programId: string,
  npi?: string | null,
  simplLearnId?: string | null,
  pgy?: string | null,
  traineeType?: string | null,
  jobTitle?: string | null,
};

export type ValidateBulkUploadResult = {
  __typename: "ValidateBulkUploadResult",
  success: boolean,
  error?: string | null,
  invitations?:  Array<ValidateBulkUploadInvitationResult > | null,
};

export type ValidateBulkUploadInvitationResult = {
  __typename: "ValidateBulkUploadInvitationResult",
  requestId?: string | null,
  firstName: string,
  lastName: string,
  email: string,
  role: ProgramRole,
  programId: string,
  npi?: string | null,
  simplLearnId?: string | null,
  pgy?: string | null,
  traineeType?: string | null,
  jobTitle?: string | null,
  errors?:  Array<ValidateBulkUploadError > | null,
};

export type ValidateBulkUploadError = {
  __typename: "ValidateBulkUploadError",
  field: string,
  error: string,
};

export type RequestBulkCCCReportInput = {
  destinationEmail: string,
  userIds: Array< string >,
  reportTypes: Array< CccReportType >,
  includeSelfAssessments?: boolean | null,
  startDate?: string | null,
  endDate?: string | null,
};

export enum CccReportType {
  User = "User",
  Milestone = "Milestone",
}


export type SendUserInvitationArgs = {
  userId?: string | null,
};

export type SendUserInvitationResult = {
  __typename: "SendUserInvitationResult",
  success: boolean,
  error?: string | null,
};

export type AvailableActivitiesArgs = {
  subjectUserId?: string | null,
  loggedInUserId?: string | null,
  limit?: number | null,
  page?: number | null,
};

export type ActivitiesByUsersArgs = {
  userIds: Array< string >,
};

export type ActivitiesByUsersResult = {
  __typename: "ActivitiesByUsersResult",
  error?: string | null,
  activities?:  Array<ActivitiesByUsersActivity | null > | null,
};

export type PaginatableUsersPendingAssessmentsArgs = {
  userId?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PaginatableUsersPendingAssessmentsResult = {
  __typename: "PaginatableUsersPendingAssessmentsResult",
  nextToken?: string | null,
  total?: number | null,
  items?:  Array<AssessmentEvent | null > | null,
};

export type AssessmentRoleResult = {
  __typename: "AssessmentRoleResult",
  showPrompt: boolean,
  assessmentRole?: AssessmentRole | null,
};

export type AssessmentHistorySearchUserArgs = {
  userId?: string | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ModelInstitutionFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelInstitutionFilterInput | null > | null,
  or?: Array< ModelInstitutionFilterInput | null > | null,
  not?: ModelInstitutionFilterInput | null,
};

export type ModelInstitutionConnection = {
  __typename: "ModelInstitutionConnection",
  items:  Array<Institution | null >,
  nextToken?: string | null,
};

export type ModelProgramFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  institutionId?: ModelIDInput | null,
  simpl1Id?: ModelIntInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProgramFilterInput | null > | null,
  or?: Array< ModelProgramFilterInput | null > | null,
  not?: ModelProgramFilterInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type SearchableProgramFilterInput = {
  id?: SearchableIDFilterInput | null,
  name?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  institutionId?: SearchableIDFilterInput | null,
  simpl1Id?: SearchableIntFilterInput | null,
  deletedAt?: SearchableStringFilterInput | null,
  deletedBy?: SearchableStringFilterInput | null,
  deletedReason?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableProgramFilterInput | null > | null,
  or?: Array< SearchableProgramFilterInput | null > | null,
  not?: SearchableProgramFilterInput | null,
};

export type SearchableIDFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableStringFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableIntFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableProgramSortInput = {
  field?: SearchableProgramSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableProgramSortableFields {
  id = "id",
  name = "name",
  description = "description",
  institutionId = "institutionId",
  simpl1Id = "simpl1Id",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc",
}


export type SearchableProgramAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableProgramAggregateField,
};

export enum SearchableAggregateType {
  terms = "terms",
  avg = "avg",
  min = "min",
  max = "max",
  sum = "sum",
  cardinality = "cardinality",
}


export enum SearchableProgramAggregateField {
  id = "id",
  name = "name",
  description = "description",
  institutionId = "institutionId",
  simpl1Id = "simpl1Id",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableProgramConnection = {
  __typename: "SearchableProgramConnection",
  items:  Array<Program | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type SearchableAggregateResult = {
  __typename: "SearchableAggregateResult",
  name: string,
  result?: SearchableAggregateGenericResult | null,
};

export type SearchableAggregateGenericResult = SearchableAggregateScalarResult | SearchableAggregateBucketResult


export type SearchableAggregateScalarResult = {
  __typename: "SearchableAggregateScalarResult",
  value: number,
};

export type SearchableAggregateBucketResult = {
  __typename: "SearchableAggregateBucketResult",
  buckets?:  Array<SearchableAggregateBucketResultItem | null > | null,
};

export type SearchableAggregateBucketResultItem = {
  __typename: "SearchableAggregateBucketResultItem",
  key: string,
  doc_count: number,
};

export type ModelNetworkFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  sponsorId?: ModelIDInput | null,
  acgmeEnabled?: ModelBooleanInput | null,
  allAttendingHistoryDisabled?: ModelBooleanInput | null,
  simpl1Id?: ModelIntInput | null,
  categoriesExcludedFromRequestFlow?: ModelStringInput | null,
  dashboardURL?: ModelStringInput | null,
  showDashboardLink?: ModelBooleanInput | null,
  disableClassicReports?: ModelBooleanInput | null,
  traineeCanRateTrainee?: ModelBooleanInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelNetworkFilterInput | null > | null,
  or?: Array< ModelNetworkFilterInput | null > | null,
  not?: ModelNetworkFilterInput | null,
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  emailLower?: ModelStringInput | null,
  institutionId?: ModelIDInput | null,
  cognitoUsername?: ModelStringInput | null,
  firstName?: ModelStringInput | null,
  lastName?: ModelStringInput | null,
  suffix?: ModelStringInput | null,
  npi?: ModelIntInput | null,
  simplLearnId?: ModelStringInput | null,
  pgy?: ModelIntInput | null,
  lastLogin?: ModelStringInput | null,
  eulaAcceptedDate?: ModelStringInput | null,
  simpl1Id?: ModelIntInput | null,
  deviceToken?: ModelStringInput | null,
  devicePlatform?: ModelDevicePlatformInput | null,
  inviteId?: ModelIDInput | null,
  jobTitle?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserFilterInput | null > | null,
  or?: Array< ModelUserFilterInput | null > | null,
  not?: ModelUserFilterInput | null,
};

export type SearchableUserFilterInput = {
  id?: SearchableIDFilterInput | null,
  email?: SearchableStringFilterInput | null,
  emailLower?: SearchableStringFilterInput | null,
  institutionId?: SearchableIDFilterInput | null,
  cognitoUsername?: SearchableStringFilterInput | null,
  firstName?: SearchableStringFilterInput | null,
  lastName?: SearchableStringFilterInput | null,
  suffix?: SearchableStringFilterInput | null,
  npi?: SearchableIntFilterInput | null,
  simplLearnId?: SearchableStringFilterInput | null,
  pgy?: SearchableIntFilterInput | null,
  lastLogin?: SearchableStringFilterInput | null,
  eulaAcceptedDate?: SearchableStringFilterInput | null,
  simpl1Id?: SearchableIntFilterInput | null,
  deviceToken?: SearchableStringFilterInput | null,
  inviteId?: SearchableIDFilterInput | null,
  jobTitle?: SearchableStringFilterInput | null,
  deletedAt?: SearchableStringFilterInput | null,
  deletedBy?: SearchableStringFilterInput | null,
  deletedReason?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  devicePlatform?: SearchableStringFilterInput | null,
  and?: Array< SearchableUserFilterInput | null > | null,
  or?: Array< SearchableUserFilterInput | null > | null,
  not?: SearchableUserFilterInput | null,
};

export type SearchableUserSortInput = {
  field?: SearchableUserSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableUserSortableFields {
  id = "id",
  email = "email",
  emailLower = "emailLower",
  institutionId = "institutionId",
  cognitoUsername = "cognitoUsername",
  firstName = "firstName",
  lastName = "lastName",
  suffix = "suffix",
  npi = "npi",
  simplLearnId = "simplLearnId",
  pgy = "pgy",
  lastLogin = "lastLogin",
  eulaAcceptedDate = "eulaAcceptedDate",
  simpl1Id = "simpl1Id",
  deviceToken = "deviceToken",
  inviteId = "inviteId",
  jobTitle = "jobTitle",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableUserAggregateField,
};

export enum SearchableUserAggregateField {
  id = "id",
  email = "email",
  emailLower = "emailLower",
  institutionId = "institutionId",
  cognitoUsername = "cognitoUsername",
  firstName = "firstName",
  lastName = "lastName",
  suffix = "suffix",
  npi = "npi",
  simplLearnId = "simplLearnId",
  pgy = "pgy",
  lastLogin = "lastLogin",
  eulaAcceptedDate = "eulaAcceptedDate",
  simpl1Id = "simpl1Id",
  deviceToken = "deviceToken",
  devicePlatform = "devicePlatform",
  inviteId = "inviteId",
  jobTitle = "jobTitle",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserConnection = {
  __typename: "SearchableUserConnection",
  items:  Array<User | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelUserInvitationFilterInput = {
  id?: ModelIDInput | null,
  inviteeId?: ModelIDInput | null,
  institutionId?: ModelIDInput | null,
  invitationStatus?: ModelInvitationStatusInput | null,
  email?: ModelStringInput | null,
  emailLower?: ModelStringInput | null,
  adminId?: ModelIDInput | null,
  programId?: ModelIDInput | null,
  role?: ModelProgramRoleInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelUserInvitationFilterInput | null > | null,
  or?: Array< ModelUserInvitationFilterInput | null > | null,
  not?: ModelUserInvitationFilterInput | null,
};

export type SearchableUserInvitationFilterInput = {
  id?: SearchableIDFilterInput | null,
  inviteeId?: SearchableIDFilterInput | null,
  institutionId?: SearchableIDFilterInput | null,
  email?: SearchableStringFilterInput | null,
  emailLower?: SearchableStringFilterInput | null,
  adminId?: SearchableIDFilterInput | null,
  programId?: SearchableIDFilterInput | null,
  deletedAt?: SearchableStringFilterInput | null,
  deletedBy?: SearchableStringFilterInput | null,
  deletedReason?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  invitationStatus?: SearchableStringFilterInput | null,
  role?: SearchableStringFilterInput | null,
  and?: Array< SearchableUserInvitationFilterInput | null > | null,
  or?: Array< SearchableUserInvitationFilterInput | null > | null,
  not?: SearchableUserInvitationFilterInput | null,
};

export type SearchableUserInvitationSortInput = {
  field?: SearchableUserInvitationSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableUserInvitationSortableFields {
  id = "id",
  inviteeId = "inviteeId",
  institutionId = "institutionId",
  email = "email",
  emailLower = "emailLower",
  adminId = "adminId",
  programId = "programId",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserInvitationAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableUserInvitationAggregateField,
};

export enum SearchableUserInvitationAggregateField {
  id = "id",
  inviteeId = "inviteeId",
  institutionId = "institutionId",
  invitationStatus = "invitationStatus",
  email = "email",
  emailLower = "emailLower",
  adminId = "adminId",
  programId = "programId",
  role = "role",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableUserInvitationConnection = {
  __typename: "SearchableUserInvitationConnection",
  items:  Array<UserInvitation | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelProgramMembershipFilterInput = {
  id?: ModelIDInput | null,
  programRole?: ModelProgramRoleInput | null,
  traineeType?: ModelTraineeTypeInput | null,
  programMemberId?: ModelIDInput | null,
  programId?: ModelIDInput | null,
  startDate?: ModelStringInput | null,
  endDate?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProgramMembershipFilterInput | null > | null,
  or?: Array< ModelProgramMembershipFilterInput | null > | null,
  not?: ModelProgramMembershipFilterInput | null,
};

export type SearchableProgramMembershipFilterInput = {
  id?: SearchableIDFilterInput | null,
  programMemberId?: SearchableIDFilterInput | null,
  programId?: SearchableIDFilterInput | null,
  startDate?: SearchableStringFilterInput | null,
  endDate?: SearchableStringFilterInput | null,
  deletedAt?: SearchableStringFilterInput | null,
  deletedBy?: SearchableStringFilterInput | null,
  deletedReason?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  programRole?: SearchableStringFilterInput | null,
  traineeType?: SearchableStringFilterInput | null,
  and?: Array< SearchableProgramMembershipFilterInput | null > | null,
  or?: Array< SearchableProgramMembershipFilterInput | null > | null,
  not?: SearchableProgramMembershipFilterInput | null,
};

export type SearchableProgramMembershipSortInput = {
  field?: SearchableProgramMembershipSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableProgramMembershipSortableFields {
  id = "id",
  programMemberId = "programMemberId",
  programId = "programId",
  startDate = "startDate",
  endDate = "endDate",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableProgramMembershipAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableProgramMembershipAggregateField,
};

export enum SearchableProgramMembershipAggregateField {
  id = "id",
  programRole = "programRole",
  traineeType = "traineeType",
  programMemberId = "programMemberId",
  programId = "programId",
  startDate = "startDate",
  endDate = "endDate",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableProgramMembershipConnection = {
  __typename: "SearchableProgramMembershipConnection",
  items:  Array<ProgramMembership | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelEULATextFilterInput = {
  id?: ModelIDInput | null,
  formattedText?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEULATextFilterInput | null > | null,
  or?: Array< ModelEULATextFilterInput | null > | null,
  not?: ModelEULATextFilterInput | null,
};

export type ModelEULATextConnection = {
  __typename: "ModelEULATextConnection",
  items:  Array<EULAText | null >,
  nextToken?: string | null,
};

export type ModelMilestoneFilterInput = {
  id?: ModelIDInput | null,
  shortName?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  scale?: ModelIntInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMilestoneFilterInput | null > | null,
  or?: Array< ModelMilestoneFilterInput | null > | null,
  not?: ModelMilestoneFilterInput | null,
};

export type ModelMilestoneConnection = {
  __typename: "ModelMilestoneConnection",
  items:  Array<Milestone | null >,
  nextToken?: string | null,
};

export type ModelMilestoneNetworkRatingFilterInput = {
  id?: ModelIDInput | null,
  activityId?: ModelIDInput | null,
  networkId?: ModelIDInput | null,
  milestoneId?: ModelIDInput | null,
  answerOptionId?: ModelIDInput | null,
  milestoneRating?: ModelFloatInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelMilestoneNetworkRatingFilterInput | null > | null,
  or?: Array< ModelMilestoneNetworkRatingFilterInput | null > | null,
  not?: ModelMilestoneNetworkRatingFilterInput | null,
};

export type ModelMilestoneNetworkRatingConnection = {
  __typename: "ModelMilestoneNetworkRatingConnection",
  items:  Array<MilestoneNetworkRating | null >,
  nextToken?: string | null,
};

export type ModelSponsorFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  activityLabel?: ModelStringInput | null,
  autoAssignActivities?: ModelIDInput | null,
  dashboardURL?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelSponsorFilterInput | null > | null,
  or?: Array< ModelSponsorFilterInput | null > | null,
  not?: ModelSponsorFilterInput | null,
};

export type ModelSponsorConnection = {
  __typename: "ModelSponsorConnection",
  items:  Array<Sponsor | null >,
  nextToken?: string | null,
};

export type ModelAssessmentFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  instrumentId?: ModelIDInput | null,
  expirationDurationHours?: ModelIntInput | null,
  sponsorId?: ModelIDInput | null,
  requireTraineeSelfAssessment?: ModelBooleanInput | null,
  authorId?: ModelIDInput | null,
  published?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  version?: ModelStringInput | null,
  creationDurationHours?: ModelIntInput | null,
  showFeedbackQuestionsToTrainees?: ModelBooleanInput | null,
  sendEmailForSelfAssessment?: ModelBooleanInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAssessmentFilterInput | null > | null,
  or?: Array< ModelAssessmentFilterInput | null > | null,
  not?: ModelAssessmentFilterInput | null,
};

export type ModelAssessmentConnection = {
  __typename: "ModelAssessmentConnection",
  items:  Array<Assessment | null >,
  nextToken?: string | null,
};

export type SearchableAssessmentFilterInput = {
  id?: SearchableIDFilterInput | null,
  title?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  instrumentId?: SearchableIDFilterInput | null,
  expirationDurationHours?: SearchableIntFilterInput | null,
  sponsorId?: SearchableIDFilterInput | null,
  requireTraineeSelfAssessment?: SearchableBooleanFilterInput | null,
  authorId?: SearchableIDFilterInput | null,
  published?: SearchableBooleanFilterInput | null,
  archived?: SearchableBooleanFilterInput | null,
  version?: SearchableStringFilterInput | null,
  creationDurationHours?: SearchableIntFilterInput | null,
  showFeedbackQuestionsToTrainees?: SearchableBooleanFilterInput | null,
  sendEmailForSelfAssessment?: SearchableBooleanFilterInput | null,
  deletedAt?: SearchableStringFilterInput | null,
  deletedBy?: SearchableStringFilterInput | null,
  deletedReason?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableAssessmentFilterInput | null > | null,
  or?: Array< SearchableAssessmentFilterInput | null > | null,
  not?: SearchableAssessmentFilterInput | null,
};

export type SearchableBooleanFilterInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type SearchableAssessmentSortInput = {
  field?: SearchableAssessmentSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableAssessmentSortableFields {
  id = "id",
  title = "title",
  description = "description",
  instrumentId = "instrumentId",
  expirationDurationHours = "expirationDurationHours",
  sponsorId = "sponsorId",
  requireTraineeSelfAssessment = "requireTraineeSelfAssessment",
  authorId = "authorId",
  published = "published",
  archived = "archived",
  version = "version",
  creationDurationHours = "creationDurationHours",
  showFeedbackQuestionsToTrainees = "showFeedbackQuestionsToTrainees",
  sendEmailForSelfAssessment = "sendEmailForSelfAssessment",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableAssessmentAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableAssessmentAggregateField,
};

export enum SearchableAssessmentAggregateField {
  id = "id",
  title = "title",
  description = "description",
  instrumentId = "instrumentId",
  expirationDurationHours = "expirationDurationHours",
  sponsorId = "sponsorId",
  requireTraineeSelfAssessment = "requireTraineeSelfAssessment",
  authorId = "authorId",
  published = "published",
  archived = "archived",
  version = "version",
  creationDurationHours = "creationDurationHours",
  showFeedbackQuestionsToTrainees = "showFeedbackQuestionsToTrainees",
  sendEmailForSelfAssessment = "sendEmailForSelfAssessment",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableAssessmentConnection = {
  __typename: "SearchableAssessmentConnection",
  items:  Array<Assessment | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelInstrumentFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  authorId?: ModelIDInput | null,
  version?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelInstrumentFilterInput | null > | null,
  or?: Array< ModelInstrumentFilterInput | null > | null,
  not?: ModelInstrumentFilterInput | null,
};

export type ModelInstrumentConnection = {
  __typename: "ModelInstrumentConnection",
  items:  Array<Instrument | null >,
  nextToken?: string | null,
};

export type SearchableInstrumentFilterInput = {
  id?: SearchableIDFilterInput | null,
  title?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  authorId?: SearchableIDFilterInput | null,
  version?: SearchableStringFilterInput | null,
  deletedAt?: SearchableStringFilterInput | null,
  deletedBy?: SearchableStringFilterInput | null,
  deletedReason?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableInstrumentFilterInput | null > | null,
  or?: Array< SearchableInstrumentFilterInput | null > | null,
  not?: SearchableInstrumentFilterInput | null,
};

export type SearchableInstrumentSortInput = {
  field?: SearchableInstrumentSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableInstrumentSortableFields {
  id = "id",
  title = "title",
  description = "description",
  authorId = "authorId",
  version = "version",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableInstrumentAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableInstrumentAggregateField,
};

export enum SearchableInstrumentAggregateField {
  id = "id",
  title = "title",
  description = "description",
  authorId = "authorId",
  version = "version",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableInstrumentConnection = {
  __typename: "SearchableInstrumentConnection",
  items:  Array<Instrument | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelActivityFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  assessmentId?: ModelIDInput | null,
  sponsorId?: ModelIDInput | null,
  authorId?: ModelIDInput | null,
  version?: ModelStringInput | null,
  simpl1Id?: ModelIntInput | null,
  categories?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelActivityFilterInput | null > | null,
  or?: Array< ModelActivityFilterInput | null > | null,
  not?: ModelActivityFilterInput | null,
  activitySubActivitiesId?: ModelIDInput | null,
};

export type SearchableActivityFilterInput = {
  id?: SearchableIDFilterInput | null,
  title?: SearchableStringFilterInput | null,
  description?: SearchableStringFilterInput | null,
  assessmentId?: SearchableIDFilterInput | null,
  sponsorId?: SearchableIDFilterInput | null,
  authorId?: SearchableIDFilterInput | null,
  version?: SearchableStringFilterInput | null,
  simpl1Id?: SearchableIntFilterInput | null,
  categories?: SearchableStringFilterInput | null,
  deletedAt?: SearchableStringFilterInput | null,
  deletedBy?: SearchableStringFilterInput | null,
  deletedReason?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  activitySubActivitiesId?: SearchableIDFilterInput | null,
  and?: Array< SearchableActivityFilterInput | null > | null,
  or?: Array< SearchableActivityFilterInput | null > | null,
  not?: SearchableActivityFilterInput | null,
};

export type SearchableActivitySortInput = {
  field?: SearchableActivitySortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableActivitySortableFields {
  id = "id",
  title = "title",
  description = "description",
  assessmentId = "assessmentId",
  sponsorId = "sponsorId",
  authorId = "authorId",
  version = "version",
  simpl1Id = "simpl1Id",
  categories = "categories",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  activitySubActivitiesId = "activitySubActivitiesId",
}


export type SearchableActivityAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableActivityAggregateField,
};

export enum SearchableActivityAggregateField {
  id = "id",
  title = "title",
  description = "description",
  assessmentId = "assessmentId",
  sponsorId = "sponsorId",
  authorId = "authorId",
  version = "version",
  simpl1Id = "simpl1Id",
  categories = "categories",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  activitySubActivitiesId = "activitySubActivitiesId",
}


export type SearchableActivityConnection = {
  __typename: "SearchableActivityConnection",
  items:  Array<Activity | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelQuestionFilterInput = {
  id?: ModelIDInput | null,
  defaultPrompt?: ModelStringInput | null,
  required?: ModelBooleanInput | null,
  selfAssessmentPrompt?: ModelStringInput | null,
  sortingIndex?: ModelIntInput | null,
  title?: ModelStringInput | null,
  helpText?: ModelStringInput | null,
  inputType?: ModelInputTypeInput | null,
  instrumentId?: ModelIDInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelQuestionFilterInput | null > | null,
  or?: Array< ModelQuestionFilterInput | null > | null,
  not?: ModelQuestionFilterInput | null,
};

export type ModelAnswerOptionFilterInput = {
  id?: ModelIDInput | null,
  anchor?: ModelStringInput | null,
  sortingIndex?: ModelIntInput | null,
  helpText?: ModelStringInput | null,
  value?: ModelStringInput | null,
  questionId?: ModelIDInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAnswerOptionFilterInput | null > | null,
  or?: Array< ModelAnswerOptionFilterInput | null > | null,
  not?: ModelAnswerOptionFilterInput | null,
};

export type ModelActivityEventFilterInput = {
  id?: ModelIDInput | null,
  creatorId?: ModelIDInput | null,
  programId?: ModelIDInput | null,
  activityEventDate?: ModelStringInput | null,
  notes?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelActivityEventFilterInput | null > | null,
  or?: Array< ModelActivityEventFilterInput | null > | null,
  not?: ModelActivityEventFilterInput | null,
};

export type ModelActivityEventConnection = {
  __typename: "ModelActivityEventConnection",
  items:  Array<ActivityEvent | null >,
  nextToken?: string | null,
};

export type SearchableActivityEventFilterInput = {
  id?: SearchableIDFilterInput | null,
  creatorId?: SearchableIDFilterInput | null,
  programId?: SearchableIDFilterInput | null,
  activityEventDate?: SearchableStringFilterInput | null,
  notes?: SearchableStringFilterInput | null,
  deletedAt?: SearchableStringFilterInput | null,
  deletedBy?: SearchableStringFilterInput | null,
  deletedReason?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  and?: Array< SearchableActivityEventFilterInput | null > | null,
  or?: Array< SearchableActivityEventFilterInput | null > | null,
  not?: SearchableActivityEventFilterInput | null,
};

export type SearchableActivityEventSortInput = {
  field?: SearchableActivityEventSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableActivityEventSortableFields {
  id = "id",
  creatorId = "creatorId",
  programId = "programId",
  activityEventDate = "activityEventDate",
  notes = "notes",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableActivityEventAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableActivityEventAggregateField,
};

export enum SearchableActivityEventAggregateField {
  id = "id",
  creatorId = "creatorId",
  programId = "programId",
  activityEventDate = "activityEventDate",
  notes = "notes",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableActivityEventConnection = {
  __typename: "SearchableActivityEventConnection",
  items:  Array<ActivityEvent | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelActivityParticipantFilterInput = {
  id?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  activityEventId?: ModelIDInput | null,
  programId?: ModelIDInput | null,
  currentPGY?: ModelIntInput | null,
  currentRole?: ModelProgramRoleInput | null,
  currentTraineeType?: ModelTraineeTypeInput | null,
  currentJobTitle?: ModelStringInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelActivityParticipantFilterInput | null > | null,
  or?: Array< ModelActivityParticipantFilterInput | null > | null,
  not?: ModelActivityParticipantFilterInput | null,
};

export type ModelAssessmentEventFilterInput = {
  id?: ModelIDInput | null,
  subjectId?: ModelIDInput | null,
  subjectUserId?: ModelIDInput | null,
  raterId?: ModelIDInput | null,
  raterUserId?: ModelIDInput | null,
  activityId?: ModelIDInput | null,
  activityEventId?: ModelIDInput | null,
  programId?: ModelIDInput | null,
  assessmentId?: ModelIDInput | null,
  expirationDate?: ModelStringInput | null,
  completionDate?: ModelStringInput | null,
  declined?: ModelReasonForDeclineInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAssessmentEventFilterInput | null > | null,
  or?: Array< ModelAssessmentEventFilterInput | null > | null,
  not?: ModelAssessmentEventFilterInput | null,
};

export type SearchableAssessmentEventFilterInput = {
  id?: SearchableIDFilterInput | null,
  subjectId?: SearchableIDFilterInput | null,
  subjectUserId?: SearchableIDFilterInput | null,
  raterId?: SearchableIDFilterInput | null,
  raterUserId?: SearchableIDFilterInput | null,
  activityId?: SearchableIDFilterInput | null,
  activityEventId?: SearchableIDFilterInput | null,
  programId?: SearchableIDFilterInput | null,
  assessmentId?: SearchableIDFilterInput | null,
  expirationDate?: SearchableStringFilterInput | null,
  completionDate?: SearchableStringFilterInput | null,
  deletedAt?: SearchableStringFilterInput | null,
  deletedBy?: SearchableStringFilterInput | null,
  deletedReason?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  declined?: SearchableStringFilterInput | null,
  and?: Array< SearchableAssessmentEventFilterInput | null > | null,
  or?: Array< SearchableAssessmentEventFilterInput | null > | null,
  not?: SearchableAssessmentEventFilterInput | null,
};

export type SearchableAssessmentEventSortInput = {
  field?: SearchableAssessmentEventSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableAssessmentEventSortableFields {
  id = "id",
  subjectId = "subjectId",
  subjectUserId = "subjectUserId",
  raterId = "raterId",
  raterUserId = "raterUserId",
  activityId = "activityId",
  activityEventId = "activityEventId",
  programId = "programId",
  assessmentId = "assessmentId",
  expirationDate = "expirationDate",
  completionDate = "completionDate",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableAssessmentEventAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableAssessmentEventAggregateField,
};

export enum SearchableAssessmentEventAggregateField {
  id = "id",
  subjectId = "subjectId",
  subjectUserId = "subjectUserId",
  raterId = "raterId",
  raterUserId = "raterUserId",
  activityId = "activityId",
  activityEventId = "activityEventId",
  programId = "programId",
  assessmentId = "assessmentId",
  expirationDate = "expirationDate",
  completionDate = "completionDate",
  declined = "declined",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableAssessmentEventConnection = {
  __typename: "SearchableAssessmentEventConnection",
  items:  Array<AssessmentEvent | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelAnswerEventFilterInput = {
  id?: ModelIDInput | null,
  questionId?: ModelIDInput | null,
  valueType?: ModelValueTypeInput | null,
  value?: ModelStringInput | null,
  assessmentEventId?: ModelIDInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAnswerEventFilterInput | null > | null,
  or?: Array< ModelAnswerEventFilterInput | null > | null,
  not?: ModelAnswerEventFilterInput | null,
};

export type SearchableAnswerEventFilterInput = {
  id?: SearchableIDFilterInput | null,
  questionId?: SearchableIDFilterInput | null,
  value?: SearchableStringFilterInput | null,
  assessmentEventId?: SearchableIDFilterInput | null,
  deletedAt?: SearchableStringFilterInput | null,
  deletedBy?: SearchableStringFilterInput | null,
  deletedReason?: SearchableStringFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  valueType?: SearchableStringFilterInput | null,
  and?: Array< SearchableAnswerEventFilterInput | null > | null,
  or?: Array< SearchableAnswerEventFilterInput | null > | null,
  not?: SearchableAnswerEventFilterInput | null,
};

export type SearchableAnswerEventSortInput = {
  field?: SearchableAnswerEventSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableAnswerEventSortableFields {
  id = "id",
  questionId = "questionId",
  value = "value",
  assessmentEventId = "assessmentEventId",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableAnswerEventAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableAnswerEventAggregateField,
};

export enum SearchableAnswerEventAggregateField {
  id = "id",
  questionId = "questionId",
  valueType = "valueType",
  value = "value",
  assessmentEventId = "assessmentEventId",
  deletedAt = "deletedAt",
  deletedBy = "deletedBy",
  deletedReason = "deletedReason",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}


export type SearchableAnswerEventConnection = {
  __typename: "SearchableAnswerEventConnection",
  items:  Array<AnswerEvent | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type ModelAcgmeProcedureFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  acgmeCode?: ModelStringInput | null,
  simpl1Id?: ModelIntInput | null,
  deletedAt?: ModelStringInput | null,
  deletedBy?: ModelStringInput | null,
  deletedReason?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAcgmeProcedureFilterInput | null > | null,
  or?: Array< ModelAcgmeProcedureFilterInput | null > | null,
  not?: ModelAcgmeProcedureFilterInput | null,
};

export type ModelAcgmeProcedureConnection = {
  __typename: "ModelAcgmeProcedureConnection",
  items:  Array<AcgmeProcedure | null >,
  nextToken?: string | null,
};

export type ModelProgramSponsorsFilterInput = {
  id?: ModelIDInput | null,
  programID?: ModelIDInput | null,
  sponsorID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelProgramSponsorsFilterInput | null > | null,
  or?: Array< ModelProgramSponsorsFilterInput | null > | null,
  not?: ModelProgramSponsorsFilterInput | null,
};

export type ModelNetworkProgramFilterInput = {
  id?: ModelIDInput | null,
  programID?: ModelIDInput | null,
  networkID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelNetworkProgramFilterInput | null > | null,
  or?: Array< ModelNetworkProgramFilterInput | null > | null,
  not?: ModelNetworkProgramFilterInput | null,
};

export type ModelNetworkActivityFilterInput = {
  id?: ModelIDInput | null,
  networkID?: ModelIDInput | null,
  activityID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelNetworkActivityFilterInput | null > | null,
  or?: Array< ModelNetworkActivityFilterInput | null > | null,
  not?: ModelNetworkActivityFilterInput | null,
};

export type ModelAssessmentActivityFilterInput = {
  id?: ModelIDInput | null,
  assessmentID?: ModelIDInput | null,
  activityID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAssessmentActivityFilterInput | null > | null,
  or?: Array< ModelAssessmentActivityFilterInput | null > | null,
  not?: ModelAssessmentActivityFilterInput | null,
};

export type ModelActivityEventActivitiesFilterInput = {
  id?: ModelIDInput | null,
  activityID?: ModelIDInput | null,
  activityEventID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelActivityEventActivitiesFilterInput | null > | null,
  or?: Array< ModelActivityEventActivitiesFilterInput | null > | null,
  not?: ModelActivityEventActivitiesFilterInput | null,
};

export type ModelAcgmeProcedureActivityFilterInput = {
  id?: ModelIDInput | null,
  activityID?: ModelIDInput | null,
  acgmeProcedureID?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelAcgmeProcedureActivityFilterInput | null > | null,
  or?: Array< ModelAcgmeProcedureActivityFilterInput | null > | null,
  not?: ModelAcgmeProcedureActivityFilterInput | null,
};

export type AppVersions = {
  __typename: "AppVersions",
  iosRequired?: string | null,
  iosRecommended?: string | null,
  androidRequired?: string | null,
  androidRecommended?: string | null,
};

export type ModelSubscriptionInstitutionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionInstitutionFilterInput | null > | null,
  or?: Array< ModelSubscriptionInstitutionFilterInput | null > | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionProgramFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  institutionId?: ModelSubscriptionIDInput | null,
  simpl1Id?: ModelSubscriptionIntInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProgramFilterInput | null > | null,
  or?: Array< ModelSubscriptionProgramFilterInput | null > | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionNetworkFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  sponsorId?: ModelSubscriptionIDInput | null,
  acgmeEnabled?: ModelSubscriptionBooleanInput | null,
  allAttendingHistoryDisabled?: ModelSubscriptionBooleanInput | null,
  simpl1Id?: ModelSubscriptionIntInput | null,
  categoriesExcludedFromRequestFlow?: ModelSubscriptionStringInput | null,
  dashboardURL?: ModelSubscriptionStringInput | null,
  showDashboardLink?: ModelSubscriptionBooleanInput | null,
  disableClassicReports?: ModelSubscriptionBooleanInput | null,
  traineeCanRateTrainee?: ModelSubscriptionBooleanInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionNetworkFilterInput | null > | null,
  or?: Array< ModelSubscriptionNetworkFilterInput | null > | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionUserFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  email?: ModelSubscriptionStringInput | null,
  emailLower?: ModelSubscriptionStringInput | null,
  institutionId?: ModelSubscriptionIDInput | null,
  cognitoUsername?: ModelSubscriptionStringInput | null,
  firstName?: ModelSubscriptionStringInput | null,
  lastName?: ModelSubscriptionStringInput | null,
  suffix?: ModelSubscriptionStringInput | null,
  npi?: ModelSubscriptionIntInput | null,
  simplLearnId?: ModelSubscriptionStringInput | null,
  pgy?: ModelSubscriptionIntInput | null,
  lastLogin?: ModelSubscriptionStringInput | null,
  eulaAcceptedDate?: ModelSubscriptionStringInput | null,
  simpl1Id?: ModelSubscriptionIntInput | null,
  deviceToken?: ModelSubscriptionStringInput | null,
  devicePlatform?: ModelSubscriptionStringInput | null,
  inviteId?: ModelSubscriptionIDInput | null,
  jobTitle?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterInput | null > | null,
};

export type ModelSubscriptionUserInvitationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  inviteeId?: ModelSubscriptionIDInput | null,
  institutionId?: ModelSubscriptionIDInput | null,
  invitationStatus?: ModelSubscriptionStringInput | null,
  email?: ModelSubscriptionStringInput | null,
  emailLower?: ModelSubscriptionStringInput | null,
  adminId?: ModelSubscriptionIDInput | null,
  programId?: ModelSubscriptionIDInput | null,
  role?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserInvitationFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserInvitationFilterInput | null > | null,
};

export type ModelSubscriptionProgramMembershipFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  programRole?: ModelSubscriptionStringInput | null,
  traineeType?: ModelSubscriptionStringInput | null,
  programMemberId?: ModelSubscriptionIDInput | null,
  programId?: ModelSubscriptionIDInput | null,
  startDate?: ModelSubscriptionStringInput | null,
  endDate?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProgramMembershipFilterInput | null > | null,
  or?: Array< ModelSubscriptionProgramMembershipFilterInput | null > | null,
};

export type ModelSubscriptionEULATextFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  formattedText?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEULATextFilterInput | null > | null,
  or?: Array< ModelSubscriptionEULATextFilterInput | null > | null,
};

export type ModelSubscriptionMilestoneFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  shortName?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  scale?: ModelSubscriptionIntInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMilestoneFilterInput | null > | null,
  or?: Array< ModelSubscriptionMilestoneFilterInput | null > | null,
};

export type ModelSubscriptionMilestoneNetworkRatingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  activityId?: ModelSubscriptionIDInput | null,
  networkId?: ModelSubscriptionIDInput | null,
  milestoneId?: ModelSubscriptionIDInput | null,
  answerOptionId?: ModelSubscriptionIDInput | null,
  milestoneRating?: ModelSubscriptionFloatInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionMilestoneNetworkRatingFilterInput | null > | null,
  or?: Array< ModelSubscriptionMilestoneNetworkRatingFilterInput | null > | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionSponsorFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  activityLabel?: ModelSubscriptionStringInput | null,
  autoAssignActivities?: ModelSubscriptionIDInput | null,
  dashboardURL?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionSponsorFilterInput | null > | null,
  or?: Array< ModelSubscriptionSponsorFilterInput | null > | null,
};

export type ModelSubscriptionAssessmentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  instrumentId?: ModelSubscriptionIDInput | null,
  expirationDurationHours?: ModelSubscriptionIntInput | null,
  sponsorId?: ModelSubscriptionIDInput | null,
  requireTraineeSelfAssessment?: ModelSubscriptionBooleanInput | null,
  authorId?: ModelSubscriptionIDInput | null,
  published?: ModelSubscriptionBooleanInput | null,
  archived?: ModelSubscriptionBooleanInput | null,
  version?: ModelSubscriptionStringInput | null,
  creationDurationHours?: ModelSubscriptionIntInput | null,
  showFeedbackQuestionsToTrainees?: ModelSubscriptionBooleanInput | null,
  sendEmailForSelfAssessment?: ModelSubscriptionBooleanInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAssessmentFilterInput | null > | null,
  or?: Array< ModelSubscriptionAssessmentFilterInput | null > | null,
};

export type ModelSubscriptionInstrumentFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  authorId?: ModelSubscriptionIDInput | null,
  version?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionInstrumentFilterInput | null > | null,
  or?: Array< ModelSubscriptionInstrumentFilterInput | null > | null,
};

export type ModelSubscriptionActivityFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  assessmentId?: ModelSubscriptionIDInput | null,
  sponsorId?: ModelSubscriptionIDInput | null,
  authorId?: ModelSubscriptionIDInput | null,
  version?: ModelSubscriptionStringInput | null,
  simpl1Id?: ModelSubscriptionIntInput | null,
  categories?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionActivityFilterInput | null > | null,
  or?: Array< ModelSubscriptionActivityFilterInput | null > | null,
  activitySubActivitiesId?: ModelSubscriptionIDInput | null,
};

export type ModelSubscriptionQuestionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  defaultPrompt?: ModelSubscriptionStringInput | null,
  required?: ModelSubscriptionBooleanInput | null,
  selfAssessmentPrompt?: ModelSubscriptionStringInput | null,
  sortingIndex?: ModelSubscriptionIntInput | null,
  title?: ModelSubscriptionStringInput | null,
  helpText?: ModelSubscriptionStringInput | null,
  inputType?: ModelSubscriptionStringInput | null,
  instrumentId?: ModelSubscriptionIDInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionQuestionFilterInput | null > | null,
  or?: Array< ModelSubscriptionQuestionFilterInput | null > | null,
};

export type ModelSubscriptionAnswerOptionFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  anchor?: ModelSubscriptionStringInput | null,
  sortingIndex?: ModelSubscriptionIntInput | null,
  helpText?: ModelSubscriptionStringInput | null,
  value?: ModelSubscriptionStringInput | null,
  questionId?: ModelSubscriptionIDInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAnswerOptionFilterInput | null > | null,
  or?: Array< ModelSubscriptionAnswerOptionFilterInput | null > | null,
};

export type ModelSubscriptionActivityEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  creatorId?: ModelSubscriptionIDInput | null,
  programId?: ModelSubscriptionIDInput | null,
  activityEventDate?: ModelSubscriptionStringInput | null,
  notes?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionActivityEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionActivityEventFilterInput | null > | null,
};

export type ModelSubscriptionActivityParticipantFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  activityEventId?: ModelSubscriptionIDInput | null,
  programId?: ModelSubscriptionIDInput | null,
  currentPGY?: ModelSubscriptionIntInput | null,
  currentRole?: ModelSubscriptionStringInput | null,
  currentTraineeType?: ModelSubscriptionStringInput | null,
  currentJobTitle?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionActivityParticipantFilterInput | null > | null,
  or?: Array< ModelSubscriptionActivityParticipantFilterInput | null > | null,
};

export type ModelSubscriptionAssessmentEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  subjectId?: ModelSubscriptionIDInput | null,
  subjectUserId?: ModelSubscriptionIDInput | null,
  raterId?: ModelSubscriptionIDInput | null,
  raterUserId?: ModelSubscriptionIDInput | null,
  activityId?: ModelSubscriptionIDInput | null,
  activityEventId?: ModelSubscriptionIDInput | null,
  programId?: ModelSubscriptionIDInput | null,
  assessmentId?: ModelSubscriptionIDInput | null,
  expirationDate?: ModelSubscriptionStringInput | null,
  completionDate?: ModelSubscriptionStringInput | null,
  declined?: ModelSubscriptionStringInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAssessmentEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionAssessmentEventFilterInput | null > | null,
};

export type ModelSubscriptionAnswerEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  questionId?: ModelSubscriptionIDInput | null,
  valueType?: ModelSubscriptionStringInput | null,
  value?: ModelSubscriptionStringInput | null,
  assessmentEventId?: ModelSubscriptionIDInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAnswerEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionAnswerEventFilterInput | null > | null,
};

export type ModelSubscriptionAcgmeProcedureFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  acgmeCode?: ModelSubscriptionStringInput | null,
  simpl1Id?: ModelSubscriptionIntInput | null,
  deletedAt?: ModelSubscriptionStringInput | null,
  deletedBy?: ModelSubscriptionStringInput | null,
  deletedReason?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAcgmeProcedureFilterInput | null > | null,
  or?: Array< ModelSubscriptionAcgmeProcedureFilterInput | null > | null,
};

export type ModelSubscriptionProgramSponsorsFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  programID?: ModelSubscriptionIDInput | null,
  sponsorID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionProgramSponsorsFilterInput | null > | null,
  or?: Array< ModelSubscriptionProgramSponsorsFilterInput | null > | null,
};

export type ModelSubscriptionNetworkProgramFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  programID?: ModelSubscriptionIDInput | null,
  networkID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionNetworkProgramFilterInput | null > | null,
  or?: Array< ModelSubscriptionNetworkProgramFilterInput | null > | null,
};

export type ModelSubscriptionNetworkActivityFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  networkID?: ModelSubscriptionIDInput | null,
  activityID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionNetworkActivityFilterInput | null > | null,
  or?: Array< ModelSubscriptionNetworkActivityFilterInput | null > | null,
};

export type ModelSubscriptionAssessmentActivityFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  assessmentID?: ModelSubscriptionIDInput | null,
  activityID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAssessmentActivityFilterInput | null > | null,
  or?: Array< ModelSubscriptionAssessmentActivityFilterInput | null > | null,
};

export type ModelSubscriptionActivityEventActivitiesFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  activityID?: ModelSubscriptionIDInput | null,
  activityEventID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionActivityEventActivitiesFilterInput | null > | null,
  or?: Array< ModelSubscriptionActivityEventActivitiesFilterInput | null > | null,
};

export type ModelSubscriptionAcgmeProcedureActivityFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  activityID?: ModelSubscriptionIDInput | null,
  acgmeProcedureID?: ModelSubscriptionIDInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionAcgmeProcedureActivityFilterInput | null > | null,
  or?: Array< ModelSubscriptionAcgmeProcedureActivityFilterInput | null > | null,
};

export type ListProgramMembershipsByUserIdQueryVariables = {
  programMemberId?: string | null,
};

export type ListProgramMembershipsByUserIdQuery = {
  listProgramMemberships?:  {
    __typename: "ModelProgramMembershipConnection",
    items:  Array< {
      __typename: "ProgramMembership",
      id: string,
      programRole: ProgramRole,
      programMember?:  {
        __typename: "User",
        id: string,
        firstName?: string | null,
        lastName?: string | null,
        email: string,
        npi?: number | null,
        pgy?: number | null,
      } | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
      } | null,
    } | null >,
  } | null,
};

export type GetUserInvitationUnauthedQueryVariables = {
  id: string,
};

export type GetUserInvitationUnauthedQuery = {
  getUserInvitation?:  {
    __typename: "UserInvitation",
    id: string,
    email?: string | null,
    institutionId: string,
    invitationStatus: InvitationStatus,
    inviteeId?: string | null,
    programId?: string | null,
    role?: ProgramRole | null,
  } | null,
};

export type GetUserInvitationsByEmailUnauthedQueryVariables = {
  emailLower: string,
};

export type GetUserInvitationsByEmailUnauthedQuery = {
  userInvitationsByEmailLower?:  {
    __typename: "ModelUserInvitationConnection",
    items:  Array< {
      __typename: "UserInvitation",
      id: string,
      email?: string | null,
    } | null >,
  } | null,
};

export type assessmentHistoryForCCCQueryVariables = {
  input?: PaginatableAssessmentHistoryArgs | null,
};

export type assessmentHistoryForCCCQuery = {
  paginatableAssessmentHistory?:  {
    __typename: "PaginatableAssessmentHistoryResult",
    nextToken?: string | null,
    total?: number | null,
    items?:  Array< {
      __typename: "AssessmentEvent",
      id: string,
      subjectId?: string | null,
      subject?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subjectUserId?: string | null,
      raterId?: string | null,
      rater?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      raterUserId?: string | null,
      activityId?: string | null,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      activityEventId?: string | null,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        simpl1Id?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answers?:  {
        __typename: "ModelAnswerEventConnection",
        items:  Array< {
          __typename: "AnswerEvent",
          id: string,
          questionId?: string | null,
          question?:  {
            __typename: "Question",
            id: string,
            defaultPrompt?: string | null,
            required?: boolean | null,
            selfAssessmentPrompt?: string | null,
            sortingIndex?: number | null,
            answerOptions?:  {
              __typename: "ModelAnswerOptionConnection",
              items:  Array< {
                __typename: "AnswerOption",
                anchor?: string | null,
                value?: string | null,
              } | null >,
            } | null,
            title?: string | null,
            helpText?: string | null,
            inputType?: InputType | null,
            instrumentId: string,
            createdAt: string,
            updatedAt: string,
          } | null,
          valueType?: ValueType | null,
          value?: string | null,
          assessmentEventId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDate?: string | null,
      completionDate?: string | null,
      declined?: ReasonForDecline | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
  } | null,
};

export type ActivitiesByUsersForCreateQueryVariables = {
  input?: PaginatableActivitiesByUsersArgs | null,
};

export type ActivitiesByUsersForCreateQuery = {
  paginatableActivitiesByUsers?:  {
    __typename: "PaginatableActivitiesByUsersResult",
    nextPage?: number | null,
    total?: number | null,
    error?: string | null,
    activities?:  Array< {
      __typename: "ActivitiesByUsersActivity",
      id: string,
      title?: string | null,
      description?: string | null,
      categories?: Array< string > | null,
      assessmentId?: string | null,
      sponsor?:  {
        __typename: "SponsorMinimal",
        id: string,
        activityLabel?: string | null,
        branding?:  {
          __typename: "SponsorBranding",
          colors?:  {
            __typename: "SponsorColors",
            primary?: string | null,
            secondary?: string | null,
            light?: string | null,
          } | null,
          logos?:  {
            __typename: "SponsorLogos",
            fullMono?: string | null,
            fullColor?: string | null,
            squareMono?: string | null,
            squareColor?: string | null,
            email?: string | null,
          } | null,
        } | null,
        description?: string | null,
        name?: string | null,
      } | null,
      programIds?: Array< string | null > | null,
    } | null > | null,
  } | null,
};

export type PendingAssessmentsForHomeScreenQueryVariables = {
  userId?: string | null,
};

export type PendingAssessmentsForHomeScreenQuery = {
  usersPendingAssessments?:  Array< {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        pgy?: number | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        programId?: string | null,
        activityEventDate?: string | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      assessmentId?: string | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
          colors?:  {
            __typename: "SponsorColors",
            primary?: string | null,
            secondary?: string | null,
            light?: string | null,
          } | null,
          logos?:  {
            __typename: "SponsorLogos",
            fullMono?: string | null,
            fullColor?: string | null,
            squareMono?: string | null,
            squareColor?: string | null,
            email?: string | null,
          } | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      version?: string | null,
      simpl1Id?: number | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      programId?: string | null,
      activityEventDate?: string | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    createdAt: string,
    updatedAt: string,
  } | null > | null,
};

export type GetAssessmentEventForCompletionQueryVariables = {
  id: string,
};

export type GetAssessmentEventForCompletionQuery = {
  getAssessmentEvent?:  {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        pgy?: number | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        programId?: string | null,
        activityEventDate?: string | null,
        notes?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      assessmentId?: string | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        branding?:  {
          __typename: "SponsorBranding",
          colors?:  {
            __typename: "SponsorColors",
            primary?: string | null,
            secondary?: string | null,
            light?: string | null,
          } | null,
          logos?:  {
            __typename: "SponsorLogos",
            fullMono?: string | null,
            fullColor?: string | null,
            squareMono?: string | null,
            squareColor?: string | null,
            email?: string | null,
          } | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      version?: string | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      programId?: string | null,
      activityEventDate?: string | null,
      notes?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type siblingUsersForCreateQueryVariables = {
  input?: PaginatableSiblingUsersArgs | null,
};

export type siblingUsersForCreateQuery = {
  paginatableSiblingUsers?:  {
    __typename: "PaginatableSiblingUsersResult",
    nextToken?: string | null,
    total?: number | null,
    items?:  Array< {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      pgy?: number | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          program?:  {
            __typename: "Program",
            id: string,
            name: string,
            description?: string | null,
            institutionId: string,
            simpl1Id?: number | null,
            createdAt: string,
            updatedAt: string,
          } | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
  } | null,
};

export type getProgramForSiblingUsersQueryVariables = {
  id: string,
};

export type getProgramForSiblingUsersQuery = {
  getProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    networks?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        network:  {
          __typename: "Network",
          traineeCanRateTrainee?: boolean | null,
        },
      } | null >,
    } | null,
  } | null,
};

export type getUserForSubmitAssessmentRequestQueryVariables = {
  id: string,
};

export type getUserForSubmitAssessmentRequestQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    email: string,
    firstName?: string | null,
    lastName?: string | null,
    pgy?: number | null,
    jobTitle?: string | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programId: string,
        startDate?: string | null,
        endDate?: string | null,
      } | null >,
    } | null,
  } | null,
};

export type getActivityForSubmitAssessmentRequestQueryVariables = {
  id: string,
};

export type getActivityForSubmitAssessmentRequestQuery = {
  getActivity?:  {
    __typename: "Activity",
    id: string,
    title?: string | null,
    description?: string | null,
    assessmentId?: string | null,
    deletedAt?: string | null,
  } | null,
};

export type createActivityEventForSubmitAssessmentRequestMutationVariables = {
  input: CreateActivityEventInput,
};

export type createActivityEventForSubmitAssessmentRequestMutation = {
  createActivityEvent?:  {
    __typename: "ActivityEvent",
    id: string,
    creatorId?: string | null,
    programId?: string | null,
    activityEventDate?: string | null,
    notes?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type getAssessmentForSubmitAssessmentRequestQueryVariables = {
  id: string,
};

export type getAssessmentForSubmitAssessmentRequestQuery = {
  getAssessment?:  {
    __typename: "Assessment",
    id: string,
    title?: string | null,
    description?: string | null,
    instrumentId?: string | null,
    expirationDurationHours?: number | null,
    sponsorId?: string | null,
    requireTraineeSelfAssessment?: boolean | null,
    authorId?: string | null,
    published?: boolean | null,
    archived?: boolean | null,
    version?: string | null,
    creationDurationHours?: number | null,
    showFeedbackQuestionsToTrainees?: boolean | null,
    sendEmailForSelfAssessment?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProgramMembershipsMutationVariables = {
  input?: UpdateProgramMembershipsInput | null,
};

export type UpdateProgramMembershipsMutation = {
  updateProgramMemberships?:  {
    __typename: "GenericMutationResult",
    success: boolean,
    message?: string | null,
    error?: string | null,
  } | null,
};

export type SubmitAssessmentRequestMutationVariables = {
  input?: SubmitAssessmentRequestInput | null,
};

export type SubmitAssessmentRequestMutation = {
  submitAssessmentRequest?:  {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type BulkUpdatePgyMutationVariables = {
  users?: Array< UpdatePgyInput | null > | null,
};

export type BulkUpdatePgyMutation = {
  bulkUpdatePgy?:  Array< {
    __typename: "User",
    id: string,
    email: string,
    emailLower?: string | null,
    institutionId?: string | null,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoUsername?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    suffix?: string | null,
    npi?: number | null,
    simplLearnId?: string | null,
    pgy?: number | null,
    settings?:  {
      __typename: "UserSettings",
      sendEmail?: boolean | null,
      sendPushNotifications?: boolean | null,
    } | null,
    lastLogin?: string | null,
    eulaAcceptedDate?: string | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deviceToken?: string | null,
    devicePlatform?: DevicePlatform | null,
    inviteId?: string | null,
    invite?:  {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null > | null,
};

export type CompleteAssessmentRequestMutationVariables = {
  input?: CompleteAssesessmentRequestInput | null,
};

export type CompleteAssessmentRequestMutation = {
  completeAssessmentRequest?:  {
    __typename: "CompletedAssessmentEvent",
    assessmentEvent?:  {
      __typename: "AssessmentEvent",
      id: string,
      subjectId?: string | null,
      subject?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subjectUserId?: string | null,
      raterId?: string | null,
      rater?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      raterUserId?: string | null,
      activityId?: string | null,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      activityEventId?: string | null,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answers?:  {
        __typename: "ModelAnswerEventConnection",
        items:  Array< {
          __typename: "AnswerEvent",
          id: string,
          questionId?: string | null,
          valueType?: ValueType | null,
          value?: string | null,
          assessmentEventId?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDate?: string | null,
      completionDate?: string | null,
      declined?: ReasonForDecline | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    acgmeEnabled?: boolean | null,
  } | null,
};

export type DeclineAssessmentRequestMutationVariables = {
  input?: DeclineAssessmentRequestInput | null,
};

export type DeclineAssessmentRequestMutation = {
  declineAssessmentRequest?:  {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateInstitutionMutationVariables = {
  input: CreateInstitutionInput,
  condition?: ModelInstitutionConditionInput | null,
};

export type CreateInstitutionMutation = {
  createInstitution?:  {
    __typename: "Institution",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramConnection",
      items:  Array< {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateInstitutionMutationVariables = {
  input: UpdateInstitutionInput,
  condition?: ModelInstitutionConditionInput | null,
};

export type UpdateInstitutionMutation = {
  updateInstitution?:  {
    __typename: "Institution",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramConnection",
      items:  Array< {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteInstitutionMutationVariables = {
  input: DeleteInstitutionInput,
  condition?: ModelInstitutionConditionInput | null,
};

export type DeleteInstitutionMutation = {
  deleteInstitution?:  {
    __typename: "Institution",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramConnection",
      items:  Array< {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProgramMutationVariables = {
  input: CreateProgramInput,
  condition?: ModelProgramConditionInput | null,
};

export type CreateProgramMutation = {
  createProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    institutionId: string,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsors?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProgramMutationVariables = {
  input: UpdateProgramInput,
  condition?: ModelProgramConditionInput | null,
};

export type UpdateProgramMutation = {
  updateProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    institutionId: string,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsors?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProgramMutationVariables = {
  input: DeleteProgramInput,
  condition?: ModelProgramConditionInput | null,
};

export type DeleteProgramMutation = {
  deleteProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    institutionId: string,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsors?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateNetworkMutationVariables = {
  input: CreateNetworkInput,
  condition?: ModelNetworkConditionInput | null,
};

export type CreateNetworkMutation = {
  createNetwork?:  {
    __typename: "Network",
    id: string,
    name: string,
    sponsorId: string,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programs?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeEnabled?: boolean | null,
    allAttendingHistoryDisabled?: boolean | null,
    simpl1Id?: number | null,
    categoriesExcludedFromRequestFlow?: Array< string | null > | null,
    dashboardURL?: string | null,
    showDashboardLink?: boolean | null,
    disableClassicReports?: boolean | null,
    traineeCanRateTrainee?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateNetworkMutationVariables = {
  input: UpdateNetworkInput,
  condition?: ModelNetworkConditionInput | null,
};

export type UpdateNetworkMutation = {
  updateNetwork?:  {
    __typename: "Network",
    id: string,
    name: string,
    sponsorId: string,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programs?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeEnabled?: boolean | null,
    allAttendingHistoryDisabled?: boolean | null,
    simpl1Id?: number | null,
    categoriesExcludedFromRequestFlow?: Array< string | null > | null,
    dashboardURL?: string | null,
    showDashboardLink?: boolean | null,
    disableClassicReports?: boolean | null,
    traineeCanRateTrainee?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteNetworkMutationVariables = {
  input: DeleteNetworkInput,
  condition?: ModelNetworkConditionInput | null,
};

export type DeleteNetworkMutation = {
  deleteNetwork?:  {
    __typename: "Network",
    id: string,
    name: string,
    sponsorId: string,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programs?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeEnabled?: boolean | null,
    allAttendingHistoryDisabled?: boolean | null,
    simpl1Id?: number | null,
    categoriesExcludedFromRequestFlow?: Array< string | null > | null,
    dashboardURL?: string | null,
    showDashboardLink?: boolean | null,
    disableClassicReports?: boolean | null,
    traineeCanRateTrainee?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename: "User",
    id: string,
    email: string,
    emailLower?: string | null,
    institutionId?: string | null,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoUsername?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    suffix?: string | null,
    npi?: number | null,
    simplLearnId?: string | null,
    pgy?: number | null,
    settings?:  {
      __typename: "UserSettings",
      sendEmail?: boolean | null,
      sendPushNotifications?: boolean | null,
    } | null,
    lastLogin?: string | null,
    eulaAcceptedDate?: string | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deviceToken?: string | null,
    devicePlatform?: DevicePlatform | null,
    inviteId?: string | null,
    invite?:  {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserMutationVariables = {
  input: UpdateUserInput,
  condition?: ModelUserConditionInput | null,
};

export type UpdateUserMutation = {
  updateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    emailLower?: string | null,
    institutionId?: string | null,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoUsername?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    suffix?: string | null,
    npi?: number | null,
    simplLearnId?: string | null,
    pgy?: number | null,
    settings?:  {
      __typename: "UserSettings",
      sendEmail?: boolean | null,
      sendPushNotifications?: boolean | null,
    } | null,
    lastLogin?: string | null,
    eulaAcceptedDate?: string | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deviceToken?: string | null,
    devicePlatform?: DevicePlatform | null,
    inviteId?: string | null,
    invite?:  {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserMutationVariables = {
  input: DeleteUserInput,
  condition?: ModelUserConditionInput | null,
};

export type DeleteUserMutation = {
  deleteUser?:  {
    __typename: "User",
    id: string,
    email: string,
    emailLower?: string | null,
    institutionId?: string | null,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoUsername?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    suffix?: string | null,
    npi?: number | null,
    simplLearnId?: string | null,
    pgy?: number | null,
    settings?:  {
      __typename: "UserSettings",
      sendEmail?: boolean | null,
      sendPushNotifications?: boolean | null,
    } | null,
    lastLogin?: string | null,
    eulaAcceptedDate?: string | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deviceToken?: string | null,
    devicePlatform?: DevicePlatform | null,
    inviteId?: string | null,
    invite?:  {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateUserInvitationMutationVariables = {
  input: CreateUserInvitationInput,
  condition?: ModelUserInvitationConditionInput | null,
};

export type CreateUserInvitationMutation = {
  createUserInvitation?:  {
    __typename: "UserInvitation",
    id: string,
    inviteeId?: string | null,
    invitee:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    institutionId: string,
    invitationStatus: InvitationStatus,
    email?: string | null,
    emailLower?: string | null,
    adminId?: string | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    role?: ProgramRole | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateUserInvitationMutationVariables = {
  input: UpdateUserInvitationInput,
  condition?: ModelUserInvitationConditionInput | null,
};

export type UpdateUserInvitationMutation = {
  updateUserInvitation?:  {
    __typename: "UserInvitation",
    id: string,
    inviteeId?: string | null,
    invitee:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    institutionId: string,
    invitationStatus: InvitationStatus,
    email?: string | null,
    emailLower?: string | null,
    adminId?: string | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    role?: ProgramRole | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteUserInvitationMutationVariables = {
  input: DeleteUserInvitationInput,
  condition?: ModelUserInvitationConditionInput | null,
};

export type DeleteUserInvitationMutation = {
  deleteUserInvitation?:  {
    __typename: "UserInvitation",
    id: string,
    inviteeId?: string | null,
    invitee:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    institutionId: string,
    invitationStatus: InvitationStatus,
    email?: string | null,
    emailLower?: string | null,
    adminId?: string | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    role?: ProgramRole | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProgramMembershipMutationVariables = {
  input: CreateProgramMembershipInput,
  condition?: ModelProgramMembershipConditionInput | null,
};

export type CreateProgramMembershipMutation = {
  createProgramMembership?:  {
    __typename: "ProgramMembership",
    id: string,
    programRole: ProgramRole,
    traineeType?: TraineeType | null,
    programMemberId: string,
    programId: string,
    programMember?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate?: string | null,
    endDate?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProgramMembershipMutationVariables = {
  input: UpdateProgramMembershipInput,
  condition?: ModelProgramMembershipConditionInput | null,
};

export type UpdateProgramMembershipMutation = {
  updateProgramMembership?:  {
    __typename: "ProgramMembership",
    id: string,
    programRole: ProgramRole,
    traineeType?: TraineeType | null,
    programMemberId: string,
    programId: string,
    programMember?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate?: string | null,
    endDate?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProgramMembershipMutationVariables = {
  input: DeleteProgramMembershipInput,
  condition?: ModelProgramMembershipConditionInput | null,
};

export type DeleteProgramMembershipMutation = {
  deleteProgramMembership?:  {
    __typename: "ProgramMembership",
    id: string,
    programRole: ProgramRole,
    traineeType?: TraineeType | null,
    programMemberId: string,
    programId: string,
    programMember?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate?: string | null,
    endDate?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateEULATextMutationVariables = {
  input: CreateEULATextInput,
  condition?: ModelEULATextConditionInput | null,
};

export type CreateEULATextMutation = {
  createEULAText?:  {
    __typename: "EULAText",
    id: string,
    formattedText: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateEULATextMutationVariables = {
  input: UpdateEULATextInput,
  condition?: ModelEULATextConditionInput | null,
};

export type UpdateEULATextMutation = {
  updateEULAText?:  {
    __typename: "EULAText",
    id: string,
    formattedText: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteEULATextMutationVariables = {
  input: DeleteEULATextInput,
  condition?: ModelEULATextConditionInput | null,
};

export type DeleteEULATextMutation = {
  deleteEULAText?:  {
    __typename: "EULAText",
    id: string,
    formattedText: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMilestoneMutationVariables = {
  input: CreateMilestoneInput,
  condition?: ModelMilestoneConditionInput | null,
};

export type CreateMilestoneMutation = {
  createMilestone?:  {
    __typename: "Milestone",
    id: string,
    shortName: string,
    name: string,
    description?: string | null,
    scale: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMilestoneMutationVariables = {
  input: UpdateMilestoneInput,
  condition?: ModelMilestoneConditionInput | null,
};

export type UpdateMilestoneMutation = {
  updateMilestone?:  {
    __typename: "Milestone",
    id: string,
    shortName: string,
    name: string,
    description?: string | null,
    scale: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMilestoneMutationVariables = {
  input: DeleteMilestoneInput,
  condition?: ModelMilestoneConditionInput | null,
};

export type DeleteMilestoneMutation = {
  deleteMilestone?:  {
    __typename: "Milestone",
    id: string,
    shortName: string,
    name: string,
    description?: string | null,
    scale: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateMilestoneNetworkRatingMutationVariables = {
  input: CreateMilestoneNetworkRatingInput,
  condition?: ModelMilestoneNetworkRatingConditionInput | null,
};

export type CreateMilestoneNetworkRatingMutation = {
  createMilestoneNetworkRating?:  {
    __typename: "MilestoneNetworkRating",
    id: string,
    activityId: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    networkId: string,
    network?:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneId: string,
    milestone?:  {
      __typename: "Milestone",
      id: string,
      shortName: string,
      name: string,
      description?: string | null,
      scale: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answerOptionId: string,
    answerOption?:  {
      __typename: "AnswerOption",
      id: string,
      anchor?: string | null,
      sortingIndex?: number | null,
      helpText?: string | null,
      value?: string | null,
      questionId: string,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneRating: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateMilestoneNetworkRatingMutationVariables = {
  input: UpdateMilestoneNetworkRatingInput,
  condition?: ModelMilestoneNetworkRatingConditionInput | null,
};

export type UpdateMilestoneNetworkRatingMutation = {
  updateMilestoneNetworkRating?:  {
    __typename: "MilestoneNetworkRating",
    id: string,
    activityId: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    networkId: string,
    network?:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneId: string,
    milestone?:  {
      __typename: "Milestone",
      id: string,
      shortName: string,
      name: string,
      description?: string | null,
      scale: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answerOptionId: string,
    answerOption?:  {
      __typename: "AnswerOption",
      id: string,
      anchor?: string | null,
      sortingIndex?: number | null,
      helpText?: string | null,
      value?: string | null,
      questionId: string,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneRating: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteMilestoneNetworkRatingMutationVariables = {
  input: DeleteMilestoneNetworkRatingInput,
  condition?: ModelMilestoneNetworkRatingConditionInput | null,
};

export type DeleteMilestoneNetworkRatingMutation = {
  deleteMilestoneNetworkRating?:  {
    __typename: "MilestoneNetworkRating",
    id: string,
    activityId: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    networkId: string,
    network?:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneId: string,
    milestone?:  {
      __typename: "Milestone",
      id: string,
      shortName: string,
      name: string,
      description?: string | null,
      scale: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answerOptionId: string,
    answerOption?:  {
      __typename: "AnswerOption",
      id: string,
      anchor?: string | null,
      sortingIndex?: number | null,
      helpText?: string | null,
      value?: string | null,
      questionId: string,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneRating: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateSponsorMutationVariables = {
  input: CreateSponsorInput,
  condition?: ModelSponsorConditionInput | null,
};

export type CreateSponsorMutation = {
  createSponsor?:  {
    __typename: "Sponsor",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkConnection",
      items:  Array< {
        __typename: "Network",
        id: string,
        name: string,
        sponsorId: string,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programs?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeEnabled?: boolean | null,
        allAttendingHistoryDisabled?: boolean | null,
        simpl1Id?: number | null,
        categoriesExcludedFromRequestFlow?: Array< string | null > | null,
        dashboardURL?: string | null,
        showDashboardLink?: boolean | null,
        disableClassicReports?: boolean | null,
        traineeCanRateTrainee?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    branding?:  {
      __typename: "SponsorBranding",
      colors?:  {
        __typename: "SponsorColors",
        primary?: string | null,
        secondary?: string | null,
        light?: string | null,
      } | null,
      logos?:  {
        __typename: "SponsorLogos",
        fullMono?: string | null,
        fullColor?: string | null,
        squareMono?: string | null,
        squareColor?: string | null,
        email?: string | null,
      } | null,
    } | null,
    activityLabel?: string | null,
    autoAssignActivities?: Array< string > | null,
    dashboardURL?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateSponsorMutationVariables = {
  input: UpdateSponsorInput,
  condition?: ModelSponsorConditionInput | null,
};

export type UpdateSponsorMutation = {
  updateSponsor?:  {
    __typename: "Sponsor",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkConnection",
      items:  Array< {
        __typename: "Network",
        id: string,
        name: string,
        sponsorId: string,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programs?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeEnabled?: boolean | null,
        allAttendingHistoryDisabled?: boolean | null,
        simpl1Id?: number | null,
        categoriesExcludedFromRequestFlow?: Array< string | null > | null,
        dashboardURL?: string | null,
        showDashboardLink?: boolean | null,
        disableClassicReports?: boolean | null,
        traineeCanRateTrainee?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    branding?:  {
      __typename: "SponsorBranding",
      colors?:  {
        __typename: "SponsorColors",
        primary?: string | null,
        secondary?: string | null,
        light?: string | null,
      } | null,
      logos?:  {
        __typename: "SponsorLogos",
        fullMono?: string | null,
        fullColor?: string | null,
        squareMono?: string | null,
        squareColor?: string | null,
        email?: string | null,
      } | null,
    } | null,
    activityLabel?: string | null,
    autoAssignActivities?: Array< string > | null,
    dashboardURL?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteSponsorMutationVariables = {
  input: DeleteSponsorInput,
  condition?: ModelSponsorConditionInput | null,
};

export type DeleteSponsorMutation = {
  deleteSponsor?:  {
    __typename: "Sponsor",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkConnection",
      items:  Array< {
        __typename: "Network",
        id: string,
        name: string,
        sponsorId: string,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programs?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeEnabled?: boolean | null,
        allAttendingHistoryDisabled?: boolean | null,
        simpl1Id?: number | null,
        categoriesExcludedFromRequestFlow?: Array< string | null > | null,
        dashboardURL?: string | null,
        showDashboardLink?: boolean | null,
        disableClassicReports?: boolean | null,
        traineeCanRateTrainee?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    branding?:  {
      __typename: "SponsorBranding",
      colors?:  {
        __typename: "SponsorColors",
        primary?: string | null,
        secondary?: string | null,
        light?: string | null,
      } | null,
      logos?:  {
        __typename: "SponsorLogos",
        fullMono?: string | null,
        fullColor?: string | null,
        squareMono?: string | null,
        squareColor?: string | null,
        email?: string | null,
      } | null,
    } | null,
    activityLabel?: string | null,
    autoAssignActivities?: Array< string > | null,
    dashboardURL?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAssessmentMutationVariables = {
  input: CreateAssessmentInput,
  condition?: ModelAssessmentConditionInput | null,
};

export type CreateAssessmentMutation = {
  createAssessment?:  {
    __typename: "Assessment",
    id: string,
    title?: string | null,
    description?: string | null,
    instrumentId?: string | null,
    instrument?:  {
      __typename: "Instrument",
      id: string,
      title?: string | null,
      description?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    multiActivities?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDurationHours?: number | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requireTraineeSelfAssessment?: boolean | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    published?: boolean | null,
    archived?: boolean | null,
    version?: string | null,
    creationDurationHours?: number | null,
    showFeedbackQuestionsToTrainees?: boolean | null,
    sendEmailForSelfAssessment?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAssessmentMutationVariables = {
  input: UpdateAssessmentInput,
  condition?: ModelAssessmentConditionInput | null,
};

export type UpdateAssessmentMutation = {
  updateAssessment?:  {
    __typename: "Assessment",
    id: string,
    title?: string | null,
    description?: string | null,
    instrumentId?: string | null,
    instrument?:  {
      __typename: "Instrument",
      id: string,
      title?: string | null,
      description?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    multiActivities?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDurationHours?: number | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requireTraineeSelfAssessment?: boolean | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    published?: boolean | null,
    archived?: boolean | null,
    version?: string | null,
    creationDurationHours?: number | null,
    showFeedbackQuestionsToTrainees?: boolean | null,
    sendEmailForSelfAssessment?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAssessmentMutationVariables = {
  input: DeleteAssessmentInput,
  condition?: ModelAssessmentConditionInput | null,
};

export type DeleteAssessmentMutation = {
  deleteAssessment?:  {
    __typename: "Assessment",
    id: string,
    title?: string | null,
    description?: string | null,
    instrumentId?: string | null,
    instrument?:  {
      __typename: "Instrument",
      id: string,
      title?: string | null,
      description?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    multiActivities?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDurationHours?: number | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requireTraineeSelfAssessment?: boolean | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    published?: boolean | null,
    archived?: boolean | null,
    version?: string | null,
    creationDurationHours?: number | null,
    showFeedbackQuestionsToTrainees?: boolean | null,
    sendEmailForSelfAssessment?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateInstrumentMutationVariables = {
  input: CreateInstrumentInput,
  condition?: ModelInstrumentConditionInput | null,
};

export type CreateInstrumentMutation = {
  createInstrument?:  {
    __typename: "Instrument",
    id: string,
    title?: string | null,
    description?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        defaultPrompt?: string | null,
        required?: boolean | null,
        selfAssessmentPrompt?: string | null,
        sortingIndex?: number | null,
        title?: string | null,
        helpText?: string | null,
        inputType?: InputType | null,
        instrumentId: string,
        answerOptions?:  {
          __typename: "ModelAnswerOptionConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateInstrumentMutationVariables = {
  input: UpdateInstrumentInput,
  condition?: ModelInstrumentConditionInput | null,
};

export type UpdateInstrumentMutation = {
  updateInstrument?:  {
    __typename: "Instrument",
    id: string,
    title?: string | null,
    description?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        defaultPrompt?: string | null,
        required?: boolean | null,
        selfAssessmentPrompt?: string | null,
        sortingIndex?: number | null,
        title?: string | null,
        helpText?: string | null,
        inputType?: InputType | null,
        instrumentId: string,
        answerOptions?:  {
          __typename: "ModelAnswerOptionConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteInstrumentMutationVariables = {
  input: DeleteInstrumentInput,
  condition?: ModelInstrumentConditionInput | null,
};

export type DeleteInstrumentMutation = {
  deleteInstrument?:  {
    __typename: "Instrument",
    id: string,
    title?: string | null,
    description?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        defaultPrompt?: string | null,
        required?: boolean | null,
        selfAssessmentPrompt?: string | null,
        sortingIndex?: number | null,
        title?: string | null,
        helpText?: string | null,
        inputType?: InputType | null,
        instrumentId: string,
        answerOptions?:  {
          __typename: "ModelAnswerOptionConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateActivityMutationVariables = {
  input: CreateActivityInput,
  condition?: ModelActivityConditionInput | null,
};

export type CreateActivityMutation = {
  createActivity?:  {
    __typename: "Activity",
    id: string,
    title?: string | null,
    description?: string | null,
    subActivities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessments?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activityEvents?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    networks?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeProcedures?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    categories?: Array< string > | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
    activitySubActivitiesId?: string | null,
  } | null,
};

export type UpdateActivityMutationVariables = {
  input: UpdateActivityInput,
  condition?: ModelActivityConditionInput | null,
};

export type UpdateActivityMutation = {
  updateActivity?:  {
    __typename: "Activity",
    id: string,
    title?: string | null,
    description?: string | null,
    subActivities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessments?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activityEvents?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    networks?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeProcedures?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    categories?: Array< string > | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
    activitySubActivitiesId?: string | null,
  } | null,
};

export type DeleteActivityMutationVariables = {
  input: DeleteActivityInput,
  condition?: ModelActivityConditionInput | null,
};

export type DeleteActivityMutation = {
  deleteActivity?:  {
    __typename: "Activity",
    id: string,
    title?: string | null,
    description?: string | null,
    subActivities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessments?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activityEvents?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    networks?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeProcedures?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    categories?: Array< string > | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
    activitySubActivitiesId?: string | null,
  } | null,
};

export type CreateQuestionMutationVariables = {
  input: CreateQuestionInput,
  condition?: ModelQuestionConditionInput | null,
};

export type CreateQuestionMutation = {
  createQuestion?:  {
    __typename: "Question",
    id: string,
    defaultPrompt?: string | null,
    required?: boolean | null,
    selfAssessmentPrompt?: string | null,
    sortingIndex?: number | null,
    title?: string | null,
    helpText?: string | null,
    inputType?: InputType | null,
    instrumentId: string,
    answerOptions?:  {
      __typename: "ModelAnswerOptionConnection",
      items:  Array< {
        __typename: "AnswerOption",
        id: string,
        anchor?: string | null,
        sortingIndex?: number | null,
        helpText?: string | null,
        value?: string | null,
        questionId: string,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateQuestionMutationVariables = {
  input: UpdateQuestionInput,
  condition?: ModelQuestionConditionInput | null,
};

export type UpdateQuestionMutation = {
  updateQuestion?:  {
    __typename: "Question",
    id: string,
    defaultPrompt?: string | null,
    required?: boolean | null,
    selfAssessmentPrompt?: string | null,
    sortingIndex?: number | null,
    title?: string | null,
    helpText?: string | null,
    inputType?: InputType | null,
    instrumentId: string,
    answerOptions?:  {
      __typename: "ModelAnswerOptionConnection",
      items:  Array< {
        __typename: "AnswerOption",
        id: string,
        anchor?: string | null,
        sortingIndex?: number | null,
        helpText?: string | null,
        value?: string | null,
        questionId: string,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteQuestionMutationVariables = {
  input: DeleteQuestionInput,
  condition?: ModelQuestionConditionInput | null,
};

export type DeleteQuestionMutation = {
  deleteQuestion?:  {
    __typename: "Question",
    id: string,
    defaultPrompt?: string | null,
    required?: boolean | null,
    selfAssessmentPrompt?: string | null,
    sortingIndex?: number | null,
    title?: string | null,
    helpText?: string | null,
    inputType?: InputType | null,
    instrumentId: string,
    answerOptions?:  {
      __typename: "ModelAnswerOptionConnection",
      items:  Array< {
        __typename: "AnswerOption",
        id: string,
        anchor?: string | null,
        sortingIndex?: number | null,
        helpText?: string | null,
        value?: string | null,
        questionId: string,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAnswerOptionMutationVariables = {
  input: CreateAnswerOptionInput,
  condition?: ModelAnswerOptionConditionInput | null,
};

export type CreateAnswerOptionMutation = {
  createAnswerOption?:  {
    __typename: "AnswerOption",
    id: string,
    anchor?: string | null,
    sortingIndex?: number | null,
    helpText?: string | null,
    value?: string | null,
    questionId: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAnswerOptionMutationVariables = {
  input: UpdateAnswerOptionInput,
  condition?: ModelAnswerOptionConditionInput | null,
};

export type UpdateAnswerOptionMutation = {
  updateAnswerOption?:  {
    __typename: "AnswerOption",
    id: string,
    anchor?: string | null,
    sortingIndex?: number | null,
    helpText?: string | null,
    value?: string | null,
    questionId: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAnswerOptionMutationVariables = {
  input: DeleteAnswerOptionInput,
  condition?: ModelAnswerOptionConditionInput | null,
};

export type DeleteAnswerOptionMutation = {
  deleteAnswerOption?:  {
    __typename: "AnswerOption",
    id: string,
    anchor?: string | null,
    sortingIndex?: number | null,
    helpText?: string | null,
    value?: string | null,
    questionId: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateActivityEventMutationVariables = {
  input: CreateActivityEventInput,
  condition?: ModelActivityEventConditionInput | null,
};

export type CreateActivityEventMutation = {
  createActivityEvent?:  {
    __typename: "ActivityEvent",
    id: string,
    creatorId?: string | null,
    creator?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    participants?:  {
      __typename: "ModelActivityParticipantConnection",
      items:  Array< {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventDate?: string | null,
    notes?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateActivityEventMutationVariables = {
  input: UpdateActivityEventInput,
  condition?: ModelActivityEventConditionInput | null,
};

export type UpdateActivityEventMutation = {
  updateActivityEvent?:  {
    __typename: "ActivityEvent",
    id: string,
    creatorId?: string | null,
    creator?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    participants?:  {
      __typename: "ModelActivityParticipantConnection",
      items:  Array< {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventDate?: string | null,
    notes?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteActivityEventMutationVariables = {
  input: DeleteActivityEventInput,
  condition?: ModelActivityEventConditionInput | null,
};

export type DeleteActivityEventMutation = {
  deleteActivityEvent?:  {
    __typename: "ActivityEvent",
    id: string,
    creatorId?: string | null,
    creator?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    participants?:  {
      __typename: "ModelActivityParticipantConnection",
      items:  Array< {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventDate?: string | null,
    notes?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateActivityParticipantMutationVariables = {
  input: CreateActivityParticipantInput,
  condition?: ModelActivityParticipantConditionInput | null,
};

export type CreateActivityParticipantMutation = {
  createActivityParticipant?:  {
    __typename: "ActivityParticipant",
    id: string,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventId: string,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    currentPGY?: number | null,
    currentRole?: ProgramRole | null,
    currentTraineeType?: TraineeType | null,
    currentJobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateActivityParticipantMutationVariables = {
  input: UpdateActivityParticipantInput,
  condition?: ModelActivityParticipantConditionInput | null,
};

export type UpdateActivityParticipantMutation = {
  updateActivityParticipant?:  {
    __typename: "ActivityParticipant",
    id: string,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventId: string,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    currentPGY?: number | null,
    currentRole?: ProgramRole | null,
    currentTraineeType?: TraineeType | null,
    currentJobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteActivityParticipantMutationVariables = {
  input: DeleteActivityParticipantInput,
  condition?: ModelActivityParticipantConditionInput | null,
};

export type DeleteActivityParticipantMutation = {
  deleteActivityParticipant?:  {
    __typename: "ActivityParticipant",
    id: string,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventId: string,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    currentPGY?: number | null,
    currentRole?: ProgramRole | null,
    currentTraineeType?: TraineeType | null,
    currentJobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAssessmentEventMutationVariables = {
  input: CreateAssessmentEventInput,
  condition?: ModelAssessmentEventConditionInput | null,
};

export type CreateAssessmentEventMutation = {
  createAssessmentEvent?:  {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAssessmentEventMutationVariables = {
  input: UpdateAssessmentEventInput,
  condition?: ModelAssessmentEventConditionInput | null,
};

export type UpdateAssessmentEventMutation = {
  updateAssessmentEvent?:  {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAssessmentEventMutationVariables = {
  input: DeleteAssessmentEventInput,
  condition?: ModelAssessmentEventConditionInput | null,
};

export type DeleteAssessmentEventMutation = {
  deleteAssessmentEvent?:  {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAnswerEventMutationVariables = {
  input: CreateAnswerEventInput,
  condition?: ModelAnswerEventConditionInput | null,
};

export type CreateAnswerEventMutation = {
  createAnswerEvent?:  {
    __typename: "AnswerEvent",
    id: string,
    questionId?: string | null,
    question?:  {
      __typename: "Question",
      id: string,
      defaultPrompt?: string | null,
      required?: boolean | null,
      selfAssessmentPrompt?: string | null,
      sortingIndex?: number | null,
      title?: string | null,
      helpText?: string | null,
      inputType?: InputType | null,
      instrumentId: string,
      answerOptions?:  {
        __typename: "ModelAnswerOptionConnection",
        items:  Array< {
          __typename: "AnswerOption",
          id: string,
          anchor?: string | null,
          sortingIndex?: number | null,
          helpText?: string | null,
          value?: string | null,
          questionId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    valueType?: ValueType | null,
    value?: string | null,
    assessmentEventId?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAnswerEventMutationVariables = {
  input: UpdateAnswerEventInput,
  condition?: ModelAnswerEventConditionInput | null,
};

export type UpdateAnswerEventMutation = {
  updateAnswerEvent?:  {
    __typename: "AnswerEvent",
    id: string,
    questionId?: string | null,
    question?:  {
      __typename: "Question",
      id: string,
      defaultPrompt?: string | null,
      required?: boolean | null,
      selfAssessmentPrompt?: string | null,
      sortingIndex?: number | null,
      title?: string | null,
      helpText?: string | null,
      inputType?: InputType | null,
      instrumentId: string,
      answerOptions?:  {
        __typename: "ModelAnswerOptionConnection",
        items:  Array< {
          __typename: "AnswerOption",
          id: string,
          anchor?: string | null,
          sortingIndex?: number | null,
          helpText?: string | null,
          value?: string | null,
          questionId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    valueType?: ValueType | null,
    value?: string | null,
    assessmentEventId?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAnswerEventMutationVariables = {
  input: DeleteAnswerEventInput,
  condition?: ModelAnswerEventConditionInput | null,
};

export type DeleteAnswerEventMutation = {
  deleteAnswerEvent?:  {
    __typename: "AnswerEvent",
    id: string,
    questionId?: string | null,
    question?:  {
      __typename: "Question",
      id: string,
      defaultPrompt?: string | null,
      required?: boolean | null,
      selfAssessmentPrompt?: string | null,
      sortingIndex?: number | null,
      title?: string | null,
      helpText?: string | null,
      inputType?: InputType | null,
      instrumentId: string,
      answerOptions?:  {
        __typename: "ModelAnswerOptionConnection",
        items:  Array< {
          __typename: "AnswerOption",
          id: string,
          anchor?: string | null,
          sortingIndex?: number | null,
          helpText?: string | null,
          value?: string | null,
          questionId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    valueType?: ValueType | null,
    value?: string | null,
    assessmentEventId?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAcgmeProcedureMutationVariables = {
  input: CreateAcgmeProcedureInput,
  condition?: ModelAcgmeProcedureConditionInput | null,
};

export type CreateAcgmeProcedureMutation = {
  createAcgmeProcedure?:  {
    __typename: "AcgmeProcedure",
    id: string,
    name: string,
    acgmeCode: string,
    activities?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAcgmeProcedureMutationVariables = {
  input: UpdateAcgmeProcedureInput,
  condition?: ModelAcgmeProcedureConditionInput | null,
};

export type UpdateAcgmeProcedureMutation = {
  updateAcgmeProcedure?:  {
    __typename: "AcgmeProcedure",
    id: string,
    name: string,
    acgmeCode: string,
    activities?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAcgmeProcedureMutationVariables = {
  input: DeleteAcgmeProcedureInput,
  condition?: ModelAcgmeProcedureConditionInput | null,
};

export type DeleteAcgmeProcedureMutation = {
  deleteAcgmeProcedure?:  {
    __typename: "AcgmeProcedure",
    id: string,
    name: string,
    acgmeCode: string,
    activities?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateProgramSponsorsMutationVariables = {
  input: CreateProgramSponsorsInput,
  condition?: ModelProgramSponsorsConditionInput | null,
};

export type CreateProgramSponsorsMutation = {
  createProgramSponsors?:  {
    __typename: "ProgramSponsors",
    id: string,
    programID: string,
    sponsorID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    sponsor:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateProgramSponsorsMutationVariables = {
  input: UpdateProgramSponsorsInput,
  condition?: ModelProgramSponsorsConditionInput | null,
};

export type UpdateProgramSponsorsMutation = {
  updateProgramSponsors?:  {
    __typename: "ProgramSponsors",
    id: string,
    programID: string,
    sponsorID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    sponsor:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteProgramSponsorsMutationVariables = {
  input: DeleteProgramSponsorsInput,
  condition?: ModelProgramSponsorsConditionInput | null,
};

export type DeleteProgramSponsorsMutation = {
  deleteProgramSponsors?:  {
    __typename: "ProgramSponsors",
    id: string,
    programID: string,
    sponsorID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    sponsor:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateNetworkProgramMutationVariables = {
  input: CreateNetworkProgramInput,
  condition?: ModelNetworkProgramConditionInput | null,
};

export type CreateNetworkProgramMutation = {
  createNetworkProgram?:  {
    __typename: "NetworkProgram",
    id: string,
    programID: string,
    networkID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateNetworkProgramMutationVariables = {
  input: UpdateNetworkProgramInput,
  condition?: ModelNetworkProgramConditionInput | null,
};

export type UpdateNetworkProgramMutation = {
  updateNetworkProgram?:  {
    __typename: "NetworkProgram",
    id: string,
    programID: string,
    networkID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteNetworkProgramMutationVariables = {
  input: DeleteNetworkProgramInput,
  condition?: ModelNetworkProgramConditionInput | null,
};

export type DeleteNetworkProgramMutation = {
  deleteNetworkProgram?:  {
    __typename: "NetworkProgram",
    id: string,
    programID: string,
    networkID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateNetworkActivityMutationVariables = {
  input: CreateNetworkActivityInput,
  condition?: ModelNetworkActivityConditionInput | null,
};

export type CreateNetworkActivityMutation = {
  createNetworkActivity?:  {
    __typename: "NetworkActivity",
    id: string,
    networkID: string,
    activityID: string,
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateNetworkActivityMutationVariables = {
  input: UpdateNetworkActivityInput,
  condition?: ModelNetworkActivityConditionInput | null,
};

export type UpdateNetworkActivityMutation = {
  updateNetworkActivity?:  {
    __typename: "NetworkActivity",
    id: string,
    networkID: string,
    activityID: string,
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteNetworkActivityMutationVariables = {
  input: DeleteNetworkActivityInput,
  condition?: ModelNetworkActivityConditionInput | null,
};

export type DeleteNetworkActivityMutation = {
  deleteNetworkActivity?:  {
    __typename: "NetworkActivity",
    id: string,
    networkID: string,
    activityID: string,
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAssessmentActivityMutationVariables = {
  input: CreateAssessmentActivityInput,
  condition?: ModelAssessmentActivityConditionInput | null,
};

export type CreateAssessmentActivityMutation = {
  createAssessmentActivity?:  {
    __typename: "AssessmentActivity",
    id: string,
    assessmentID: string,
    activityID: string,
    assessment:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAssessmentActivityMutationVariables = {
  input: UpdateAssessmentActivityInput,
  condition?: ModelAssessmentActivityConditionInput | null,
};

export type UpdateAssessmentActivityMutation = {
  updateAssessmentActivity?:  {
    __typename: "AssessmentActivity",
    id: string,
    assessmentID: string,
    activityID: string,
    assessment:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAssessmentActivityMutationVariables = {
  input: DeleteAssessmentActivityInput,
  condition?: ModelAssessmentActivityConditionInput | null,
};

export type DeleteAssessmentActivityMutation = {
  deleteAssessmentActivity?:  {
    __typename: "AssessmentActivity",
    id: string,
    assessmentID: string,
    activityID: string,
    assessment:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateActivityEventActivitiesMutationVariables = {
  input: CreateActivityEventActivitiesInput,
  condition?: ModelActivityEventActivitiesConditionInput | null,
};

export type CreateActivityEventActivitiesMutation = {
  createActivityEventActivities?:  {
    __typename: "ActivityEventActivities",
    id: string,
    activityID: string,
    activityEventID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    activityEvent:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateActivityEventActivitiesMutationVariables = {
  input: UpdateActivityEventActivitiesInput,
  condition?: ModelActivityEventActivitiesConditionInput | null,
};

export type UpdateActivityEventActivitiesMutation = {
  updateActivityEventActivities?:  {
    __typename: "ActivityEventActivities",
    id: string,
    activityID: string,
    activityEventID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    activityEvent:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteActivityEventActivitiesMutationVariables = {
  input: DeleteActivityEventActivitiesInput,
  condition?: ModelActivityEventActivitiesConditionInput | null,
};

export type DeleteActivityEventActivitiesMutation = {
  deleteActivityEventActivities?:  {
    __typename: "ActivityEventActivities",
    id: string,
    activityID: string,
    activityEventID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    activityEvent:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateAcgmeProcedureActivityMutationVariables = {
  input: CreateAcgmeProcedureActivityInput,
  condition?: ModelAcgmeProcedureActivityConditionInput | null,
};

export type CreateAcgmeProcedureActivityMutation = {
  createAcgmeProcedureActivity?:  {
    __typename: "AcgmeProcedureActivity",
    id: string,
    activityID: string,
    acgmeProcedureID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    acgmeProcedure:  {
      __typename: "AcgmeProcedure",
      id: string,
      name: string,
      acgmeCode: string,
      activities?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateAcgmeProcedureActivityMutationVariables = {
  input: UpdateAcgmeProcedureActivityInput,
  condition?: ModelAcgmeProcedureActivityConditionInput | null,
};

export type UpdateAcgmeProcedureActivityMutation = {
  updateAcgmeProcedureActivity?:  {
    __typename: "AcgmeProcedureActivity",
    id: string,
    activityID: string,
    acgmeProcedureID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    acgmeProcedure:  {
      __typename: "AcgmeProcedure",
      id: string,
      name: string,
      acgmeCode: string,
      activities?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteAcgmeProcedureActivityMutationVariables = {
  input: DeleteAcgmeProcedureActivityInput,
  condition?: ModelAcgmeProcedureActivityConditionInput | null,
};

export type DeleteAcgmeProcedureActivityMutation = {
  deleteAcgmeProcedureActivity?:  {
    __typename: "AcgmeProcedureActivity",
    id: string,
    activityID: string,
    acgmeProcedureID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    acgmeProcedure:  {
      __typename: "AcgmeProcedure",
      id: string,
      name: string,
      acgmeCode: string,
      activities?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UserStatsQueryVariables = {
  userId?: string | null,
};

export type UserStatsQuery = {
  userStats?:  {
    __typename: "UserStats",
    percentCompleted?: number | null,
    averageResponseTime?: number | null,
    assessmentsCreated?: number | null,
    assessmentsCompleted?: number | null,
    assessmentsExpired?: number | null,
  } | null,
};

export type SiblingUsersQueryVariables = {
  userId?: string | null,
};

export type SiblingUsersQuery = {
  siblingUsers?:  Array< {
    __typename: "User",
    id: string,
    email: string,
    emailLower?: string | null,
    institutionId?: string | null,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoUsername?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    suffix?: string | null,
    npi?: number | null,
    simplLearnId?: string | null,
    pgy?: number | null,
    settings?:  {
      __typename: "UserSettings",
      sendEmail?: boolean | null,
      sendPushNotifications?: boolean | null,
    } | null,
    lastLogin?: string | null,
    eulaAcceptedDate?: string | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deviceToken?: string | null,
    devicePlatform?: DevicePlatform | null,
    inviteId?: string | null,
    invite?:  {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null > | null,
};

export type PaginatableSiblingUsersQueryVariables = {
  input?: PaginatableSiblingUsersArgs | null,
};

export type PaginatableSiblingUsersQuery = {
  paginatableSiblingUsers?:  {
    __typename: "PaginatableSiblingUsersResult",
    nextToken?: string | null,
    total?: number | null,
    items?:  Array< {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
  } | null,
};

export type CompletedAssessmentHistoryByProgramMembershipQueryVariables = {
  programMembershipId?: string | null,
};

export type CompletedAssessmentHistoryByProgramMembershipQuery = {
  completedAssessmentHistoryByProgramMembership?:  Array< {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null > | null,
};

export type AssessmentHistoryQueryVariables = {
  input?: AssessmentHistoryArgs | null,
};

export type AssessmentHistoryQuery = {
  assessmentHistory?:  Array< {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null > | null,
};

export type PaginatableAssessmentHistoryQueryVariables = {
  input?: PaginatableAssessmentHistoryArgs | null,
};

export type PaginatableAssessmentHistoryQuery = {
  paginatableAssessmentHistory?:  {
    __typename: "PaginatableAssessmentHistoryResult",
    nextToken?: string | null,
    total?: number | null,
    items?:  Array< {
      __typename: "AssessmentEvent",
      id: string,
      subjectId?: string | null,
      subject?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subjectUserId?: string | null,
      raterId?: string | null,
      rater?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      raterUserId?: string | null,
      activityId?: string | null,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      activityEventId?: string | null,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answers?:  {
        __typename: "ModelAnswerEventConnection",
        items:  Array< {
          __typename: "AnswerEvent",
          id: string,
          questionId?: string | null,
          valueType?: ValueType | null,
          value?: string | null,
          assessmentEventId?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDate?: string | null,
      completionDate?: string | null,
      declined?: ReasonForDecline | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
  } | null,
};

export type MilestoneReportQueryVariables = {
  programMembershipIds?: Array< string | null > | null,
};

export type MilestoneReportQuery = {
  milestoneReport?: string | null,
};

export type UpdateUserEmailQueryVariables = {
  input?: UpdateUserEmailArgs | null,
};

export type UpdateUserEmailQuery = {
  updateUserEmail?: string | null,
};

export type EngagementReportQueryVariables = {
  input?: EngagementReportArgs | null,
};

export type EngagementReportQuery = {
  engagementReport?:  {
    __typename: "EngagementReportResult",
    success: boolean,
    error?: string | null,
    programReportRows?:  Array< {
      __typename: "ProgramReportRow",
      institutionId?: string | null,
      institutionName?: string | null,
      programId?: string | null,
      program?: string | null,
      createdAssessmentEvents?: number | null,
      assignedAssessmentEvents?: number | null,
      completedAssessmentEvents?: number | null,
      percentCompleted?: number | null,
      attendingsInProgram?: number | null,
      traineesInProgram?: number | null,
      averageCompletedPerTrainee?: number | null,
    } > | null,
    userReportRows?:  Array< {
      __typename: "UserReportRow",
      userId?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      email?: string | null,
      programRole?: string | null,
      programId?: string | null,
      program?: string | null,
      createdAssessmentEvents?: number | null,
      assignedAssessmentEvents?: number | null,
      completedAssessmentEvents?: number | null,
      percentCompleted?: number | null,
      expiredAssessmentEvents?: number | null,
      percentExpired?: number | null,
    } > | null,
  } | null,
};

export type ValidateBulkUploadQueryVariables = {
  input?: ValidateBulkUploadArgs | null,
};

export type ValidateBulkUploadQuery = {
  validateBulkUpload?:  {
    __typename: "ValidateBulkUploadResult",
    success: boolean,
    error?: string | null,
    invitations?:  Array< {
      __typename: "ValidateBulkUploadInvitationResult",
      requestId?: string | null,
      firstName: string,
      lastName: string,
      email: string,
      role: ProgramRole,
      programId: string,
      npi?: string | null,
      simplLearnId?: string | null,
      pgy?: string | null,
      traineeType?: string | null,
      jobTitle?: string | null,
      errors?:  Array< {
        __typename: "ValidateBulkUploadError",
        field: string,
        error: string,
      } > | null,
    } > | null,
  } | null,
};

export type RequestBulkCCCReportQueryVariables = {
  input?: RequestBulkCCCReportInput | null,
};

export type RequestBulkCCCReportQuery = {
  requestBulkCCCReport?: string | null,
};

export type SendUserInvitationQueryVariables = {
  input?: SendUserInvitationArgs | null,
};

export type SendUserInvitationQuery = {
  sendUserInvitation?:  {
    __typename: "SendUserInvitationResult",
    success: boolean,
    error?: string | null,
  } | null,
};

export type AvailableActivitiesQueryVariables = {
  input?: AvailableActivitiesArgs | null,
};

export type AvailableActivitiesQuery = {
  availableActivities?:  {
    __typename: "PaginatableActivitiesByUsersResult",
    activities?:  Array< {
      __typename: "ActivitiesByUsersActivity",
      id: string,
      title?: string | null,
      description?: string | null,
      assessmentId?: string | null,
      sponsor?:  {
        __typename: "SponsorMinimal",
        id: string,
        name?: string | null,
        description?: string | null,
        activityLabel?: string | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        deletedAt?: string | null,
      } | null,
      categories?: Array< string > | null,
      programIds?: Array< string | null > | null,
    } | null > | null,
    total?: number | null,
    nextPage?: number | null,
    error?: string | null,
  } | null,
};

export type ActivitiesByUsersQueryVariables = {
  input?: ActivitiesByUsersArgs | null,
};

export type ActivitiesByUsersQuery = {
  activitiesByUsers?:  {
    __typename: "ActivitiesByUsersResult",
    error?: string | null,
    activities?:  Array< {
      __typename: "ActivitiesByUsersActivity",
      id: string,
      title?: string | null,
      description?: string | null,
      assessmentId?: string | null,
      sponsor?:  {
        __typename: "SponsorMinimal",
        id: string,
        name?: string | null,
        description?: string | null,
        activityLabel?: string | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        deletedAt?: string | null,
      } | null,
      categories?: Array< string > | null,
      programIds?: Array< string | null > | null,
    } | null > | null,
  } | null,
};

export type PaginatableActivitiesByUsersQueryVariables = {
  input?: PaginatableActivitiesByUsersArgs | null,
};

export type PaginatableActivitiesByUsersQuery = {
  paginatableActivitiesByUsers?:  {
    __typename: "PaginatableActivitiesByUsersResult",
    activities?:  Array< {
      __typename: "ActivitiesByUsersActivity",
      id: string,
      title?: string | null,
      description?: string | null,
      assessmentId?: string | null,
      sponsor?:  {
        __typename: "SponsorMinimal",
        id: string,
        name?: string | null,
        description?: string | null,
        activityLabel?: string | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        createdAt?: string | null,
        updatedAt?: string | null,
        deletedAt?: string | null,
      } | null,
      categories?: Array< string > | null,
      programIds?: Array< string | null > | null,
    } | null > | null,
    total?: number | null,
    nextPage?: number | null,
    error?: string | null,
  } | null,
};

export type UsersPendingAssessmentsQueryVariables = {
  userId?: string | null,
};

export type UsersPendingAssessmentsQuery = {
  usersPendingAssessments?:  Array< {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null > | null,
};

export type PaginatableUsersPendingAssessmentsQueryVariables = {
  input?: PaginatableUsersPendingAssessmentsArgs | null,
};

export type PaginatableUsersPendingAssessmentsQuery = {
  paginatableUsersPendingAssessments?:  {
    __typename: "PaginatableUsersPendingAssessmentsResult",
    nextToken?: string | null,
    total?: number | null,
    items?:  Array< {
      __typename: "AssessmentEvent",
      id: string,
      subjectId?: string | null,
      subject?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subjectUserId?: string | null,
      raterId?: string | null,
      rater?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      raterUserId?: string | null,
      activityId?: string | null,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      activityEventId?: string | null,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answers?:  {
        __typename: "ModelAnswerEventConnection",
        items:  Array< {
          __typename: "AnswerEvent",
          id: string,
          questionId?: string | null,
          valueType?: ValueType | null,
          value?: string | null,
          assessmentEventId?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDate?: string | null,
      completionDate?: string | null,
      declined?: ReasonForDecline | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
  } | null,
};

export type NetworkRatingRulesQueryVariables = {
  userId?: string | null,
};

export type NetworkRatingRulesQuery = {
  networkRatingRules?:  {
    __typename: "AssessmentRoleResult",
    showPrompt: boolean,
    assessmentRole?: AssessmentRole | null,
  } | null,
};

export type PaginatableAssessmentHistorySearchUserQueryVariables = {
  input?: AssessmentHistorySearchUserArgs | null,
};

export type PaginatableAssessmentHistorySearchUserQuery = {
  paginatableAssessmentHistorySearchUser?:  {
    __typename: "PaginatableSiblingUsersResult",
    nextToken?: string | null,
    total?: number | null,
    items?:  Array< {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null > | null,
  } | null,
};

export type GetInstitutionQueryVariables = {
  id: string,
};

export type GetInstitutionQuery = {
  getInstitution?:  {
    __typename: "Institution",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramConnection",
      items:  Array< {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListInstitutionsQueryVariables = {
  filter?: ModelInstitutionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInstitutionsQuery = {
  listInstitutions?:  {
    __typename: "ModelInstitutionConnection",
    items:  Array< {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProgramQueryVariables = {
  id: string,
};

export type GetProgramQuery = {
  getProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    institutionId: string,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsors?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProgramsQueryVariables = {
  filter?: ModelProgramFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProgramsQuery = {
  listPrograms?:  {
    __typename: "ModelProgramConnection",
    items:  Array< {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProgramsByInstitutionQueryVariables = {
  institutionId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProgramFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProgramsByInstitutionQuery = {
  programsByInstitution?:  {
    __typename: "ModelProgramConnection",
    items:  Array< {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchProgramsQueryVariables = {
  filter?: SearchableProgramFilterInput | null,
  sort?: Array< SearchableProgramSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableProgramAggregationInput | null > | null,
};

export type SearchProgramsQuery = {
  searchPrograms?:  {
    __typename: "SearchableProgramConnection",
    items:  Array< {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetNetworkQueryVariables = {
  id: string,
};

export type GetNetworkQuery = {
  getNetwork?:  {
    __typename: "Network",
    id: string,
    name: string,
    sponsorId: string,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programs?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeEnabled?: boolean | null,
    allAttendingHistoryDisabled?: boolean | null,
    simpl1Id?: number | null,
    categoriesExcludedFromRequestFlow?: Array< string | null > | null,
    dashboardURL?: string | null,
    showDashboardLink?: boolean | null,
    disableClassicReports?: boolean | null,
    traineeCanRateTrainee?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListNetworksQueryVariables = {
  filter?: ModelNetworkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNetworksQuery = {
  listNetworks?:  {
    __typename: "ModelNetworkConnection",
    items:  Array< {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type NetworksBySponsorQueryVariables = {
  sponsorId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNetworkFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NetworksBySponsorQuery = {
  networksBySponsor?:  {
    __typename: "ModelNetworkConnection",
    items:  Array< {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename: "User",
    id: string,
    email: string,
    emailLower?: string | null,
    institutionId?: string | null,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoUsername?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    suffix?: string | null,
    npi?: number | null,
    simplLearnId?: string | null,
    pgy?: number | null,
    settings?:  {
      __typename: "UserSettings",
      sendEmail?: boolean | null,
      sendPushNotifications?: boolean | null,
    } | null,
    lastLogin?: string | null,
    eulaAcceptedDate?: string | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deviceToken?: string | null,
    devicePlatform?: DevicePlatform | null,
    inviteId?: string | null,
    invite?:  {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUsersQueryVariables = {
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUsersQuery = {
  listUsers?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByEmailQuery = {
  usersByEmail?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByEmailLowerQueryVariables = {
  emailLower: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByEmailLowerQuery = {
  usersByEmailLower?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByInstitutionQueryVariables = {
  institutionId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByInstitutionQuery = {
  usersByInstitution?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByNPIQueryVariables = {
  npi: number,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByNPIQuery = {
  usersByNPI?:  {
    __typename: "ModelUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchUsersQueryVariables = {
  filter?: SearchableUserFilterInput | null,
  sort?: Array< SearchableUserSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableUserAggregationInput | null > | null,
};

export type SearchUsersQuery = {
  searchUsers?:  {
    __typename: "SearchableUserConnection",
    items:  Array< {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetUserInvitationQueryVariables = {
  id: string,
};

export type GetUserInvitationQuery = {
  getUserInvitation?:  {
    __typename: "UserInvitation",
    id: string,
    inviteeId?: string | null,
    invitee:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    institutionId: string,
    invitationStatus: InvitationStatus,
    email?: string | null,
    emailLower?: string | null,
    adminId?: string | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    role?: ProgramRole | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListUserInvitationsQueryVariables = {
  filter?: ModelUserInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserInvitationsQuery = {
  listUserInvitations?:  {
    __typename: "ModelUserInvitationConnection",
    items:  Array< {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserInvitationsByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserInvitationsByEmailQuery = {
  userInvitationsByEmail?:  {
    __typename: "ModelUserInvitationConnection",
    items:  Array< {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserInvitationsByEmailLowerQueryVariables = {
  emailLower: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserInvitationsByEmailLowerQuery = {
  userInvitationsByEmailLower?:  {
    __typename: "ModelUserInvitationConnection",
    items:  Array< {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UserInvitationsByProgramQueryVariables = {
  programId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserInvitationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserInvitationsByProgramQuery = {
  userInvitationsByProgram?:  {
    __typename: "ModelUserInvitationConnection",
    items:  Array< {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchUserInvitationsQueryVariables = {
  filter?: SearchableUserInvitationFilterInput | null,
  sort?: Array< SearchableUserInvitationSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableUserInvitationAggregationInput | null > | null,
};

export type SearchUserInvitationsQuery = {
  searchUserInvitations?:  {
    __typename: "SearchableUserInvitationConnection",
    items:  Array< {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetProgramMembershipQueryVariables = {
  id: string,
};

export type GetProgramMembershipQuery = {
  getProgramMembership?:  {
    __typename: "ProgramMembership",
    id: string,
    programRole: ProgramRole,
    traineeType?: TraineeType | null,
    programMemberId: string,
    programId: string,
    programMember?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate?: string | null,
    endDate?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProgramMembershipsQueryVariables = {
  filter?: ModelProgramMembershipFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProgramMembershipsQuery = {
  listProgramMemberships?:  {
    __typename: "ModelProgramMembershipConnection",
    items:  Array< {
      __typename: "ProgramMembership",
      id: string,
      programRole: ProgramRole,
      traineeType?: TraineeType | null,
      programMemberId: string,
      programId: string,
      programMember?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      startDate?: string | null,
      endDate?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProgramsByUserQueryVariables = {
  programMemberId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProgramMembershipFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProgramsByUserQuery = {
  programsByUser?:  {
    __typename: "ModelProgramMembershipConnection",
    items:  Array< {
      __typename: "ProgramMembership",
      id: string,
      programRole: ProgramRole,
      traineeType?: TraineeType | null,
      programMemberId: string,
      programId: string,
      programMember?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      startDate?: string | null,
      endDate?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByProgramQueryVariables = {
  programId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelProgramMembershipFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByProgramQuery = {
  usersByProgram?:  {
    __typename: "ModelProgramMembershipConnection",
    items:  Array< {
      __typename: "ProgramMembership",
      id: string,
      programRole: ProgramRole,
      traineeType?: TraineeType | null,
      programMemberId: string,
      programId: string,
      programMember?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      startDate?: string | null,
      endDate?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchProgramMembershipsQueryVariables = {
  filter?: SearchableProgramMembershipFilterInput | null,
  sort?: Array< SearchableProgramMembershipSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableProgramMembershipAggregationInput | null > | null,
};

export type SearchProgramMembershipsQuery = {
  searchProgramMemberships?:  {
    __typename: "SearchableProgramMembershipConnection",
    items:  Array< {
      __typename: "ProgramMembership",
      id: string,
      programRole: ProgramRole,
      traineeType?: TraineeType | null,
      programMemberId: string,
      programId: string,
      programMember?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      startDate?: string | null,
      endDate?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetEULATextQueryVariables = {
  id: string,
};

export type GetEULATextQuery = {
  getEULAText?:  {
    __typename: "EULAText",
    id: string,
    formattedText: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEULATextsQueryVariables = {
  filter?: ModelEULATextFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEULATextsQuery = {
  listEULATexts?:  {
    __typename: "ModelEULATextConnection",
    items:  Array< {
      __typename: "EULAText",
      id: string,
      formattedText: string,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMilestoneQueryVariables = {
  id: string,
};

export type GetMilestoneQuery = {
  getMilestone?:  {
    __typename: "Milestone",
    id: string,
    shortName: string,
    name: string,
    description?: string | null,
    scale: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMilestonesQueryVariables = {
  filter?: ModelMilestoneFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMilestonesQuery = {
  listMilestones?:  {
    __typename: "ModelMilestoneConnection",
    items:  Array< {
      __typename: "Milestone",
      id: string,
      shortName: string,
      name: string,
      description?: string | null,
      scale: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetMilestoneNetworkRatingQueryVariables = {
  id: string,
};

export type GetMilestoneNetworkRatingQuery = {
  getMilestoneNetworkRating?:  {
    __typename: "MilestoneNetworkRating",
    id: string,
    activityId: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    networkId: string,
    network?:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneId: string,
    milestone?:  {
      __typename: "Milestone",
      id: string,
      shortName: string,
      name: string,
      description?: string | null,
      scale: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answerOptionId: string,
    answerOption?:  {
      __typename: "AnswerOption",
      id: string,
      anchor?: string | null,
      sortingIndex?: number | null,
      helpText?: string | null,
      value?: string | null,
      questionId: string,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneRating: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListMilestoneNetworkRatingsQueryVariables = {
  filter?: ModelMilestoneNetworkRatingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListMilestoneNetworkRatingsQuery = {
  listMilestoneNetworkRatings?:  {
    __typename: "ModelMilestoneNetworkRatingConnection",
    items:  Array< {
      __typename: "MilestoneNetworkRating",
      id: string,
      activityId: string,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      networkId: string,
      network?:  {
        __typename: "Network",
        id: string,
        name: string,
        sponsorId: string,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programs?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeEnabled?: boolean | null,
        allAttendingHistoryDisabled?: boolean | null,
        simpl1Id?: number | null,
        categoriesExcludedFromRequestFlow?: Array< string | null > | null,
        dashboardURL?: string | null,
        showDashboardLink?: boolean | null,
        disableClassicReports?: boolean | null,
        traineeCanRateTrainee?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      milestoneId: string,
      milestone?:  {
        __typename: "Milestone",
        id: string,
        shortName: string,
        name: string,
        description?: string | null,
        scale: number,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answerOptionId: string,
      answerOption?:  {
        __typename: "AnswerOption",
        id: string,
        anchor?: string | null,
        sortingIndex?: number | null,
        helpText?: string | null,
        value?: string | null,
        questionId: string,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      milestoneRating: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetSponsorQueryVariables = {
  id: string,
};

export type GetSponsorQuery = {
  getSponsor?:  {
    __typename: "Sponsor",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkConnection",
      items:  Array< {
        __typename: "Network",
        id: string,
        name: string,
        sponsorId: string,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programs?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeEnabled?: boolean | null,
        allAttendingHistoryDisabled?: boolean | null,
        simpl1Id?: number | null,
        categoriesExcludedFromRequestFlow?: Array< string | null > | null,
        dashboardURL?: string | null,
        showDashboardLink?: boolean | null,
        disableClassicReports?: boolean | null,
        traineeCanRateTrainee?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    branding?:  {
      __typename: "SponsorBranding",
      colors?:  {
        __typename: "SponsorColors",
        primary?: string | null,
        secondary?: string | null,
        light?: string | null,
      } | null,
      logos?:  {
        __typename: "SponsorLogos",
        fullMono?: string | null,
        fullColor?: string | null,
        squareMono?: string | null,
        squareColor?: string | null,
        email?: string | null,
      } | null,
    } | null,
    activityLabel?: string | null,
    autoAssignActivities?: Array< string > | null,
    dashboardURL?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSponsorsQueryVariables = {
  filter?: ModelSponsorFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListSponsorsQuery = {
  listSponsors?:  {
    __typename: "ModelSponsorConnection",
    items:  Array< {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAssessmentQueryVariables = {
  id: string,
};

export type GetAssessmentQuery = {
  getAssessment?:  {
    __typename: "Assessment",
    id: string,
    title?: string | null,
    description?: string | null,
    instrumentId?: string | null,
    instrument?:  {
      __typename: "Instrument",
      id: string,
      title?: string | null,
      description?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    multiActivities?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDurationHours?: number | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requireTraineeSelfAssessment?: boolean | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    published?: boolean | null,
    archived?: boolean | null,
    version?: string | null,
    creationDurationHours?: number | null,
    showFeedbackQuestionsToTrainees?: boolean | null,
    sendEmailForSelfAssessment?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAssessmentsQueryVariables = {
  filter?: ModelAssessmentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssessmentsQuery = {
  listAssessments?:  {
    __typename: "ModelAssessmentConnection",
    items:  Array< {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchAssessmentsQueryVariables = {
  filter?: SearchableAssessmentFilterInput | null,
  sort?: Array< SearchableAssessmentSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableAssessmentAggregationInput | null > | null,
};

export type SearchAssessmentsQuery = {
  searchAssessments?:  {
    __typename: "SearchableAssessmentConnection",
    items:  Array< {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetInstrumentQueryVariables = {
  id: string,
};

export type GetInstrumentQuery = {
  getInstrument?:  {
    __typename: "Instrument",
    id: string,
    title?: string | null,
    description?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        defaultPrompt?: string | null,
        required?: boolean | null,
        selfAssessmentPrompt?: string | null,
        sortingIndex?: number | null,
        title?: string | null,
        helpText?: string | null,
        inputType?: InputType | null,
        instrumentId: string,
        answerOptions?:  {
          __typename: "ModelAnswerOptionConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListInstrumentsQueryVariables = {
  filter?: ModelInstrumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListInstrumentsQuery = {
  listInstruments?:  {
    __typename: "ModelInstrumentConnection",
    items:  Array< {
      __typename: "Instrument",
      id: string,
      title?: string | null,
      description?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchInstrumentsQueryVariables = {
  filter?: SearchableInstrumentFilterInput | null,
  sort?: Array< SearchableInstrumentSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableInstrumentAggregationInput | null > | null,
};

export type SearchInstrumentsQuery = {
  searchInstruments?:  {
    __typename: "SearchableInstrumentConnection",
    items:  Array< {
      __typename: "Instrument",
      id: string,
      title?: string | null,
      description?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetActivityQueryVariables = {
  id: string,
};

export type GetActivityQuery = {
  getActivity?:  {
    __typename: "Activity",
    id: string,
    title?: string | null,
    description?: string | null,
    subActivities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessments?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activityEvents?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    networks?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeProcedures?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    categories?: Array< string > | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
    activitySubActivitiesId?: string | null,
  } | null,
};

export type ListActivitiesQueryVariables = {
  filter?: ModelActivityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActivitiesQuery = {
  listActivities?:  {
    __typename: "ModelActivityConnection",
    items:  Array< {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ActivitiesByAssessmentQueryVariables = {
  assessmentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActivityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActivitiesByAssessmentQuery = {
  activitiesByAssessment?:  {
    __typename: "ModelActivityConnection",
    items:  Array< {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ActivitiesBySponsorQueryVariables = {
  sponsorId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActivityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActivitiesBySponsorQuery = {
  activitiesBySponsor?:  {
    __typename: "ModelActivityConnection",
    items:  Array< {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchActivitiesQueryVariables = {
  filter?: SearchableActivityFilterInput | null,
  sort?: Array< SearchableActivitySortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableActivityAggregationInput | null > | null,
};

export type SearchActivitiesQuery = {
  searchActivities?:  {
    __typename: "SearchableActivityConnection",
    items:  Array< {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetQuestionQueryVariables = {
  id: string,
};

export type GetQuestionQuery = {
  getQuestion?:  {
    __typename: "Question",
    id: string,
    defaultPrompt?: string | null,
    required?: boolean | null,
    selfAssessmentPrompt?: string | null,
    sortingIndex?: number | null,
    title?: string | null,
    helpText?: string | null,
    inputType?: InputType | null,
    instrumentId: string,
    answerOptions?:  {
      __typename: "ModelAnswerOptionConnection",
      items:  Array< {
        __typename: "AnswerOption",
        id: string,
        anchor?: string | null,
        sortingIndex?: number | null,
        helpText?: string | null,
        value?: string | null,
        questionId: string,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListQuestionsQueryVariables = {
  filter?: ModelQuestionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListQuestionsQuery = {
  listQuestions?:  {
    __typename: "ModelQuestionConnection",
    items:  Array< {
      __typename: "Question",
      id: string,
      defaultPrompt?: string | null,
      required?: boolean | null,
      selfAssessmentPrompt?: string | null,
      sortingIndex?: number | null,
      title?: string | null,
      helpText?: string | null,
      inputType?: InputType | null,
      instrumentId: string,
      answerOptions?:  {
        __typename: "ModelAnswerOptionConnection",
        items:  Array< {
          __typename: "AnswerOption",
          id: string,
          anchor?: string | null,
          sortingIndex?: number | null,
          helpText?: string | null,
          value?: string | null,
          questionId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type QuestionsByInstrumentQueryVariables = {
  instrumentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelQuestionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type QuestionsByInstrumentQuery = {
  questionsByInstrument?:  {
    __typename: "ModelQuestionConnection",
    items:  Array< {
      __typename: "Question",
      id: string,
      defaultPrompt?: string | null,
      required?: boolean | null,
      selfAssessmentPrompt?: string | null,
      sortingIndex?: number | null,
      title?: string | null,
      helpText?: string | null,
      inputType?: InputType | null,
      instrumentId: string,
      answerOptions?:  {
        __typename: "ModelAnswerOptionConnection",
        items:  Array< {
          __typename: "AnswerOption",
          id: string,
          anchor?: string | null,
          sortingIndex?: number | null,
          helpText?: string | null,
          value?: string | null,
          questionId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAnswerOptionQueryVariables = {
  id: string,
};

export type GetAnswerOptionQuery = {
  getAnswerOption?:  {
    __typename: "AnswerOption",
    id: string,
    anchor?: string | null,
    sortingIndex?: number | null,
    helpText?: string | null,
    value?: string | null,
    questionId: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAnswerOptionsQueryVariables = {
  filter?: ModelAnswerOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAnswerOptionsQuery = {
  listAnswerOptions?:  {
    __typename: "ModelAnswerOptionConnection",
    items:  Array< {
      __typename: "AnswerOption",
      id: string,
      anchor?: string | null,
      sortingIndex?: number | null,
      helpText?: string | null,
      value?: string | null,
      questionId: string,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AnswerOptionsbyQuestionQueryVariables = {
  questionId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAnswerOptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AnswerOptionsbyQuestionQuery = {
  answerOptionsbyQuestion?:  {
    __typename: "ModelAnswerOptionConnection",
    items:  Array< {
      __typename: "AnswerOption",
      id: string,
      anchor?: string | null,
      sortingIndex?: number | null,
      helpText?: string | null,
      value?: string | null,
      questionId: string,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetActivityEventQueryVariables = {
  id: string,
};

export type GetActivityEventQuery = {
  getActivityEvent?:  {
    __typename: "ActivityEvent",
    id: string,
    creatorId?: string | null,
    creator?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    participants?:  {
      __typename: "ModelActivityParticipantConnection",
      items:  Array< {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventDate?: string | null,
    notes?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListActivityEventsQueryVariables = {
  filter?: ModelActivityEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActivityEventsQuery = {
  listActivityEvents?:  {
    __typename: "ModelActivityEventConnection",
    items:  Array< {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ActivityEventsByCreatorQueryVariables = {
  creatorId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActivityEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ActivityEventsByCreatorQuery = {
  activityEventsByCreator?:  {
    __typename: "ModelActivityEventConnection",
    items:  Array< {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchActivityEventsQueryVariables = {
  filter?: SearchableActivityEventFilterInput | null,
  sort?: Array< SearchableActivityEventSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableActivityEventAggregationInput | null > | null,
};

export type SearchActivityEventsQuery = {
  searchActivityEvents?:  {
    __typename: "SearchableActivityEventConnection",
    items:  Array< {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetActivityParticipantQueryVariables = {
  id: string,
};

export type GetActivityParticipantQuery = {
  getActivityParticipant?:  {
    __typename: "ActivityParticipant",
    id: string,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventId: string,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    currentPGY?: number | null,
    currentRole?: ProgramRole | null,
    currentTraineeType?: TraineeType | null,
    currentJobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListActivityParticipantsQueryVariables = {
  filter?: ModelActivityParticipantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActivityParticipantsQuery = {
  listActivityParticipants?:  {
    __typename: "ModelActivityParticipantConnection",
    items:  Array< {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ParticipantsByActivityEventQueryVariables = {
  activityEventId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelActivityParticipantFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ParticipantsByActivityEventQuery = {
  participantsByActivityEvent?:  {
    __typename: "ModelActivityParticipantConnection",
    items:  Array< {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAssessmentEventQueryVariables = {
  id: string,
};

export type GetAssessmentEventQuery = {
  getAssessmentEvent?:  {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAssessmentEventsQueryVariables = {
  filter?: ModelAssessmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssessmentEventsQuery = {
  listAssessmentEvents?:  {
    __typename: "ModelAssessmentEventConnection",
    items:  Array< {
      __typename: "AssessmentEvent",
      id: string,
      subjectId?: string | null,
      subject?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subjectUserId?: string | null,
      raterId?: string | null,
      rater?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      raterUserId?: string | null,
      activityId?: string | null,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      activityEventId?: string | null,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answers?:  {
        __typename: "ModelAnswerEventConnection",
        items:  Array< {
          __typename: "AnswerEvent",
          id: string,
          questionId?: string | null,
          valueType?: ValueType | null,
          value?: string | null,
          assessmentEventId?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDate?: string | null,
      completionDate?: string | null,
      declined?: ReasonForDecline | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AssessmentEventbySubjectUserQueryVariables = {
  subjectUserId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssessmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AssessmentEventbySubjectUserQuery = {
  assessmentEventbySubjectUser?:  {
    __typename: "ModelAssessmentEventConnection",
    items:  Array< {
      __typename: "AssessmentEvent",
      id: string,
      subjectId?: string | null,
      subject?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subjectUserId?: string | null,
      raterId?: string | null,
      rater?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      raterUserId?: string | null,
      activityId?: string | null,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      activityEventId?: string | null,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answers?:  {
        __typename: "ModelAnswerEventConnection",
        items:  Array< {
          __typename: "AnswerEvent",
          id: string,
          questionId?: string | null,
          valueType?: ValueType | null,
          value?: string | null,
          assessmentEventId?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDate?: string | null,
      completionDate?: string | null,
      declined?: ReasonForDecline | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AssessmentEventbyRaterUserQueryVariables = {
  raterUserId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssessmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AssessmentEventbyRaterUserQuery = {
  assessmentEventbyRaterUser?:  {
    __typename: "ModelAssessmentEventConnection",
    items:  Array< {
      __typename: "AssessmentEvent",
      id: string,
      subjectId?: string | null,
      subject?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subjectUserId?: string | null,
      raterId?: string | null,
      rater?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      raterUserId?: string | null,
      activityId?: string | null,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      activityEventId?: string | null,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answers?:  {
        __typename: "ModelAnswerEventConnection",
        items:  Array< {
          __typename: "AnswerEvent",
          id: string,
          questionId?: string | null,
          valueType?: ValueType | null,
          value?: string | null,
          assessmentEventId?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDate?: string | null,
      completionDate?: string | null,
      declined?: ReasonForDecline | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AssessmentEventsByActivityQueryVariables = {
  activityId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssessmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AssessmentEventsByActivityQuery = {
  assessmentEventsByActivity?:  {
    __typename: "ModelAssessmentEventConnection",
    items:  Array< {
      __typename: "AssessmentEvent",
      id: string,
      subjectId?: string | null,
      subject?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subjectUserId?: string | null,
      raterId?: string | null,
      rater?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      raterUserId?: string | null,
      activityId?: string | null,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      activityEventId?: string | null,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answers?:  {
        __typename: "ModelAnswerEventConnection",
        items:  Array< {
          __typename: "AnswerEvent",
          id: string,
          questionId?: string | null,
          valueType?: ValueType | null,
          value?: string | null,
          assessmentEventId?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDate?: string | null,
      completionDate?: string | null,
      declined?: ReasonForDecline | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AssessmentEventsByActivityEventQueryVariables = {
  activityEventId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssessmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AssessmentEventsByActivityEventQuery = {
  assessmentEventsByActivityEvent?:  {
    __typename: "ModelAssessmentEventConnection",
    items:  Array< {
      __typename: "AssessmentEvent",
      id: string,
      subjectId?: string | null,
      subject?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subjectUserId?: string | null,
      raterId?: string | null,
      rater?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      raterUserId?: string | null,
      activityId?: string | null,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      activityEventId?: string | null,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answers?:  {
        __typename: "ModelAnswerEventConnection",
        items:  Array< {
          __typename: "AnswerEvent",
          id: string,
          questionId?: string | null,
          valueType?: ValueType | null,
          value?: string | null,
          assessmentEventId?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDate?: string | null,
      completionDate?: string | null,
      declined?: ReasonForDecline | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AssessmentEventsByProgramQueryVariables = {
  programId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAssessmentEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AssessmentEventsByProgramQuery = {
  assessmentEventsByProgram?:  {
    __typename: "ModelAssessmentEventConnection",
    items:  Array< {
      __typename: "AssessmentEvent",
      id: string,
      subjectId?: string | null,
      subject?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subjectUserId?: string | null,
      raterId?: string | null,
      rater?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      raterUserId?: string | null,
      activityId?: string | null,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      activityEventId?: string | null,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answers?:  {
        __typename: "ModelAnswerEventConnection",
        items:  Array< {
          __typename: "AnswerEvent",
          id: string,
          questionId?: string | null,
          valueType?: ValueType | null,
          value?: string | null,
          assessmentEventId?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDate?: string | null,
      completionDate?: string | null,
      declined?: ReasonForDecline | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchAssessmentEventsQueryVariables = {
  filter?: SearchableAssessmentEventFilterInput | null,
  sort?: Array< SearchableAssessmentEventSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableAssessmentEventAggregationInput | null > | null,
};

export type SearchAssessmentEventsQuery = {
  searchAssessmentEvents?:  {
    __typename: "SearchableAssessmentEventConnection",
    items:  Array< {
      __typename: "AssessmentEvent",
      id: string,
      subjectId?: string | null,
      subject?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      subjectUserId?: string | null,
      raterId?: string | null,
      rater?:  {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      raterUserId?: string | null,
      activityId?: string | null,
      activity?:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null,
      activityEventId?: string | null,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      answers?:  {
        __typename: "ModelAnswerEventConnection",
        items:  Array< {
          __typename: "AnswerEvent",
          id: string,
          questionId?: string | null,
          valueType?: ValueType | null,
          value?: string | null,
          assessmentEventId?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDate?: string | null,
      completionDate?: string | null,
      declined?: ReasonForDecline | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetAnswerEventQueryVariables = {
  id: string,
};

export type GetAnswerEventQuery = {
  getAnswerEvent?:  {
    __typename: "AnswerEvent",
    id: string,
    questionId?: string | null,
    question?:  {
      __typename: "Question",
      id: string,
      defaultPrompt?: string | null,
      required?: boolean | null,
      selfAssessmentPrompt?: string | null,
      sortingIndex?: number | null,
      title?: string | null,
      helpText?: string | null,
      inputType?: InputType | null,
      instrumentId: string,
      answerOptions?:  {
        __typename: "ModelAnswerOptionConnection",
        items:  Array< {
          __typename: "AnswerOption",
          id: string,
          anchor?: string | null,
          sortingIndex?: number | null,
          helpText?: string | null,
          value?: string | null,
          questionId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    valueType?: ValueType | null,
    value?: string | null,
    assessmentEventId?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAnswerEventsQueryVariables = {
  filter?: ModelAnswerEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAnswerEventsQuery = {
  listAnswerEvents?:  {
    __typename: "ModelAnswerEventConnection",
    items:  Array< {
      __typename: "AnswerEvent",
      id: string,
      questionId?: string | null,
      question?:  {
        __typename: "Question",
        id: string,
        defaultPrompt?: string | null,
        required?: boolean | null,
        selfAssessmentPrompt?: string | null,
        sortingIndex?: number | null,
        title?: string | null,
        helpText?: string | null,
        inputType?: InputType | null,
        instrumentId: string,
        answerOptions?:  {
          __typename: "ModelAnswerOptionConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      valueType?: ValueType | null,
      value?: string | null,
      assessmentEventId?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AnswerEventsByAssessmentEventQueryVariables = {
  assessmentEventId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelAnswerEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AnswerEventsByAssessmentEventQuery = {
  answerEventsByAssessmentEvent?:  {
    __typename: "ModelAnswerEventConnection",
    items:  Array< {
      __typename: "AnswerEvent",
      id: string,
      questionId?: string | null,
      question?:  {
        __typename: "Question",
        id: string,
        defaultPrompt?: string | null,
        required?: boolean | null,
        selfAssessmentPrompt?: string | null,
        sortingIndex?: number | null,
        title?: string | null,
        helpText?: string | null,
        inputType?: InputType | null,
        instrumentId: string,
        answerOptions?:  {
          __typename: "ModelAnswerOptionConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      valueType?: ValueType | null,
      value?: string | null,
      assessmentEventId?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type SearchAnswerEventsQueryVariables = {
  filter?: SearchableAnswerEventFilterInput | null,
  sort?: Array< SearchableAnswerEventSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableAnswerEventAggregationInput | null > | null,
};

export type SearchAnswerEventsQuery = {
  searchAnswerEvents?:  {
    __typename: "SearchableAnswerEventConnection",
    items:  Array< {
      __typename: "AnswerEvent",
      id: string,
      questionId?: string | null,
      question?:  {
        __typename: "Question",
        id: string,
        defaultPrompt?: string | null,
        required?: boolean | null,
        selfAssessmentPrompt?: string | null,
        sortingIndex?: number | null,
        title?: string | null,
        helpText?: string | null,
        inputType?: InputType | null,
        instrumentId: string,
        answerOptions?:  {
          __typename: "ModelAnswerOptionConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      valueType?: ValueType | null,
      value?: string | null,
      assessmentEventId?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type GetAcgmeProcedureQueryVariables = {
  id: string,
};

export type GetAcgmeProcedureQuery = {
  getAcgmeProcedure?:  {
    __typename: "AcgmeProcedure",
    id: string,
    name: string,
    acgmeCode: string,
    activities?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAcgmeProceduresQueryVariables = {
  filter?: ModelAcgmeProcedureFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAcgmeProceduresQuery = {
  listAcgmeProcedures?:  {
    __typename: "ModelAcgmeProcedureConnection",
    items:  Array< {
      __typename: "AcgmeProcedure",
      id: string,
      name: string,
      acgmeCode: string,
      activities?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetProgramSponsorsQueryVariables = {
  id: string,
};

export type GetProgramSponsorsQuery = {
  getProgramSponsors?:  {
    __typename: "ProgramSponsors",
    id: string,
    programID: string,
    sponsorID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    sponsor:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListProgramSponsorsQueryVariables = {
  filter?: ModelProgramSponsorsFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListProgramSponsorsQuery = {
  listProgramSponsors?:  {
    __typename: "ModelProgramSponsorsConnection",
    items:  Array< {
      __typename: "ProgramSponsors",
      id: string,
      programID: string,
      sponsorID: string,
      program:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      sponsor:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetNetworkProgramQueryVariables = {
  id: string,
};

export type GetNetworkProgramQuery = {
  getNetworkProgram?:  {
    __typename: "NetworkProgram",
    id: string,
    programID: string,
    networkID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListNetworkProgramsQueryVariables = {
  filter?: ModelNetworkProgramFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNetworkProgramsQuery = {
  listNetworkPrograms?:  {
    __typename: "ModelNetworkProgramConnection",
    items:  Array< {
      __typename: "NetworkProgram",
      id: string,
      programID: string,
      networkID: string,
      program:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      network:  {
        __typename: "Network",
        id: string,
        name: string,
        sponsorId: string,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programs?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeEnabled?: boolean | null,
        allAttendingHistoryDisabled?: boolean | null,
        simpl1Id?: number | null,
        categoriesExcludedFromRequestFlow?: Array< string | null > | null,
        dashboardURL?: string | null,
        showDashboardLink?: boolean | null,
        disableClassicReports?: boolean | null,
        traineeCanRateTrainee?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetNetworkActivityQueryVariables = {
  id: string,
};

export type GetNetworkActivityQuery = {
  getNetworkActivity?:  {
    __typename: "NetworkActivity",
    id: string,
    networkID: string,
    activityID: string,
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListNetworkActivitiesQueryVariables = {
  filter?: ModelNetworkActivityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListNetworkActivitiesQuery = {
  listNetworkActivities?:  {
    __typename: "ModelNetworkActivityConnection",
    items:  Array< {
      __typename: "NetworkActivity",
      id: string,
      networkID: string,
      activityID: string,
      network:  {
        __typename: "Network",
        id: string,
        name: string,
        sponsorId: string,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programs?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeEnabled?: boolean | null,
        allAttendingHistoryDisabled?: boolean | null,
        simpl1Id?: number | null,
        categoriesExcludedFromRequestFlow?: Array< string | null > | null,
        dashboardURL?: string | null,
        showDashboardLink?: boolean | null,
        disableClassicReports?: boolean | null,
        traineeCanRateTrainee?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      activity:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAssessmentActivityQueryVariables = {
  id: string,
};

export type GetAssessmentActivityQuery = {
  getAssessmentActivity?:  {
    __typename: "AssessmentActivity",
    id: string,
    assessmentID: string,
    activityID: string,
    assessment:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAssessmentActivitiesQueryVariables = {
  filter?: ModelAssessmentActivityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAssessmentActivitiesQuery = {
  listAssessmentActivities?:  {
    __typename: "ModelAssessmentActivityConnection",
    items:  Array< {
      __typename: "AssessmentActivity",
      id: string,
      assessmentID: string,
      activityID: string,
      assessment:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      activity:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetActivityEventActivitiesQueryVariables = {
  id: string,
};

export type GetActivityEventActivitiesQuery = {
  getActivityEventActivities?:  {
    __typename: "ActivityEventActivities",
    id: string,
    activityID: string,
    activityEventID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    activityEvent:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListActivityEventActivitiesQueryVariables = {
  filter?: ModelActivityEventActivitiesFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListActivityEventActivitiesQuery = {
  listActivityEventActivities?:  {
    __typename: "ModelActivityEventActivitiesConnection",
    items:  Array< {
      __typename: "ActivityEventActivities",
      id: string,
      activityID: string,
      activityEventID: string,
      activity:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      },
      activityEvent:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetAcgmeProcedureActivityQueryVariables = {
  id: string,
};

export type GetAcgmeProcedureActivityQuery = {
  getAcgmeProcedureActivity?:  {
    __typename: "AcgmeProcedureActivity",
    id: string,
    activityID: string,
    acgmeProcedureID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    acgmeProcedure:  {
      __typename: "AcgmeProcedure",
      id: string,
      name: string,
      acgmeCode: string,
      activities?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListAcgmeProcedureActivitiesQueryVariables = {
  filter?: ModelAcgmeProcedureActivityFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListAcgmeProcedureActivitiesQuery = {
  listAcgmeProcedureActivities?:  {
    __typename: "ModelAcgmeProcedureActivityConnection",
    items:  Array< {
      __typename: "AcgmeProcedureActivity",
      id: string,
      activityID: string,
      acgmeProcedureID: string,
      activity:  {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      },
      acgmeProcedure:  {
        __typename: "AcgmeProcedure",
        id: string,
        name: string,
        acgmeCode: string,
        activities?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id: number,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AppVersionsQueryVariables = {
};

export type AppVersionsQuery = {
  appVersions?:  {
    __typename: "AppVersions",
    iosRequired?: string | null,
    iosRecommended?: string | null,
    androidRequired?: string | null,
    androidRecommended?: string | null,
  } | null,
};

export type OnCreateInstitutionSubscriptionVariables = {
  filter?: ModelSubscriptionInstitutionFilterInput | null,
};

export type OnCreateInstitutionSubscription = {
  onCreateInstitution?:  {
    __typename: "Institution",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramConnection",
      items:  Array< {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateInstitutionSubscriptionVariables = {
  filter?: ModelSubscriptionInstitutionFilterInput | null,
};

export type OnUpdateInstitutionSubscription = {
  onUpdateInstitution?:  {
    __typename: "Institution",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramConnection",
      items:  Array< {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteInstitutionSubscriptionVariables = {
  filter?: ModelSubscriptionInstitutionFilterInput | null,
};

export type OnDeleteInstitutionSubscription = {
  onDeleteInstitution?:  {
    __typename: "Institution",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramConnection",
      items:  Array< {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    users?:  {
      __typename: "ModelUserConnection",
      items:  Array< {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProgramSubscriptionVariables = {
  filter?: ModelSubscriptionProgramFilterInput | null,
};

export type OnCreateProgramSubscription = {
  onCreateProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    institutionId: string,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsors?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProgramSubscriptionVariables = {
  filter?: ModelSubscriptionProgramFilterInput | null,
};

export type OnUpdateProgramSubscription = {
  onUpdateProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    institutionId: string,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsors?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProgramSubscriptionVariables = {
  filter?: ModelSubscriptionProgramFilterInput | null,
};

export type OnDeleteProgramSubscription = {
  onDeleteProgram?:  {
    __typename: "Program",
    id: string,
    name: string,
    description?: string | null,
    institutionId: string,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsors?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateNetworkSubscriptionVariables = {
  filter?: ModelSubscriptionNetworkFilterInput | null,
};

export type OnCreateNetworkSubscription = {
  onCreateNetwork?:  {
    __typename: "Network",
    id: string,
    name: string,
    sponsorId: string,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programs?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeEnabled?: boolean | null,
    allAttendingHistoryDisabled?: boolean | null,
    simpl1Id?: number | null,
    categoriesExcludedFromRequestFlow?: Array< string | null > | null,
    dashboardURL?: string | null,
    showDashboardLink?: boolean | null,
    disableClassicReports?: boolean | null,
    traineeCanRateTrainee?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateNetworkSubscriptionVariables = {
  filter?: ModelSubscriptionNetworkFilterInput | null,
};

export type OnUpdateNetworkSubscription = {
  onUpdateNetwork?:  {
    __typename: "Network",
    id: string,
    name: string,
    sponsorId: string,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programs?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeEnabled?: boolean | null,
    allAttendingHistoryDisabled?: boolean | null,
    simpl1Id?: number | null,
    categoriesExcludedFromRequestFlow?: Array< string | null > | null,
    dashboardURL?: string | null,
    showDashboardLink?: boolean | null,
    disableClassicReports?: boolean | null,
    traineeCanRateTrainee?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteNetworkSubscriptionVariables = {
  filter?: ModelSubscriptionNetworkFilterInput | null,
};

export type OnDeleteNetworkSubscription = {
  onDeleteNetwork?:  {
    __typename: "Network",
    id: string,
    name: string,
    sponsorId: string,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programs?:  {
      __typename: "ModelNetworkProgramConnection",
      items:  Array< {
        __typename: "NetworkProgram",
        id: string,
        programID: string,
        networkID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeEnabled?: boolean | null,
    allAttendingHistoryDisabled?: boolean | null,
    simpl1Id?: number | null,
    categoriesExcludedFromRequestFlow?: Array< string | null > | null,
    dashboardURL?: string | null,
    showDashboardLink?: boolean | null,
    disableClassicReports?: boolean | null,
    traineeCanRateTrainee?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnCreateUserSubscription = {
  onCreateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    emailLower?: string | null,
    institutionId?: string | null,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoUsername?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    suffix?: string | null,
    npi?: number | null,
    simplLearnId?: string | null,
    pgy?: number | null,
    settings?:  {
      __typename: "UserSettings",
      sendEmail?: boolean | null,
      sendPushNotifications?: boolean | null,
    } | null,
    lastLogin?: string | null,
    eulaAcceptedDate?: string | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deviceToken?: string | null,
    devicePlatform?: DevicePlatform | null,
    inviteId?: string | null,
    invite?:  {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnUpdateUserSubscription = {
  onUpdateUser?:  {
    __typename: "User",
    id: string,
    email: string,
    emailLower?: string | null,
    institutionId?: string | null,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoUsername?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    suffix?: string | null,
    npi?: number | null,
    simplLearnId?: string | null,
    pgy?: number | null,
    settings?:  {
      __typename: "UserSettings",
      sendEmail?: boolean | null,
      sendPushNotifications?: boolean | null,
    } | null,
    lastLogin?: string | null,
    eulaAcceptedDate?: string | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deviceToken?: string | null,
    devicePlatform?: DevicePlatform | null,
    inviteId?: string | null,
    invite?:  {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterInput | null,
};

export type OnDeleteUserSubscription = {
  onDeleteUser?:  {
    __typename: "User",
    id: string,
    email: string,
    emailLower?: string | null,
    institutionId?: string | null,
    institution?:  {
      __typename: "Institution",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramConnection",
        items:  Array< {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      users?:  {
        __typename: "ModelUserConnection",
        items:  Array< {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    cognitoUsername?: string | null,
    firstName?: string | null,
    lastName?: string | null,
    suffix?: string | null,
    npi?: number | null,
    simplLearnId?: string | null,
    pgy?: number | null,
    settings?:  {
      __typename: "UserSettings",
      sendEmail?: boolean | null,
      sendPushNotifications?: boolean | null,
    } | null,
    lastLogin?: string | null,
    eulaAcceptedDate?: string | null,
    programMemberships?:  {
      __typename: "ModelProgramMembershipConnection",
      items:  Array< {
        __typename: "ProgramMembership",
        id: string,
        programRole: ProgramRole,
        traineeType?: TraineeType | null,
        programMemberId: string,
        programId: string,
        programMember?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        startDate?: string | null,
        endDate?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    deviceToken?: string | null,
    devicePlatform?: DevicePlatform | null,
    inviteId?: string | null,
    invite?:  {
      __typename: "UserInvitation",
      id: string,
      inviteeId?: string | null,
      invitee:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      },
      institutionId: string,
      invitationStatus: InvitationStatus,
      email?: string | null,
      emailLower?: string | null,
      adminId?: string | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      role?: ProgramRole | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    jobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateUserInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionUserInvitationFilterInput | null,
};

export type OnCreateUserInvitationSubscription = {
  onCreateUserInvitation?:  {
    __typename: "UserInvitation",
    id: string,
    inviteeId?: string | null,
    invitee:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    institutionId: string,
    invitationStatus: InvitationStatus,
    email?: string | null,
    emailLower?: string | null,
    adminId?: string | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    role?: ProgramRole | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateUserInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionUserInvitationFilterInput | null,
};

export type OnUpdateUserInvitationSubscription = {
  onUpdateUserInvitation?:  {
    __typename: "UserInvitation",
    id: string,
    inviteeId?: string | null,
    invitee:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    institutionId: string,
    invitationStatus: InvitationStatus,
    email?: string | null,
    emailLower?: string | null,
    adminId?: string | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    role?: ProgramRole | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteUserInvitationSubscriptionVariables = {
  filter?: ModelSubscriptionUserInvitationFilterInput | null,
};

export type OnDeleteUserInvitationSubscription = {
  onDeleteUserInvitation?:  {
    __typename: "UserInvitation",
    id: string,
    inviteeId?: string | null,
    invitee:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    institutionId: string,
    invitationStatus: InvitationStatus,
    email?: string | null,
    emailLower?: string | null,
    adminId?: string | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    role?: ProgramRole | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProgramMembershipSubscriptionVariables = {
  filter?: ModelSubscriptionProgramMembershipFilterInput | null,
};

export type OnCreateProgramMembershipSubscription = {
  onCreateProgramMembership?:  {
    __typename: "ProgramMembership",
    id: string,
    programRole: ProgramRole,
    traineeType?: TraineeType | null,
    programMemberId: string,
    programId: string,
    programMember?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate?: string | null,
    endDate?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProgramMembershipSubscriptionVariables = {
  filter?: ModelSubscriptionProgramMembershipFilterInput | null,
};

export type OnUpdateProgramMembershipSubscription = {
  onUpdateProgramMembership?:  {
    __typename: "ProgramMembership",
    id: string,
    programRole: ProgramRole,
    traineeType?: TraineeType | null,
    programMemberId: string,
    programId: string,
    programMember?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate?: string | null,
    endDate?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProgramMembershipSubscriptionVariables = {
  filter?: ModelSubscriptionProgramMembershipFilterInput | null,
};

export type OnDeleteProgramMembershipSubscription = {
  onDeleteProgramMembership?:  {
    __typename: "ProgramMembership",
    id: string,
    programRole: ProgramRole,
    traineeType?: TraineeType | null,
    programMemberId: string,
    programId: string,
    programMember?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    startDate?: string | null,
    endDate?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateEULATextSubscriptionVariables = {
  filter?: ModelSubscriptionEULATextFilterInput | null,
};

export type OnCreateEULATextSubscription = {
  onCreateEULAText?:  {
    __typename: "EULAText",
    id: string,
    formattedText: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateEULATextSubscriptionVariables = {
  filter?: ModelSubscriptionEULATextFilterInput | null,
};

export type OnUpdateEULATextSubscription = {
  onUpdateEULAText?:  {
    __typename: "EULAText",
    id: string,
    formattedText: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteEULATextSubscriptionVariables = {
  filter?: ModelSubscriptionEULATextFilterInput | null,
};

export type OnDeleteEULATextSubscription = {
  onDeleteEULAText?:  {
    __typename: "EULAText",
    id: string,
    formattedText: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMilestoneSubscriptionVariables = {
  filter?: ModelSubscriptionMilestoneFilterInput | null,
};

export type OnCreateMilestoneSubscription = {
  onCreateMilestone?:  {
    __typename: "Milestone",
    id: string,
    shortName: string,
    name: string,
    description?: string | null,
    scale: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMilestoneSubscriptionVariables = {
  filter?: ModelSubscriptionMilestoneFilterInput | null,
};

export type OnUpdateMilestoneSubscription = {
  onUpdateMilestone?:  {
    __typename: "Milestone",
    id: string,
    shortName: string,
    name: string,
    description?: string | null,
    scale: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMilestoneSubscriptionVariables = {
  filter?: ModelSubscriptionMilestoneFilterInput | null,
};

export type OnDeleteMilestoneSubscription = {
  onDeleteMilestone?:  {
    __typename: "Milestone",
    id: string,
    shortName: string,
    name: string,
    description?: string | null,
    scale: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateMilestoneNetworkRatingSubscriptionVariables = {
  filter?: ModelSubscriptionMilestoneNetworkRatingFilterInput | null,
};

export type OnCreateMilestoneNetworkRatingSubscription = {
  onCreateMilestoneNetworkRating?:  {
    __typename: "MilestoneNetworkRating",
    id: string,
    activityId: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    networkId: string,
    network?:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneId: string,
    milestone?:  {
      __typename: "Milestone",
      id: string,
      shortName: string,
      name: string,
      description?: string | null,
      scale: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answerOptionId: string,
    answerOption?:  {
      __typename: "AnswerOption",
      id: string,
      anchor?: string | null,
      sortingIndex?: number | null,
      helpText?: string | null,
      value?: string | null,
      questionId: string,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneRating: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateMilestoneNetworkRatingSubscriptionVariables = {
  filter?: ModelSubscriptionMilestoneNetworkRatingFilterInput | null,
};

export type OnUpdateMilestoneNetworkRatingSubscription = {
  onUpdateMilestoneNetworkRating?:  {
    __typename: "MilestoneNetworkRating",
    id: string,
    activityId: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    networkId: string,
    network?:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneId: string,
    milestone?:  {
      __typename: "Milestone",
      id: string,
      shortName: string,
      name: string,
      description?: string | null,
      scale: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answerOptionId: string,
    answerOption?:  {
      __typename: "AnswerOption",
      id: string,
      anchor?: string | null,
      sortingIndex?: number | null,
      helpText?: string | null,
      value?: string | null,
      questionId: string,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneRating: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteMilestoneNetworkRatingSubscriptionVariables = {
  filter?: ModelSubscriptionMilestoneNetworkRatingFilterInput | null,
};

export type OnDeleteMilestoneNetworkRatingSubscription = {
  onDeleteMilestoneNetworkRating?:  {
    __typename: "MilestoneNetworkRating",
    id: string,
    activityId: string,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    networkId: string,
    network?:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneId: string,
    milestone?:  {
      __typename: "Milestone",
      id: string,
      shortName: string,
      name: string,
      description?: string | null,
      scale: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answerOptionId: string,
    answerOption?:  {
      __typename: "AnswerOption",
      id: string,
      anchor?: string | null,
      sortingIndex?: number | null,
      helpText?: string | null,
      value?: string | null,
      questionId: string,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    milestoneRating: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateSponsorSubscriptionVariables = {
  filter?: ModelSubscriptionSponsorFilterInput | null,
};

export type OnCreateSponsorSubscription = {
  onCreateSponsor?:  {
    __typename: "Sponsor",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkConnection",
      items:  Array< {
        __typename: "Network",
        id: string,
        name: string,
        sponsorId: string,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programs?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeEnabled?: boolean | null,
        allAttendingHistoryDisabled?: boolean | null,
        simpl1Id?: number | null,
        categoriesExcludedFromRequestFlow?: Array< string | null > | null,
        dashboardURL?: string | null,
        showDashboardLink?: boolean | null,
        disableClassicReports?: boolean | null,
        traineeCanRateTrainee?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    branding?:  {
      __typename: "SponsorBranding",
      colors?:  {
        __typename: "SponsorColors",
        primary?: string | null,
        secondary?: string | null,
        light?: string | null,
      } | null,
      logos?:  {
        __typename: "SponsorLogos",
        fullMono?: string | null,
        fullColor?: string | null,
        squareMono?: string | null,
        squareColor?: string | null,
        email?: string | null,
      } | null,
    } | null,
    activityLabel?: string | null,
    autoAssignActivities?: Array< string > | null,
    dashboardURL?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateSponsorSubscriptionVariables = {
  filter?: ModelSubscriptionSponsorFilterInput | null,
};

export type OnUpdateSponsorSubscription = {
  onUpdateSponsor?:  {
    __typename: "Sponsor",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkConnection",
      items:  Array< {
        __typename: "Network",
        id: string,
        name: string,
        sponsorId: string,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programs?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeEnabled?: boolean | null,
        allAttendingHistoryDisabled?: boolean | null,
        simpl1Id?: number | null,
        categoriesExcludedFromRequestFlow?: Array< string | null > | null,
        dashboardURL?: string | null,
        showDashboardLink?: boolean | null,
        disableClassicReports?: boolean | null,
        traineeCanRateTrainee?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    branding?:  {
      __typename: "SponsorBranding",
      colors?:  {
        __typename: "SponsorColors",
        primary?: string | null,
        secondary?: string | null,
        light?: string | null,
      } | null,
      logos?:  {
        __typename: "SponsorLogos",
        fullMono?: string | null,
        fullColor?: string | null,
        squareMono?: string | null,
        squareColor?: string | null,
        email?: string | null,
      } | null,
    } | null,
    activityLabel?: string | null,
    autoAssignActivities?: Array< string > | null,
    dashboardURL?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteSponsorSubscriptionVariables = {
  filter?: ModelSubscriptionSponsorFilterInput | null,
};

export type OnDeleteSponsorSubscription = {
  onDeleteSponsor?:  {
    __typename: "Sponsor",
    id: string,
    name?: string | null,
    description?: string | null,
    programs?:  {
      __typename: "ModelProgramSponsorsConnection",
      items:  Array< {
        __typename: "ProgramSponsors",
        id: string,
        programID: string,
        sponsorID: string,
        program:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        sponsor:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    networks?:  {
      __typename: "ModelNetworkConnection",
      items:  Array< {
        __typename: "Network",
        id: string,
        name: string,
        sponsorId: string,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programs?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeEnabled?: boolean | null,
        allAttendingHistoryDisabled?: boolean | null,
        simpl1Id?: number | null,
        categoriesExcludedFromRequestFlow?: Array< string | null > | null,
        dashboardURL?: string | null,
        showDashboardLink?: boolean | null,
        disableClassicReports?: boolean | null,
        traineeCanRateTrainee?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    branding?:  {
      __typename: "SponsorBranding",
      colors?:  {
        __typename: "SponsorColors",
        primary?: string | null,
        secondary?: string | null,
        light?: string | null,
      } | null,
      logos?:  {
        __typename: "SponsorLogos",
        fullMono?: string | null,
        fullColor?: string | null,
        squareMono?: string | null,
        squareColor?: string | null,
        email?: string | null,
      } | null,
    } | null,
    activityLabel?: string | null,
    autoAssignActivities?: Array< string > | null,
    dashboardURL?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAssessmentSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentFilterInput | null,
};

export type OnCreateAssessmentSubscription = {
  onCreateAssessment?:  {
    __typename: "Assessment",
    id: string,
    title?: string | null,
    description?: string | null,
    instrumentId?: string | null,
    instrument?:  {
      __typename: "Instrument",
      id: string,
      title?: string | null,
      description?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    multiActivities?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDurationHours?: number | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requireTraineeSelfAssessment?: boolean | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    published?: boolean | null,
    archived?: boolean | null,
    version?: string | null,
    creationDurationHours?: number | null,
    showFeedbackQuestionsToTrainees?: boolean | null,
    sendEmailForSelfAssessment?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAssessmentSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentFilterInput | null,
};

export type OnUpdateAssessmentSubscription = {
  onUpdateAssessment?:  {
    __typename: "Assessment",
    id: string,
    title?: string | null,
    description?: string | null,
    instrumentId?: string | null,
    instrument?:  {
      __typename: "Instrument",
      id: string,
      title?: string | null,
      description?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    multiActivities?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDurationHours?: number | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requireTraineeSelfAssessment?: boolean | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    published?: boolean | null,
    archived?: boolean | null,
    version?: string | null,
    creationDurationHours?: number | null,
    showFeedbackQuestionsToTrainees?: boolean | null,
    sendEmailForSelfAssessment?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAssessmentSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentFilterInput | null,
};

export type OnDeleteAssessmentSubscription = {
  onDeleteAssessment?:  {
    __typename: "Assessment",
    id: string,
    title?: string | null,
    description?: string | null,
    instrumentId?: string | null,
    instrument?:  {
      __typename: "Instrument",
      id: string,
      title?: string | null,
      description?: string | null,
      questions?:  {
        __typename: "ModelQuestionConnection",
        items:  Array< {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    multiActivities?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDurationHours?: number | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requireTraineeSelfAssessment?: boolean | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    published?: boolean | null,
    archived?: boolean | null,
    version?: string | null,
    creationDurationHours?: number | null,
    showFeedbackQuestionsToTrainees?: boolean | null,
    sendEmailForSelfAssessment?: boolean | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateInstrumentSubscriptionVariables = {
  filter?: ModelSubscriptionInstrumentFilterInput | null,
};

export type OnCreateInstrumentSubscription = {
  onCreateInstrument?:  {
    __typename: "Instrument",
    id: string,
    title?: string | null,
    description?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        defaultPrompt?: string | null,
        required?: boolean | null,
        selfAssessmentPrompt?: string | null,
        sortingIndex?: number | null,
        title?: string | null,
        helpText?: string | null,
        inputType?: InputType | null,
        instrumentId: string,
        answerOptions?:  {
          __typename: "ModelAnswerOptionConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateInstrumentSubscriptionVariables = {
  filter?: ModelSubscriptionInstrumentFilterInput | null,
};

export type OnUpdateInstrumentSubscription = {
  onUpdateInstrument?:  {
    __typename: "Instrument",
    id: string,
    title?: string | null,
    description?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        defaultPrompt?: string | null,
        required?: boolean | null,
        selfAssessmentPrompt?: string | null,
        sortingIndex?: number | null,
        title?: string | null,
        helpText?: string | null,
        inputType?: InputType | null,
        instrumentId: string,
        answerOptions?:  {
          __typename: "ModelAnswerOptionConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteInstrumentSubscriptionVariables = {
  filter?: ModelSubscriptionInstrumentFilterInput | null,
};

export type OnDeleteInstrumentSubscription = {
  onDeleteInstrument?:  {
    __typename: "Instrument",
    id: string,
    title?: string | null,
    description?: string | null,
    questions?:  {
      __typename: "ModelQuestionConnection",
      items:  Array< {
        __typename: "Question",
        id: string,
        defaultPrompt?: string | null,
        required?: boolean | null,
        selfAssessmentPrompt?: string | null,
        sortingIndex?: number | null,
        title?: string | null,
        helpText?: string | null,
        inputType?: InputType | null,
        instrumentId: string,
        answerOptions?:  {
          __typename: "ModelAnswerOptionConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateActivitySubscriptionVariables = {
  filter?: ModelSubscriptionActivityFilterInput | null,
};

export type OnCreateActivitySubscription = {
  onCreateActivity?:  {
    __typename: "Activity",
    id: string,
    title?: string | null,
    description?: string | null,
    subActivities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessments?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activityEvents?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    networks?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeProcedures?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    categories?: Array< string > | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
    activitySubActivitiesId?: string | null,
  } | null,
};

export type OnUpdateActivitySubscriptionVariables = {
  filter?: ModelSubscriptionActivityFilterInput | null,
};

export type OnUpdateActivitySubscription = {
  onUpdateActivity?:  {
    __typename: "Activity",
    id: string,
    title?: string | null,
    description?: string | null,
    subActivities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessments?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activityEvents?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    networks?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeProcedures?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    categories?: Array< string > | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
    activitySubActivitiesId?: string | null,
  } | null,
};

export type OnDeleteActivitySubscriptionVariables = {
  filter?: ModelSubscriptionActivityFilterInput | null,
};

export type OnDeleteActivitySubscription = {
  onDeleteActivity?:  {
    __typename: "Activity",
    id: string,
    title?: string | null,
    description?: string | null,
    subActivities?:  {
      __typename: "ModelActivityConnection",
      items:  Array< {
        __typename: "Activity",
        id: string,
        title?: string | null,
        description?: string | null,
        subActivities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessments?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        activityEvents?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        networks?:  {
          __typename: "ModelNetworkActivityConnection",
          nextToken?: string | null,
        } | null,
        acgmeProcedures?:  {
          __typename: "ModelAcgmeProcedureActivityConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        categories?: Array< string > | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
        activitySubActivitiesId?: string | null,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessments?:  {
      __typename: "ModelAssessmentActivityConnection",
      items:  Array< {
        __typename: "AssessmentActivity",
        id: string,
        assessmentID: string,
        activityID: string,
        assessment:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activityEvents?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    sponsorId?: string | null,
    sponsor?:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    authorId?: string | null,
    author?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    version?: string | null,
    networks?:  {
      __typename: "ModelNetworkActivityConnection",
      items:  Array< {
        __typename: "NetworkActivity",
        id: string,
        networkID: string,
        activityID: string,
        network:  {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    acgmeProcedures?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id?: number | null,
    categories?: Array< string > | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
    activitySubActivitiesId?: string | null,
  } | null,
};

export type OnCreateQuestionSubscriptionVariables = {
  filter?: ModelSubscriptionQuestionFilterInput | null,
};

export type OnCreateQuestionSubscription = {
  onCreateQuestion?:  {
    __typename: "Question",
    id: string,
    defaultPrompt?: string | null,
    required?: boolean | null,
    selfAssessmentPrompt?: string | null,
    sortingIndex?: number | null,
    title?: string | null,
    helpText?: string | null,
    inputType?: InputType | null,
    instrumentId: string,
    answerOptions?:  {
      __typename: "ModelAnswerOptionConnection",
      items:  Array< {
        __typename: "AnswerOption",
        id: string,
        anchor?: string | null,
        sortingIndex?: number | null,
        helpText?: string | null,
        value?: string | null,
        questionId: string,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateQuestionSubscriptionVariables = {
  filter?: ModelSubscriptionQuestionFilterInput | null,
};

export type OnUpdateQuestionSubscription = {
  onUpdateQuestion?:  {
    __typename: "Question",
    id: string,
    defaultPrompt?: string | null,
    required?: boolean | null,
    selfAssessmentPrompt?: string | null,
    sortingIndex?: number | null,
    title?: string | null,
    helpText?: string | null,
    inputType?: InputType | null,
    instrumentId: string,
    answerOptions?:  {
      __typename: "ModelAnswerOptionConnection",
      items:  Array< {
        __typename: "AnswerOption",
        id: string,
        anchor?: string | null,
        sortingIndex?: number | null,
        helpText?: string | null,
        value?: string | null,
        questionId: string,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteQuestionSubscriptionVariables = {
  filter?: ModelSubscriptionQuestionFilterInput | null,
};

export type OnDeleteQuestionSubscription = {
  onDeleteQuestion?:  {
    __typename: "Question",
    id: string,
    defaultPrompt?: string | null,
    required?: boolean | null,
    selfAssessmentPrompt?: string | null,
    sortingIndex?: number | null,
    title?: string | null,
    helpText?: string | null,
    inputType?: InputType | null,
    instrumentId: string,
    answerOptions?:  {
      __typename: "ModelAnswerOptionConnection",
      items:  Array< {
        __typename: "AnswerOption",
        id: string,
        anchor?: string | null,
        sortingIndex?: number | null,
        helpText?: string | null,
        value?: string | null,
        questionId: string,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAnswerOptionSubscriptionVariables = {
  filter?: ModelSubscriptionAnswerOptionFilterInput | null,
};

export type OnCreateAnswerOptionSubscription = {
  onCreateAnswerOption?:  {
    __typename: "AnswerOption",
    id: string,
    anchor?: string | null,
    sortingIndex?: number | null,
    helpText?: string | null,
    value?: string | null,
    questionId: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAnswerOptionSubscriptionVariables = {
  filter?: ModelSubscriptionAnswerOptionFilterInput | null,
};

export type OnUpdateAnswerOptionSubscription = {
  onUpdateAnswerOption?:  {
    __typename: "AnswerOption",
    id: string,
    anchor?: string | null,
    sortingIndex?: number | null,
    helpText?: string | null,
    value?: string | null,
    questionId: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAnswerOptionSubscriptionVariables = {
  filter?: ModelSubscriptionAnswerOptionFilterInput | null,
};

export type OnDeleteAnswerOptionSubscription = {
  onDeleteAnswerOption?:  {
    __typename: "AnswerOption",
    id: string,
    anchor?: string | null,
    sortingIndex?: number | null,
    helpText?: string | null,
    value?: string | null,
    questionId: string,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateActivityEventSubscriptionVariables = {
  filter?: ModelSubscriptionActivityEventFilterInput | null,
};

export type OnCreateActivityEventSubscription = {
  onCreateActivityEvent?:  {
    __typename: "ActivityEvent",
    id: string,
    creatorId?: string | null,
    creator?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    participants?:  {
      __typename: "ModelActivityParticipantConnection",
      items:  Array< {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventDate?: string | null,
    notes?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateActivityEventSubscriptionVariables = {
  filter?: ModelSubscriptionActivityEventFilterInput | null,
};

export type OnUpdateActivityEventSubscription = {
  onUpdateActivityEvent?:  {
    __typename: "ActivityEvent",
    id: string,
    creatorId?: string | null,
    creator?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    participants?:  {
      __typename: "ModelActivityParticipantConnection",
      items:  Array< {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventDate?: string | null,
    notes?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteActivityEventSubscriptionVariables = {
  filter?: ModelSubscriptionActivityEventFilterInput | null,
};

export type OnDeleteActivityEventSubscription = {
  onDeleteActivityEvent?:  {
    __typename: "ActivityEvent",
    id: string,
    creatorId?: string | null,
    creator?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    participants?:  {
      __typename: "ModelActivityParticipantConnection",
      items:  Array< {
        __typename: "ActivityParticipant",
        id: string,
        userId?: string | null,
        user?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventId: string,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        currentPGY?: number | null,
        currentRole?: ProgramRole | null,
        currentTraineeType?: TraineeType | null,
        currentJobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    activities?:  {
      __typename: "ModelActivityEventActivitiesConnection",
      items:  Array< {
        __typename: "ActivityEventActivities",
        id: string,
        activityID: string,
        activityEventID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        activityEvent:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    assessmentEvents?:  {
      __typename: "ModelAssessmentEventConnection",
      items:  Array< {
        __typename: "AssessmentEvent",
        id: string,
        subjectId?: string | null,
        subject?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        subjectUserId?: string | null,
        raterId?: string | null,
        rater?:  {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        raterUserId?: string | null,
        activityId?: string | null,
        activity?:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null,
        activityEventId?: string | null,
        activityEvent?:  {
          __typename: "ActivityEvent",
          id: string,
          creatorId?: string | null,
          programId?: string | null,
          activityEventDate?: string | null,
          notes?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        assessmentId?: string | null,
        assessment?:  {
          __typename: "Assessment",
          id: string,
          title?: string | null,
          description?: string | null,
          instrumentId?: string | null,
          expirationDurationHours?: number | null,
          sponsorId?: string | null,
          requireTraineeSelfAssessment?: boolean | null,
          authorId?: string | null,
          published?: boolean | null,
          archived?: boolean | null,
          version?: string | null,
          creationDurationHours?: number | null,
          showFeedbackQuestionsToTrainees?: boolean | null,
          sendEmailForSelfAssessment?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        answers?:  {
          __typename: "ModelAnswerEventConnection",
          nextToken?: string | null,
        } | null,
        expirationDate?: string | null,
        completionDate?: string | null,
        declined?: ReasonForDecline | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventDate?: string | null,
    notes?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateActivityParticipantSubscriptionVariables = {
  filter?: ModelSubscriptionActivityParticipantFilterInput | null,
};

export type OnCreateActivityParticipantSubscription = {
  onCreateActivityParticipant?:  {
    __typename: "ActivityParticipant",
    id: string,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventId: string,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    currentPGY?: number | null,
    currentRole?: ProgramRole | null,
    currentTraineeType?: TraineeType | null,
    currentJobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateActivityParticipantSubscriptionVariables = {
  filter?: ModelSubscriptionActivityParticipantFilterInput | null,
};

export type OnUpdateActivityParticipantSubscription = {
  onUpdateActivityParticipant?:  {
    __typename: "ActivityParticipant",
    id: string,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventId: string,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    currentPGY?: number | null,
    currentRole?: ProgramRole | null,
    currentTraineeType?: TraineeType | null,
    currentJobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteActivityParticipantSubscriptionVariables = {
  filter?: ModelSubscriptionActivityParticipantFilterInput | null,
};

export type OnDeleteActivityParticipantSubscription = {
  onDeleteActivityParticipant?:  {
    __typename: "ActivityParticipant",
    id: string,
    userId?: string | null,
    user?:  {
      __typename: "User",
      id: string,
      email: string,
      emailLower?: string | null,
      institutionId?: string | null,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      cognitoUsername?: string | null,
      firstName?: string | null,
      lastName?: string | null,
      suffix?: string | null,
      npi?: number | null,
      simplLearnId?: string | null,
      pgy?: number | null,
      settings?:  {
        __typename: "UserSettings",
        sendEmail?: boolean | null,
        sendPushNotifications?: boolean | null,
      } | null,
      lastLogin?: string | null,
      eulaAcceptedDate?: string | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deviceToken?: string | null,
      devicePlatform?: DevicePlatform | null,
      inviteId?: string | null,
      invite?:  {
        __typename: "UserInvitation",
        id: string,
        inviteeId?: string | null,
        invitee:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        institutionId: string,
        invitationStatus: InvitationStatus,
        email?: string | null,
        emailLower?: string | null,
        adminId?: string | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        role?: ProgramRole | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      jobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    activityEventId: string,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    currentPGY?: number | null,
    currentRole?: ProgramRole | null,
    currentTraineeType?: TraineeType | null,
    currentJobTitle?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAssessmentEventSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentEventFilterInput | null,
};

export type OnCreateAssessmentEventSubscription = {
  onCreateAssessmentEvent?:  {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAssessmentEventSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentEventFilterInput | null,
};

export type OnUpdateAssessmentEventSubscription = {
  onUpdateAssessmentEvent?:  {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAssessmentEventSubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentEventFilterInput | null,
};

export type OnDeleteAssessmentEventSubscription = {
  onDeleteAssessmentEvent?:  {
    __typename: "AssessmentEvent",
    id: string,
    subjectId?: string | null,
    subject?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    subjectUserId?: string | null,
    raterId?: string | null,
    rater?:  {
      __typename: "ActivityParticipant",
      id: string,
      userId?: string | null,
      user?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventId: string,
      activityEvent?:  {
        __typename: "ActivityEvent",
        id: string,
        creatorId?: string | null,
        creator?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        participants?:  {
          __typename: "ModelActivityParticipantConnection",
          nextToken?: string | null,
        } | null,
        activities?:  {
          __typename: "ModelActivityEventActivitiesConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        programId?: string | null,
        program?:  {
          __typename: "Program",
          id: string,
          name: string,
          description?: string | null,
          institutionId: string,
          simpl1Id?: number | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activityEventDate?: string | null,
        notes?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programId?: string | null,
      currentPGY?: number | null,
      currentRole?: ProgramRole | null,
      currentTraineeType?: TraineeType | null,
      currentJobTitle?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    raterUserId?: string | null,
    activityId?: string | null,
    activity?:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    } | null,
    activityEventId?: string | null,
    activityEvent?:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    programId?: string | null,
    program?:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    assessmentId?: string | null,
    assessment?:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    answers?:  {
      __typename: "ModelAnswerEventConnection",
      items:  Array< {
        __typename: "AnswerEvent",
        id: string,
        questionId?: string | null,
        question?:  {
          __typename: "Question",
          id: string,
          defaultPrompt?: string | null,
          required?: boolean | null,
          selfAssessmentPrompt?: string | null,
          sortingIndex?: number | null,
          title?: string | null,
          helpText?: string | null,
          inputType?: InputType | null,
          instrumentId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        valueType?: ValueType | null,
        value?: string | null,
        assessmentEventId?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    expirationDate?: string | null,
    completionDate?: string | null,
    declined?: ReasonForDecline | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAnswerEventSubscriptionVariables = {
  filter?: ModelSubscriptionAnswerEventFilterInput | null,
};

export type OnCreateAnswerEventSubscription = {
  onCreateAnswerEvent?:  {
    __typename: "AnswerEvent",
    id: string,
    questionId?: string | null,
    question?:  {
      __typename: "Question",
      id: string,
      defaultPrompt?: string | null,
      required?: boolean | null,
      selfAssessmentPrompt?: string | null,
      sortingIndex?: number | null,
      title?: string | null,
      helpText?: string | null,
      inputType?: InputType | null,
      instrumentId: string,
      answerOptions?:  {
        __typename: "ModelAnswerOptionConnection",
        items:  Array< {
          __typename: "AnswerOption",
          id: string,
          anchor?: string | null,
          sortingIndex?: number | null,
          helpText?: string | null,
          value?: string | null,
          questionId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    valueType?: ValueType | null,
    value?: string | null,
    assessmentEventId?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAnswerEventSubscriptionVariables = {
  filter?: ModelSubscriptionAnswerEventFilterInput | null,
};

export type OnUpdateAnswerEventSubscription = {
  onUpdateAnswerEvent?:  {
    __typename: "AnswerEvent",
    id: string,
    questionId?: string | null,
    question?:  {
      __typename: "Question",
      id: string,
      defaultPrompt?: string | null,
      required?: boolean | null,
      selfAssessmentPrompt?: string | null,
      sortingIndex?: number | null,
      title?: string | null,
      helpText?: string | null,
      inputType?: InputType | null,
      instrumentId: string,
      answerOptions?:  {
        __typename: "ModelAnswerOptionConnection",
        items:  Array< {
          __typename: "AnswerOption",
          id: string,
          anchor?: string | null,
          sortingIndex?: number | null,
          helpText?: string | null,
          value?: string | null,
          questionId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    valueType?: ValueType | null,
    value?: string | null,
    assessmentEventId?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAnswerEventSubscriptionVariables = {
  filter?: ModelSubscriptionAnswerEventFilterInput | null,
};

export type OnDeleteAnswerEventSubscription = {
  onDeleteAnswerEvent?:  {
    __typename: "AnswerEvent",
    id: string,
    questionId?: string | null,
    question?:  {
      __typename: "Question",
      id: string,
      defaultPrompt?: string | null,
      required?: boolean | null,
      selfAssessmentPrompt?: string | null,
      sortingIndex?: number | null,
      title?: string | null,
      helpText?: string | null,
      inputType?: InputType | null,
      instrumentId: string,
      answerOptions?:  {
        __typename: "ModelAnswerOptionConnection",
        items:  Array< {
          __typename: "AnswerOption",
          id: string,
          anchor?: string | null,
          sortingIndex?: number | null,
          helpText?: string | null,
          value?: string | null,
          questionId: string,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    valueType?: ValueType | null,
    value?: string | null,
    assessmentEventId?: string | null,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAcgmeProcedureSubscriptionVariables = {
  filter?: ModelSubscriptionAcgmeProcedureFilterInput | null,
};

export type OnCreateAcgmeProcedureSubscription = {
  onCreateAcgmeProcedure?:  {
    __typename: "AcgmeProcedure",
    id: string,
    name: string,
    acgmeCode: string,
    activities?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAcgmeProcedureSubscriptionVariables = {
  filter?: ModelSubscriptionAcgmeProcedureFilterInput | null,
};

export type OnUpdateAcgmeProcedureSubscription = {
  onUpdateAcgmeProcedure?:  {
    __typename: "AcgmeProcedure",
    id: string,
    name: string,
    acgmeCode: string,
    activities?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAcgmeProcedureSubscriptionVariables = {
  filter?: ModelSubscriptionAcgmeProcedureFilterInput | null,
};

export type OnDeleteAcgmeProcedureSubscription = {
  onDeleteAcgmeProcedure?:  {
    __typename: "AcgmeProcedure",
    id: string,
    name: string,
    acgmeCode: string,
    activities?:  {
      __typename: "ModelAcgmeProcedureActivityConnection",
      items:  Array< {
        __typename: "AcgmeProcedureActivity",
        id: string,
        activityID: string,
        acgmeProcedureID: string,
        activity:  {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        },
        acgmeProcedure:  {
          __typename: "AcgmeProcedure",
          id: string,
          name: string,
          acgmeCode: string,
          simpl1Id: number,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        },
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    simpl1Id: number,
    deletedAt?: string | null,
    deletedBy?: string | null,
    deletedReason?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateProgramSponsorsSubscriptionVariables = {
  filter?: ModelSubscriptionProgramSponsorsFilterInput | null,
};

export type OnCreateProgramSponsorsSubscription = {
  onCreateProgramSponsors?:  {
    __typename: "ProgramSponsors",
    id: string,
    programID: string,
    sponsorID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    sponsor:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateProgramSponsorsSubscriptionVariables = {
  filter?: ModelSubscriptionProgramSponsorsFilterInput | null,
};

export type OnUpdateProgramSponsorsSubscription = {
  onUpdateProgramSponsors?:  {
    __typename: "ProgramSponsors",
    id: string,
    programID: string,
    sponsorID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    sponsor:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteProgramSponsorsSubscriptionVariables = {
  filter?: ModelSubscriptionProgramSponsorsFilterInput | null,
};

export type OnDeleteProgramSponsorsSubscription = {
  onDeleteProgramSponsors?:  {
    __typename: "ProgramSponsors",
    id: string,
    programID: string,
    sponsorID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    sponsor:  {
      __typename: "Sponsor",
      id: string,
      name?: string | null,
      description?: string | null,
      programs?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkConnection",
        items:  Array< {
          __typename: "Network",
          id: string,
          name: string,
          sponsorId: string,
          acgmeEnabled?: boolean | null,
          allAttendingHistoryDisabled?: boolean | null,
          simpl1Id?: number | null,
          categoriesExcludedFromRequestFlow?: Array< string | null > | null,
          dashboardURL?: string | null,
          showDashboardLink?: boolean | null,
          disableClassicReports?: boolean | null,
          traineeCanRateTrainee?: boolean | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      branding?:  {
        __typename: "SponsorBranding",
        colors?:  {
          __typename: "SponsorColors",
          primary?: string | null,
          secondary?: string | null,
          light?: string | null,
        } | null,
        logos?:  {
          __typename: "SponsorLogos",
          fullMono?: string | null,
          fullColor?: string | null,
          squareMono?: string | null,
          squareColor?: string | null,
          email?: string | null,
        } | null,
      } | null,
      activityLabel?: string | null,
      autoAssignActivities?: Array< string > | null,
      dashboardURL?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateNetworkProgramSubscriptionVariables = {
  filter?: ModelSubscriptionNetworkProgramFilterInput | null,
};

export type OnCreateNetworkProgramSubscription = {
  onCreateNetworkProgram?:  {
    __typename: "NetworkProgram",
    id: string,
    programID: string,
    networkID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateNetworkProgramSubscriptionVariables = {
  filter?: ModelSubscriptionNetworkProgramFilterInput | null,
};

export type OnUpdateNetworkProgramSubscription = {
  onUpdateNetworkProgram?:  {
    __typename: "NetworkProgram",
    id: string,
    programID: string,
    networkID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteNetworkProgramSubscriptionVariables = {
  filter?: ModelSubscriptionNetworkProgramFilterInput | null,
};

export type OnDeleteNetworkProgramSubscription = {
  onDeleteNetworkProgram?:  {
    __typename: "NetworkProgram",
    id: string,
    programID: string,
    networkID: string,
    program:  {
      __typename: "Program",
      id: string,
      name: string,
      description?: string | null,
      institutionId: string,
      institution?:  {
        __typename: "Institution",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramConnection",
          nextToken?: string | null,
        } | null,
        users?:  {
          __typename: "ModelUserConnection",
          nextToken?: string | null,
        } | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programMemberships?:  {
        __typename: "ModelProgramMembershipConnection",
        items:  Array< {
          __typename: "ProgramMembership",
          id: string,
          programRole: ProgramRole,
          traineeType?: TraineeType | null,
          programMemberId: string,
          programId: string,
          startDate?: string | null,
          endDate?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsors?:  {
        __typename: "ModelProgramSponsorsConnection",
        items:  Array< {
          __typename: "ProgramSponsors",
          id: string,
          programID: string,
          sponsorID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      networks?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateNetworkActivitySubscriptionVariables = {
  filter?: ModelSubscriptionNetworkActivityFilterInput | null,
};

export type OnCreateNetworkActivitySubscription = {
  onCreateNetworkActivity?:  {
    __typename: "NetworkActivity",
    id: string,
    networkID: string,
    activityID: string,
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateNetworkActivitySubscriptionVariables = {
  filter?: ModelSubscriptionNetworkActivityFilterInput | null,
};

export type OnUpdateNetworkActivitySubscription = {
  onUpdateNetworkActivity?:  {
    __typename: "NetworkActivity",
    id: string,
    networkID: string,
    activityID: string,
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteNetworkActivitySubscriptionVariables = {
  filter?: ModelSubscriptionNetworkActivityFilterInput | null,
};

export type OnDeleteNetworkActivitySubscription = {
  onDeleteNetworkActivity?:  {
    __typename: "NetworkActivity",
    id: string,
    networkID: string,
    activityID: string,
    network:  {
      __typename: "Network",
      id: string,
      name: string,
      sponsorId: string,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      programs?:  {
        __typename: "ModelNetworkProgramConnection",
        items:  Array< {
          __typename: "NetworkProgram",
          id: string,
          programID: string,
          networkID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeEnabled?: boolean | null,
      allAttendingHistoryDisabled?: boolean | null,
      simpl1Id?: number | null,
      categoriesExcludedFromRequestFlow?: Array< string | null > | null,
      dashboardURL?: string | null,
      showDashboardLink?: boolean | null,
      disableClassicReports?: boolean | null,
      traineeCanRateTrainee?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAssessmentActivitySubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentActivityFilterInput | null,
};

export type OnCreateAssessmentActivitySubscription = {
  onCreateAssessmentActivity?:  {
    __typename: "AssessmentActivity",
    id: string,
    assessmentID: string,
    activityID: string,
    assessment:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAssessmentActivitySubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentActivityFilterInput | null,
};

export type OnUpdateAssessmentActivitySubscription = {
  onUpdateAssessmentActivity?:  {
    __typename: "AssessmentActivity",
    id: string,
    assessmentID: string,
    activityID: string,
    assessment:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAssessmentActivitySubscriptionVariables = {
  filter?: ModelSubscriptionAssessmentActivityFilterInput | null,
};

export type OnDeleteAssessmentActivitySubscription = {
  onDeleteAssessmentActivity?:  {
    __typename: "AssessmentActivity",
    id: string,
    assessmentID: string,
    activityID: string,
    assessment:  {
      __typename: "Assessment",
      id: string,
      title?: string | null,
      description?: string | null,
      instrumentId?: string | null,
      instrument?:  {
        __typename: "Instrument",
        id: string,
        title?: string | null,
        description?: string | null,
        questions?:  {
          __typename: "ModelQuestionConnection",
          nextToken?: string | null,
        } | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        version?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      multiActivities?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      expirationDurationHours?: number | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requireTraineeSelfAssessment?: boolean | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      published?: boolean | null,
      archived?: boolean | null,
      version?: string | null,
      creationDurationHours?: number | null,
      showFeedbackQuestionsToTrainees?: boolean | null,
      sendEmailForSelfAssessment?: boolean | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateActivityEventActivitiesSubscriptionVariables = {
  filter?: ModelSubscriptionActivityEventActivitiesFilterInput | null,
};

export type OnCreateActivityEventActivitiesSubscription = {
  onCreateActivityEventActivities?:  {
    __typename: "ActivityEventActivities",
    id: string,
    activityID: string,
    activityEventID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    activityEvent:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateActivityEventActivitiesSubscriptionVariables = {
  filter?: ModelSubscriptionActivityEventActivitiesFilterInput | null,
};

export type OnUpdateActivityEventActivitiesSubscription = {
  onUpdateActivityEventActivities?:  {
    __typename: "ActivityEventActivities",
    id: string,
    activityID: string,
    activityEventID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    activityEvent:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteActivityEventActivitiesSubscriptionVariables = {
  filter?: ModelSubscriptionActivityEventActivitiesFilterInput | null,
};

export type OnDeleteActivityEventActivitiesSubscription = {
  onDeleteActivityEventActivities?:  {
    __typename: "ActivityEventActivities",
    id: string,
    activityID: string,
    activityEventID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    activityEvent:  {
      __typename: "ActivityEvent",
      id: string,
      creatorId?: string | null,
      creator?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      participants?:  {
        __typename: "ModelActivityParticipantConnection",
        items:  Array< {
          __typename: "ActivityParticipant",
          id: string,
          userId?: string | null,
          activityEventId: string,
          programId?: string | null,
          currentPGY?: number | null,
          currentRole?: ProgramRole | null,
          currentTraineeType?: TraineeType | null,
          currentJobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activities?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      programId?: string | null,
      program?:  {
        __typename: "Program",
        id: string,
        name: string,
        description?: string | null,
        institutionId: string,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        assessmentEvents?:  {
          __typename: "ModelAssessmentEventConnection",
          nextToken?: string | null,
        } | null,
        sponsors?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkProgramConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      activityEventDate?: string | null,
      notes?: string | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnCreateAcgmeProcedureActivitySubscriptionVariables = {
  filter?: ModelSubscriptionAcgmeProcedureActivityFilterInput | null,
};

export type OnCreateAcgmeProcedureActivitySubscription = {
  onCreateAcgmeProcedureActivity?:  {
    __typename: "AcgmeProcedureActivity",
    id: string,
    activityID: string,
    acgmeProcedureID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    acgmeProcedure:  {
      __typename: "AcgmeProcedure",
      id: string,
      name: string,
      acgmeCode: string,
      activities?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnUpdateAcgmeProcedureActivitySubscriptionVariables = {
  filter?: ModelSubscriptionAcgmeProcedureActivityFilterInput | null,
};

export type OnUpdateAcgmeProcedureActivitySubscription = {
  onUpdateAcgmeProcedureActivity?:  {
    __typename: "AcgmeProcedureActivity",
    id: string,
    activityID: string,
    acgmeProcedureID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    acgmeProcedure:  {
      __typename: "AcgmeProcedure",
      id: string,
      name: string,
      acgmeCode: string,
      activities?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type OnDeleteAcgmeProcedureActivitySubscriptionVariables = {
  filter?: ModelSubscriptionAcgmeProcedureActivityFilterInput | null,
};

export type OnDeleteAcgmeProcedureActivitySubscription = {
  onDeleteAcgmeProcedureActivity?:  {
    __typename: "AcgmeProcedureActivity",
    id: string,
    activityID: string,
    acgmeProcedureID: string,
    activity:  {
      __typename: "Activity",
      id: string,
      title?: string | null,
      description?: string | null,
      subActivities?:  {
        __typename: "ModelActivityConnection",
        items:  Array< {
          __typename: "Activity",
          id: string,
          title?: string | null,
          description?: string | null,
          assessmentId?: string | null,
          sponsorId?: string | null,
          authorId?: string | null,
          version?: string | null,
          simpl1Id?: number | null,
          categories?: Array< string > | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
          activitySubActivitiesId?: string | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentId?: string | null,
      assessment?:  {
        __typename: "Assessment",
        id: string,
        title?: string | null,
        description?: string | null,
        instrumentId?: string | null,
        instrument?:  {
          __typename: "Instrument",
          id: string,
          title?: string | null,
          description?: string | null,
          authorId?: string | null,
          version?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        activities?:  {
          __typename: "ModelActivityConnection",
          nextToken?: string | null,
        } | null,
        multiActivities?:  {
          __typename: "ModelAssessmentActivityConnection",
          nextToken?: string | null,
        } | null,
        expirationDurationHours?: number | null,
        sponsorId?: string | null,
        sponsor?:  {
          __typename: "Sponsor",
          id: string,
          name?: string | null,
          description?: string | null,
          activityLabel?: string | null,
          autoAssignActivities?: Array< string > | null,
          dashboardURL?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requireTraineeSelfAssessment?: boolean | null,
        authorId?: string | null,
        author?:  {
          __typename: "User",
          id: string,
          email: string,
          emailLower?: string | null,
          institutionId?: string | null,
          cognitoUsername?: string | null,
          firstName?: string | null,
          lastName?: string | null,
          suffix?: string | null,
          npi?: number | null,
          simplLearnId?: string | null,
          pgy?: number | null,
          lastLogin?: string | null,
          eulaAcceptedDate?: string | null,
          simpl1Id?: number | null,
          deviceToken?: string | null,
          devicePlatform?: DevicePlatform | null,
          inviteId?: string | null,
          jobTitle?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        published?: boolean | null,
        archived?: boolean | null,
        version?: string | null,
        creationDurationHours?: number | null,
        showFeedbackQuestionsToTrainees?: boolean | null,
        sendEmailForSelfAssessment?: boolean | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      assessments?:  {
        __typename: "ModelAssessmentActivityConnection",
        items:  Array< {
          __typename: "AssessmentActivity",
          id: string,
          assessmentID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      activityEvents?:  {
        __typename: "ModelActivityEventActivitiesConnection",
        items:  Array< {
          __typename: "ActivityEventActivities",
          id: string,
          activityID: string,
          activityEventID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      assessmentEvents?:  {
        __typename: "ModelAssessmentEventConnection",
        items:  Array< {
          __typename: "AssessmentEvent",
          id: string,
          subjectId?: string | null,
          subjectUserId?: string | null,
          raterId?: string | null,
          raterUserId?: string | null,
          activityId?: string | null,
          activityEventId?: string | null,
          programId?: string | null,
          assessmentId?: string | null,
          expirationDate?: string | null,
          completionDate?: string | null,
          declined?: ReasonForDecline | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      sponsorId?: string | null,
      sponsor?:  {
        __typename: "Sponsor",
        id: string,
        name?: string | null,
        description?: string | null,
        programs?:  {
          __typename: "ModelProgramSponsorsConnection",
          nextToken?: string | null,
        } | null,
        networks?:  {
          __typename: "ModelNetworkConnection",
          nextToken?: string | null,
        } | null,
        branding?:  {
          __typename: "SponsorBranding",
        } | null,
        activityLabel?: string | null,
        autoAssignActivities?: Array< string > | null,
        dashboardURL?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      authorId?: string | null,
      author?:  {
        __typename: "User",
        id: string,
        email: string,
        emailLower?: string | null,
        institutionId?: string | null,
        institution?:  {
          __typename: "Institution",
          id: string,
          name?: string | null,
          description?: string | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        cognitoUsername?: string | null,
        firstName?: string | null,
        lastName?: string | null,
        suffix?: string | null,
        npi?: number | null,
        simplLearnId?: string | null,
        pgy?: number | null,
        settings?:  {
          __typename: "UserSettings",
          sendEmail?: boolean | null,
          sendPushNotifications?: boolean | null,
        } | null,
        lastLogin?: string | null,
        eulaAcceptedDate?: string | null,
        programMemberships?:  {
          __typename: "ModelProgramMembershipConnection",
          nextToken?: string | null,
        } | null,
        simpl1Id?: number | null,
        deviceToken?: string | null,
        devicePlatform?: DevicePlatform | null,
        inviteId?: string | null,
        invite?:  {
          __typename: "UserInvitation",
          id: string,
          inviteeId?: string | null,
          institutionId: string,
          invitationStatus: InvitationStatus,
          email?: string | null,
          emailLower?: string | null,
          adminId?: string | null,
          programId?: string | null,
          role?: ProgramRole | null,
          deletedAt?: string | null,
          deletedBy?: string | null,
          deletedReason?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        jobTitle?: string | null,
        deletedAt?: string | null,
        deletedBy?: string | null,
        deletedReason?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      version?: string | null,
      networks?:  {
        __typename: "ModelNetworkActivityConnection",
        items:  Array< {
          __typename: "NetworkActivity",
          id: string,
          networkID: string,
          activityID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      acgmeProcedures?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id?: number | null,
      categories?: Array< string > | null,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
      activitySubActivitiesId?: string | null,
    },
    acgmeProcedure:  {
      __typename: "AcgmeProcedure",
      id: string,
      name: string,
      acgmeCode: string,
      activities?:  {
        __typename: "ModelAcgmeProcedureActivityConnection",
        items:  Array< {
          __typename: "AcgmeProcedureActivity",
          id: string,
          activityID: string,
          acgmeProcedureID: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      simpl1Id: number,
      deletedAt?: string | null,
      deletedBy?: string | null,
      deletedReason?: string | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};
